export const ICON_NAMES = [
  'mdiAbTesting',
  'mdiAbacus',
  'mdiAbjadArabic',
  'mdiAbjadHebrew',
  'mdiAbugidaDevanagari',
  'mdiAbugidaThai',
  'mdiAccessPoint',
  'mdiAccessPointCheck',
  'mdiAccessPointMinus',
  'mdiAccessPointNetwork',
  'mdiAccessPointNetworkOff',
  'mdiAccessPointOff',
  'mdiAccessPointPlus',
  'mdiAccessPointRemove',
  'mdiAccount',
  'mdiAccountAlert',
  'mdiAccountAlertOutline',
  'mdiAccountArrowDown',
  'mdiAccountArrowDownOutline',
  'mdiAccountArrowLeft',
  'mdiAccountArrowLeftOutline',
  'mdiAccountArrowRight',
  'mdiAccountArrowRightOutline',
  'mdiAccountArrowUp',
  'mdiAccountArrowUpOutline',
  'mdiAccountBadge',
  'mdiAccountBadgeOutline',
  'mdiAccountBox',
  'mdiAccountBoxEditOutline',
  'mdiAccountBoxMinusOutline',
  'mdiAccountBoxMultiple',
  'mdiAccountBoxMultipleOutline',
  'mdiAccountBoxOutline',
  'mdiAccountBoxPlusOutline',
  'mdiAccountCancel',
  'mdiAccountCancelOutline',
  'mdiAccountCard',
  'mdiAccountCardOutline',
  'mdiAccountCash',
  'mdiAccountCashOutline',
  'mdiAccountCheck',
  'mdiAccountCheckOutline',
  'mdiAccountChild',
  'mdiAccountChildCircle',
  'mdiAccountChildOutline',
  'mdiAccountCircle',
  'mdiAccountCircleOutline',
  'mdiAccountClock',
  'mdiAccountClockOutline',
  'mdiAccountCog',
  'mdiAccountCogOutline',
  'mdiAccountConvert',
  'mdiAccountConvertOutline',
  'mdiAccountCowboyHat',
  'mdiAccountCowboyHatOutline',
  'mdiAccountCreditCard',
  'mdiAccountCreditCardOutline',
  'mdiAccountDetails',
  'mdiAccountDetailsOutline',
  'mdiAccountEdit',
  'mdiAccountEditOutline',
  'mdiAccountEye',
  'mdiAccountEyeOutline',
  'mdiAccountFile',
  'mdiAccountFileOutline',
  'mdiAccountFileText',
  'mdiAccountFileTextOutline',
  'mdiAccountFilter',
  'mdiAccountFilterOutline',
  'mdiAccountGroup',
  'mdiAccountGroupOutline',
  'mdiAccountHardHat',
  'mdiAccountHardHatOutline',
  'mdiAccountHeart',
  'mdiAccountHeartOutline',
  'mdiAccountInjury',
  'mdiAccountInjuryOutline',
  'mdiAccountKey',
  'mdiAccountKeyOutline',
  'mdiAccountLock',
  'mdiAccountLockOpen',
  'mdiAccountLockOpenOutline',
  'mdiAccountLockOutline',
  'mdiAccountMinus',
  'mdiAccountMinusOutline',
  'mdiAccountMultiple',
  'mdiAccountMultipleCheck',
  'mdiAccountMultipleCheckOutline',
  'mdiAccountMultipleMinus',
  'mdiAccountMultipleMinusOutline',
  'mdiAccountMultipleOutline',
  'mdiAccountMultiplePlus',
  'mdiAccountMultiplePlusOutline',
  'mdiAccountMultipleRemove',
  'mdiAccountMultipleRemoveOutline',
  'mdiAccountMusic',
  'mdiAccountMusicOutline',
  'mdiAccountNetwork',
  'mdiAccountNetworkOff',
  'mdiAccountNetworkOffOutline',
  'mdiAccountNetworkOutline',
  'mdiAccountOff',
  'mdiAccountOffOutline',
  'mdiAccountOutline',
  'mdiAccountPlus',
  'mdiAccountPlusOutline',
  'mdiAccountQuestion',
  'mdiAccountQuestionOutline',
  'mdiAccountReactivate',
  'mdiAccountReactivateOutline',
  'mdiAccountRemove',
  'mdiAccountRemoveOutline',
  'mdiAccountSchool',
  'mdiAccountSchoolOutline',
  'mdiAccountSearch',
  'mdiAccountSearchOutline',
  'mdiAccountSettings',
  'mdiAccountSettingsOutline',
  'mdiAccountStar',
  'mdiAccountStarOutline',
  'mdiAccountSupervisor',
  'mdiAccountSupervisorCircle',
  'mdiAccountSupervisorCircleOutline',
  'mdiAccountSupervisorOutline',
  'mdiAccountSwitch',
  'mdiAccountSwitchOutline',
  'mdiAccountSync',
  'mdiAccountSyncOutline',
  'mdiAccountTag',
  'mdiAccountTagOutline',
  'mdiAccountTie',
  'mdiAccountTieHat',
  'mdiAccountTieHatOutline',
  'mdiAccountTieOutline',
  'mdiAccountTieVoice',
  'mdiAccountTieVoiceOff',
  'mdiAccountTieVoiceOffOutline',
  'mdiAccountTieVoiceOutline',
  'mdiAccountTieWoman',
  'mdiAccountVoice',
  'mdiAccountVoiceOff',
  'mdiAccountWrench',
  'mdiAccountWrenchOutline',
  'mdiAdjust',
  'mdiAdvertisements',
  'mdiAdvertisementsOff',
  'mdiAirConditioner',
  'mdiAirFilter',
  'mdiAirHorn',
  'mdiAirHumidifier',
  'mdiAirHumidifierOff',
  'mdiAirPurifier',
  'mdiAirPurifierOff',
  'mdiAirbag',
  'mdiAirballoon',
  'mdiAirballoonOutline',
  'mdiAirplane',
  'mdiAirplaneAlert',
  'mdiAirplaneCheck',
  'mdiAirplaneClock',
  'mdiAirplaneCog',
  'mdiAirplaneEdit',
  'mdiAirplaneLanding',
  'mdiAirplaneMarker',
  'mdiAirplaneMinus',
  'mdiAirplaneOff',
  'mdiAirplanePlus',
  'mdiAirplaneRemove',
  'mdiAirplaneSearch',
  'mdiAirplaneSettings',
  'mdiAirplaneTakeoff',
  'mdiAirport',
  'mdiAlarm',
  'mdiAlarmBell',
  'mdiAlarmCheck',
  'mdiAlarmLight',
  'mdiAlarmLightOff',
  'mdiAlarmLightOffOutline',
  'mdiAlarmLightOutline',
  'mdiAlarmMultiple',
  'mdiAlarmNote',
  'mdiAlarmNoteOff',
  'mdiAlarmOff',
  'mdiAlarmPanel',
  'mdiAlarmPanelOutline',
  'mdiAlarmPlus',
  'mdiAlarmSnooze',
  'mdiAlbum',
  'mdiAlert',
  'mdiAlertBox',
  'mdiAlertBoxOutline',
  'mdiAlertCircle',
  'mdiAlertCircleCheck',
  'mdiAlertCircleCheckOutline',
  'mdiAlertCircleOutline',
  'mdiAlertDecagram',
  'mdiAlertDecagramOutline',
  'mdiAlertMinus',
  'mdiAlertMinusOutline',
  'mdiAlertOctagon',
  'mdiAlertOctagonOutline',
  'mdiAlertOctagram',
  'mdiAlertOctagramOutline',
  'mdiAlertOutline',
  'mdiAlertPlus',
  'mdiAlertPlusOutline',
  'mdiAlertRemove',
  'mdiAlertRemoveOutline',
  'mdiAlertRhombus',
  'mdiAlertRhombusOutline',
  'mdiAlien',
  'mdiAlienOutline',
  'mdiAlignHorizontalCenter',
  'mdiAlignHorizontalDistribute',
  'mdiAlignHorizontalLeft',
  'mdiAlignHorizontalRight',
  'mdiAlignVerticalBottom',
  'mdiAlignVerticalCenter',
  'mdiAlignVerticalDistribute',
  'mdiAlignVerticalTop',
  'mdiAllInclusive',
  'mdiAllInclusiveBox',
  'mdiAllInclusiveBoxOutline',
  'mdiAllergy',
  'mdiAlpha',
  'mdiAlphaA',
  'mdiAlphaABox',
  'mdiAlphaABoxOutline',
  'mdiAlphaACircle',
  'mdiAlphaACircleOutline',
  'mdiAlphaB',
  'mdiAlphaBBox',
  'mdiAlphaBBoxOutline',
  'mdiAlphaBCircle',
  'mdiAlphaBCircleOutline',
  'mdiAlphaC',
  'mdiAlphaCBox',
  'mdiAlphaCBoxOutline',
  'mdiAlphaCCircle',
  'mdiAlphaCCircleOutline',
  'mdiAlphaD',
  'mdiAlphaDBox',
  'mdiAlphaDBoxOutline',
  'mdiAlphaDCircle',
  'mdiAlphaDCircleOutline',
  'mdiAlphaE',
  'mdiAlphaEBox',
  'mdiAlphaEBoxOutline',
  'mdiAlphaECircle',
  'mdiAlphaECircleOutline',
  'mdiAlphaF',
  'mdiAlphaFBox',
  'mdiAlphaFBoxOutline',
  'mdiAlphaFCircle',
  'mdiAlphaFCircleOutline',
  'mdiAlphaG',
  'mdiAlphaGBox',
  'mdiAlphaGBoxOutline',
  'mdiAlphaGCircle',
  'mdiAlphaGCircleOutline',
  'mdiAlphaH',
  'mdiAlphaHBox',
  'mdiAlphaHBoxOutline',
  'mdiAlphaHCircle',
  'mdiAlphaHCircleOutline',
  'mdiAlphaI',
  'mdiAlphaIBox',
  'mdiAlphaIBoxOutline',
  'mdiAlphaICircle',
  'mdiAlphaICircleOutline',
  'mdiAlphaJ',
  'mdiAlphaJBox',
  'mdiAlphaJBoxOutline',
  'mdiAlphaJCircle',
  'mdiAlphaJCircleOutline',
  'mdiAlphaK',
  'mdiAlphaKBox',
  'mdiAlphaKBoxOutline',
  'mdiAlphaKCircle',
  'mdiAlphaKCircleOutline',
  'mdiAlphaL',
  'mdiAlphaLBox',
  'mdiAlphaLBoxOutline',
  'mdiAlphaLCircle',
  'mdiAlphaLCircleOutline',
  'mdiAlphaM',
  'mdiAlphaMBox',
  'mdiAlphaMBoxOutline',
  'mdiAlphaMCircle',
  'mdiAlphaMCircleOutline',
  'mdiAlphaN',
  'mdiAlphaNBox',
  'mdiAlphaNBoxOutline',
  'mdiAlphaNCircle',
  'mdiAlphaNCircleOutline',
  'mdiAlphaO',
  'mdiAlphaOBox',
  'mdiAlphaOBoxOutline',
  'mdiAlphaOCircle',
  'mdiAlphaOCircleOutline',
  'mdiAlphaP',
  'mdiAlphaPBox',
  'mdiAlphaPBoxOutline',
  'mdiAlphaPCircle',
  'mdiAlphaPCircleOutline',
  'mdiAlphaQ',
  'mdiAlphaQBox',
  'mdiAlphaQBoxOutline',
  'mdiAlphaQCircle',
  'mdiAlphaQCircleOutline',
  'mdiAlphaR',
  'mdiAlphaRBox',
  'mdiAlphaRBoxOutline',
  'mdiAlphaRCircle',
  'mdiAlphaRCircleOutline',
  'mdiAlphaS',
  'mdiAlphaSBox',
  'mdiAlphaSBoxOutline',
  'mdiAlphaSCircle',
  'mdiAlphaSCircleOutline',
  'mdiAlphaT',
  'mdiAlphaTBox',
  'mdiAlphaTBoxOutline',
  'mdiAlphaTCircle',
  'mdiAlphaTCircleOutline',
  'mdiAlphaU',
  'mdiAlphaUBox',
  'mdiAlphaUBoxOutline',
  'mdiAlphaUCircle',
  'mdiAlphaUCircleOutline',
  'mdiAlphaV',
  'mdiAlphaVBox',
  'mdiAlphaVBoxOutline',
  'mdiAlphaVCircle',
  'mdiAlphaVCircleOutline',
  'mdiAlphaW',
  'mdiAlphaWBox',
  'mdiAlphaWBoxOutline',
  'mdiAlphaWCircle',
  'mdiAlphaWCircleOutline',
  'mdiAlphaX',
  'mdiAlphaXBox',
  'mdiAlphaXBoxOutline',
  'mdiAlphaXCircle',
  'mdiAlphaXCircleOutline',
  'mdiAlphaY',
  'mdiAlphaYBox',
  'mdiAlphaYBoxOutline',
  'mdiAlphaYCircle',
  'mdiAlphaYCircleOutline',
  'mdiAlphaZ',
  'mdiAlphaZBox',
  'mdiAlphaZBoxOutline',
  'mdiAlphaZCircle',
  'mdiAlphaZCircleOutline',
  'mdiAlphabetAurebesh',
  'mdiAlphabetCyrillic',
  'mdiAlphabetGreek',
  'mdiAlphabetLatin',
  'mdiAlphabetPiqad',
  'mdiAlphabetTengwar',
  'mdiAlphabetical',
  'mdiAlphabeticalOff',
  'mdiAlphabeticalVariant',
  'mdiAlphabeticalVariantOff',
  'mdiAltimeter',
  'mdiAmbulance',
  'mdiAmmunition',
  'mdiAmpersand',
  'mdiAmplifier',
  'mdiAmplifierOff',
  'mdiAnchor',
  'mdiAndroid',
  'mdiAndroidStudio',
  'mdiAngleAcute',
  'mdiAngleObtuse',
  'mdiAngleRight',
  'mdiAngular',
  'mdiAngularjs',
  'mdiAnimation',
  'mdiAnimationOutline',
  'mdiAnimationPlay',
  'mdiAnimationPlayOutline',
  'mdiAnsible',
  'mdiAntenna',
  'mdiAnvil',
  'mdiApacheKafka',
  'mdiApi',
  'mdiApiOff',
  'mdiApple',
  'mdiAppleFinder',
  'mdiAppleIcloud',
  'mdiAppleIos',
  'mdiAppleKeyboardCaps',
  'mdiAppleKeyboardCommand',
  'mdiAppleKeyboardControl',
  'mdiAppleKeyboardOption',
  'mdiAppleKeyboardShift',
  'mdiAppleSafari',
  'mdiApplication',
  'mdiApplicationArray',
  'mdiApplicationArrayOutline',
  'mdiApplicationBraces',
  'mdiApplicationBracesOutline',
  'mdiApplicationBrackets',
  'mdiApplicationBracketsOutline',
  'mdiApplicationCog',
  'mdiApplicationCogOutline',
  'mdiApplicationEdit',
  'mdiApplicationEditOutline',
  'mdiApplicationExport',
  'mdiApplicationImport',
  'mdiApplicationOutline',
  'mdiApplicationParentheses',
  'mdiApplicationParenthesesOutline',
  'mdiApplicationSettings',
  'mdiApplicationSettingsOutline',
  'mdiApplicationVariable',
  'mdiApplicationVariableOutline',
  'mdiApproximatelyEqual',
  'mdiApproximatelyEqualBox',
  'mdiApps',
  'mdiAppsBox',
  'mdiArch',
  'mdiArchive',
  'mdiArchiveAlert',
  'mdiArchiveAlertOutline',
  'mdiArchiveArrowDown',
  'mdiArchiveArrowDownOutline',
  'mdiArchiveArrowUp',
  'mdiArchiveArrowUpOutline',
  'mdiArchiveCancel',
  'mdiArchiveCancelOutline',
  'mdiArchiveCheck',
  'mdiArchiveCheckOutline',
  'mdiArchiveClock',
  'mdiArchiveClockOutline',
  'mdiArchiveCog',
  'mdiArchiveCogOutline',
  'mdiArchiveEdit',
  'mdiArchiveEditOutline',
  'mdiArchiveEye',
  'mdiArchiveEyeOutline',
  'mdiArchiveLock',
  'mdiArchiveLockOpen',
  'mdiArchiveLockOpenOutline',
  'mdiArchiveLockOutline',
  'mdiArchiveMarker',
  'mdiArchiveMarkerOutline',
  'mdiArchiveMinus',
  'mdiArchiveMinusOutline',
  'mdiArchiveMusic',
  'mdiArchiveMusicOutline',
  'mdiArchiveOff',
  'mdiArchiveOffOutline',
  'mdiArchiveOutline',
  'mdiArchivePlus',
  'mdiArchivePlusOutline',
  'mdiArchiveRefresh',
  'mdiArchiveRefreshOutline',
  'mdiArchiveRemove',
  'mdiArchiveRemoveOutline',
  'mdiArchiveSearch',
  'mdiArchiveSearchOutline',
  'mdiArchiveSettings',
  'mdiArchiveSettingsOutline',
  'mdiArchiveStar',
  'mdiArchiveStarOutline',
  'mdiArchiveSync',
  'mdiArchiveSyncOutline',
  'mdiArmFlex',
  'mdiArmFlexOutline',
  'mdiArrangeBringForward',
  'mdiArrangeBringToFront',
  'mdiArrangeSendBackward',
  'mdiArrangeSendToBack',
  'mdiArrowAll',
  'mdiArrowBottomLeft',
  'mdiArrowBottomLeftBoldBox',
  'mdiArrowBottomLeftBoldBoxOutline',
  'mdiArrowBottomLeftBoldOutline',
  'mdiArrowBottomLeftThick',
  'mdiArrowBottomLeftThin',
  'mdiArrowBottomLeftThinCircleOutline',
  'mdiArrowBottomRight',
  'mdiArrowBottomRightBoldBox',
  'mdiArrowBottomRightBoldBoxOutline',
  'mdiArrowBottomRightBoldOutline',
  'mdiArrowBottomRightThick',
  'mdiArrowBottomRightThin',
  'mdiArrowBottomRightThinCircleOutline',
  'mdiArrowCollapse',
  'mdiArrowCollapseAll',
  'mdiArrowCollapseDown',
  'mdiArrowCollapseHorizontal',
  'mdiArrowCollapseLeft',
  'mdiArrowCollapseRight',
  'mdiArrowCollapseUp',
  'mdiArrowCollapseVertical',
  'mdiArrowDecision',
  'mdiArrowDecisionAuto',
  'mdiArrowDecisionAutoOutline',
  'mdiArrowDecisionOutline',
  'mdiArrowDown',
  'mdiArrowDownBold',
  'mdiArrowDownBoldBox',
  'mdiArrowDownBoldBoxOutline',
  'mdiArrowDownBoldCircle',
  'mdiArrowDownBoldCircleOutline',
  'mdiArrowDownBoldHexagonOutline',
  'mdiArrowDownBoldOutline',
  'mdiArrowDownBox',
  'mdiArrowDownCircle',
  'mdiArrowDownCircleOutline',
  'mdiArrowDownDropCircle',
  'mdiArrowDownDropCircleOutline',
  'mdiArrowDownLeft',
  'mdiArrowDownLeftBold',
  'mdiArrowDownRight',
  'mdiArrowDownRightBold',
  'mdiArrowDownThick',
  'mdiArrowDownThin',
  'mdiArrowDownThinCircleOutline',
  'mdiArrowExpand',
  'mdiArrowExpandAll',
  'mdiArrowExpandDown',
  'mdiArrowExpandHorizontal',
  'mdiArrowExpandLeft',
  'mdiArrowExpandRight',
  'mdiArrowExpandUp',
  'mdiArrowExpandVertical',
  'mdiArrowHorizontalLock',
  'mdiArrowLeft',
  'mdiArrowLeftBold',
  'mdiArrowLeftBoldBox',
  'mdiArrowLeftBoldBoxOutline',
  'mdiArrowLeftBoldCircle',
  'mdiArrowLeftBoldCircleOutline',
  'mdiArrowLeftBoldHexagonOutline',
  'mdiArrowLeftBoldOutline',
  'mdiArrowLeftBottom',
  'mdiArrowLeftBottomBold',
  'mdiArrowLeftBox',
  'mdiArrowLeftCircle',
  'mdiArrowLeftCircleOutline',
  'mdiArrowLeftDropCircle',
  'mdiArrowLeftDropCircleOutline',
  'mdiArrowLeftRight',
  'mdiArrowLeftRightBold',
  'mdiArrowLeftRightBoldOutline',
  'mdiArrowLeftThick',
  'mdiArrowLeftThin',
  'mdiArrowLeftThinCircleOutline',
  'mdiArrowLeftTop',
  'mdiArrowLeftTopBold',
  'mdiArrowOscillating',
  'mdiArrowOscillatingOff',
  'mdiArrowProjectile',
  'mdiArrowProjectileMultiple',
  'mdiArrowRight',
  'mdiArrowRightBold',
  'mdiArrowRightBoldBox',
  'mdiArrowRightBoldBoxOutline',
  'mdiArrowRightBoldCircle',
  'mdiArrowRightBoldCircleOutline',
  'mdiArrowRightBoldHexagonOutline',
  'mdiArrowRightBoldOutline',
  'mdiArrowRightBottom',
  'mdiArrowRightBottomBold',
  'mdiArrowRightBox',
  'mdiArrowRightCircle',
  'mdiArrowRightCircleOutline',
  'mdiArrowRightDropCircle',
  'mdiArrowRightDropCircleOutline',
  'mdiArrowRightThick',
  'mdiArrowRightThin',
  'mdiArrowRightThinCircleOutline',
  'mdiArrowRightTop',
  'mdiArrowRightTopBold',
  'mdiArrowSplitHorizontal',
  'mdiArrowSplitVertical',
  'mdiArrowTopLeft',
  'mdiArrowTopLeftBoldBox',
  'mdiArrowTopLeftBoldBoxOutline',
  'mdiArrowTopLeftBoldOutline',
  'mdiArrowTopLeftBottomRight',
  'mdiArrowTopLeftBottomRightBold',
  'mdiArrowTopLeftThick',
  'mdiArrowTopLeftThin',
  'mdiArrowTopLeftThinCircleOutline',
  'mdiArrowTopRight',
  'mdiArrowTopRightBoldBox',
  'mdiArrowTopRightBoldBoxOutline',
  'mdiArrowTopRightBoldOutline',
  'mdiArrowTopRightBottomLeft',
  'mdiArrowTopRightBottomLeftBold',
  'mdiArrowTopRightThick',
  'mdiArrowTopRightThin',
  'mdiArrowTopRightThinCircleOutline',
  'mdiArrowUDownLeft',
  'mdiArrowUDownLeftBold',
  'mdiArrowUDownRight',
  'mdiArrowUDownRightBold',
  'mdiArrowULeftBottom',
  'mdiArrowULeftBottomBold',
  'mdiArrowULeftTop',
  'mdiArrowULeftTopBold',
  'mdiArrowURightBottom',
  'mdiArrowURightBottomBold',
  'mdiArrowURightTop',
  'mdiArrowURightTopBold',
  'mdiArrowUUpLeft',
  'mdiArrowUUpLeftBold',
  'mdiArrowUUpRight',
  'mdiArrowUUpRightBold',
  'mdiArrowUp',
  'mdiArrowUpBold',
  'mdiArrowUpBoldBox',
  'mdiArrowUpBoldBoxOutline',
  'mdiArrowUpBoldCircle',
  'mdiArrowUpBoldCircleOutline',
  'mdiArrowUpBoldHexagonOutline',
  'mdiArrowUpBoldOutline',
  'mdiArrowUpBox',
  'mdiArrowUpCircle',
  'mdiArrowUpCircleOutline',
  'mdiArrowUpDown',
  'mdiArrowUpDownBold',
  'mdiArrowUpDownBoldOutline',
  'mdiArrowUpDropCircle',
  'mdiArrowUpDropCircleOutline',
  'mdiArrowUpLeft',
  'mdiArrowUpLeftBold',
  'mdiArrowUpRight',
  'mdiArrowUpRightBold',
  'mdiArrowUpThick',
  'mdiArrowUpThin',
  'mdiArrowUpThinCircleOutline',
  'mdiArrowVerticalLock',
  'mdiArtboard',
  'mdiArtstation',
  'mdiAspectRatio',
  'mdiAssistant',
  'mdiAsterisk',
  'mdiAsteriskCircleOutline',
  'mdiAt',
  'mdiAtlassian',
  'mdiAtm',
  'mdiAtom',
  'mdiAtomVariant',
  'mdiAttachment',
  'mdiAttachmentCheck',
  'mdiAttachmentLock',
  'mdiAttachmentMinus',
  'mdiAttachmentOff',
  'mdiAttachmentPlus',
  'mdiAttachmentRemove',
  'mdiAtv',
  'mdiAudioInputRca',
  'mdiAudioInputStereoMinijack',
  'mdiAudioInputXlr',
  'mdiAudioVideo',
  'mdiAudioVideoOff',
  'mdiAugmentedReality',
  'mdiAurora',
  'mdiAutoDownload',
  'mdiAutoFix',
  'mdiAutoMode',
  'mdiAutoUpload',
  'mdiAutorenew',
  'mdiAutorenewOff',
  'mdiAvTimer',
  'mdiAwning',
  'mdiAwningOutline',
  'mdiAws',
  'mdiAxe',
  'mdiAxeBattle',
  'mdiAxis',
  'mdiAxisArrow',
  'mdiAxisArrowInfo',
  'mdiAxisArrowLock',
  'mdiAxisLock',
  'mdiAxisXArrow',
  'mdiAxisXArrowLock',
  'mdiAxisXRotateClockwise',
  'mdiAxisXRotateCounterclockwise',
  'mdiAxisXYArrowLock',
  'mdiAxisYArrow',
  'mdiAxisYArrowLock',
  'mdiAxisYRotateClockwise',
  'mdiAxisYRotateCounterclockwise',
  'mdiAxisZArrow',
  'mdiAxisZArrowLock',
  'mdiAxisZRotateClockwise',
  'mdiAxisZRotateCounterclockwise',
  'mdiBabel',
  'mdiBaby',
  'mdiBabyBottle',
  'mdiBabyBottleOutline',
  'mdiBabyBuggy',
  'mdiBabyBuggyOff',
  'mdiBabyCarriage',
  'mdiBabyCarriageOff',
  'mdiBabyFace',
  'mdiBabyFaceOutline',
  'mdiBackburger',
  'mdiBackspace',
  'mdiBackspaceOutline',
  'mdiBackspaceReverse',
  'mdiBackspaceReverseOutline',
  'mdiBackupRestore',
  'mdiBacteria',
  'mdiBacteriaOutline',
  'mdiBadgeAccount',
  'mdiBadgeAccountAlert',
  'mdiBadgeAccountAlertOutline',
  'mdiBadgeAccountHorizontal',
  'mdiBadgeAccountHorizontalOutline',
  'mdiBadgeAccountOutline',
  'mdiBadminton',
  'mdiBagCarryOn',
  'mdiBagCarryOnCheck',
  'mdiBagCarryOnOff',
  'mdiBagChecked',
  'mdiBagPersonal',
  'mdiBagPersonalOff',
  'mdiBagPersonalOffOutline',
  'mdiBagPersonalOutline',
  'mdiBagPersonalPlus',
  'mdiBagPersonalPlusOutline',
  'mdiBagPersonalTag',
  'mdiBagPersonalTagOutline',
  'mdiBagSuitcase',
  'mdiBagSuitcaseOff',
  'mdiBagSuitcaseOffOutline',
  'mdiBagSuitcaseOutline',
  'mdiBaguette',
  'mdiBalcony',
  'mdiBalloon',
  'mdiBallot',
  'mdiBallotOutline',
  'mdiBallotRecount',
  'mdiBallotRecountOutline',
  'mdiBandage',
  'mdiBank',
  'mdiBankCheck',
  'mdiBankCircle',
  'mdiBankCircleOutline',
  'mdiBankMinus',
  'mdiBankOff',
  'mdiBankOffOutline',
  'mdiBankOutline',
  'mdiBankPlus',
  'mdiBankRemove',
  'mdiBankTransfer',
  'mdiBankTransferIn',
  'mdiBankTransferOut',
  'mdiBarcode',
  'mdiBarcodeOff',
  'mdiBarcodeScan',
  'mdiBarley',
  'mdiBarleyOff',
  'mdiBarn',
  'mdiBarrel',
  'mdiBarrelOutline',
  'mdiBaseball',
  'mdiBaseballBat',
  'mdiBaseballDiamond',
  'mdiBaseballDiamondOutline',
  'mdiBaseballOutline',
  'mdiBash',
  'mdiBasket',
  'mdiBasketCheck',
  'mdiBasketCheckOutline',
  'mdiBasketFill',
  'mdiBasketMinus',
  'mdiBasketMinusOutline',
  'mdiBasketOff',
  'mdiBasketOffOutline',
  'mdiBasketOutline',
  'mdiBasketPlus',
  'mdiBasketPlusOutline',
  'mdiBasketRemove',
  'mdiBasketRemoveOutline',
  'mdiBasketUnfill',
  'mdiBasketball',
  'mdiBasketballHoop',
  'mdiBasketballHoopOutline',
  'mdiBat',
  'mdiBathtub',
  'mdiBathtubOutline',
  'mdiBattery',
  'mdiBattery10',
  'mdiBattery10Bluetooth',
  'mdiBattery20',
  'mdiBattery20Bluetooth',
  'mdiBattery30',
  'mdiBattery30Bluetooth',
  'mdiBattery40',
  'mdiBattery40Bluetooth',
  'mdiBattery50',
  'mdiBattery50Bluetooth',
  'mdiBattery60',
  'mdiBattery60Bluetooth',
  'mdiBattery70',
  'mdiBattery70Bluetooth',
  'mdiBattery80',
  'mdiBattery80Bluetooth',
  'mdiBattery90',
  'mdiBattery90Bluetooth',
  'mdiBatteryAlert',
  'mdiBatteryAlertBluetooth',
  'mdiBatteryAlertVariant',
  'mdiBatteryAlertVariantOutline',
  'mdiBatteryArrowDown',
  'mdiBatteryArrowDownOutline',
  'mdiBatteryArrowUp',
  'mdiBatteryArrowUpOutline',
  'mdiBatteryBluetooth',
  'mdiBatteryBluetoothVariant',
  'mdiBatteryCharging',
  'mdiBatteryCharging10',
  'mdiBatteryCharging100',
  'mdiBatteryCharging20',
  'mdiBatteryCharging30',
  'mdiBatteryCharging40',
  'mdiBatteryCharging50',
  'mdiBatteryCharging60',
  'mdiBatteryCharging70',
  'mdiBatteryCharging80',
  'mdiBatteryCharging90',
  'mdiBatteryChargingHigh',
  'mdiBatteryChargingLow',
  'mdiBatteryChargingMedium',
  'mdiBatteryChargingOutline',
  'mdiBatteryChargingWireless',
  'mdiBatteryChargingWireless10',
  'mdiBatteryChargingWireless20',
  'mdiBatteryChargingWireless30',
  'mdiBatteryChargingWireless40',
  'mdiBatteryChargingWireless50',
  'mdiBatteryChargingWireless60',
  'mdiBatteryChargingWireless70',
  'mdiBatteryChargingWireless80',
  'mdiBatteryChargingWireless90',
  'mdiBatteryChargingWirelessAlert',
  'mdiBatteryChargingWirelessOutline',
  'mdiBatteryCheck',
  'mdiBatteryCheckOutline',
  'mdiBatteryClock',
  'mdiBatteryClockOutline',
  'mdiBatteryHeart',
  'mdiBatteryHeartOutline',
  'mdiBatteryHeartVariant',
  'mdiBatteryHigh',
  'mdiBatteryLock',
  'mdiBatteryLockOpen',
  'mdiBatteryLow',
  'mdiBatteryMedium',
  'mdiBatteryMinus',
  'mdiBatteryMinusOutline',
  'mdiBatteryMinusVariant',
  'mdiBatteryNegative',
  'mdiBatteryOff',
  'mdiBatteryOffOutline',
  'mdiBatteryOutline',
  'mdiBatteryPlus',
  'mdiBatteryPlusOutline',
  'mdiBatteryPlusVariant',
  'mdiBatteryPositive',
  'mdiBatteryRemove',
  'mdiBatteryRemoveOutline',
  'mdiBatterySync',
  'mdiBatterySyncOutline',
  'mdiBatteryUnknown',
  'mdiBatteryUnknownBluetooth',
  'mdiBeach',
  'mdiBeaker',
  'mdiBeakerAlert',
  'mdiBeakerAlertOutline',
  'mdiBeakerCheck',
  'mdiBeakerCheckOutline',
  'mdiBeakerMinus',
  'mdiBeakerMinusOutline',
  'mdiBeakerOutline',
  'mdiBeakerPlus',
  'mdiBeakerPlusOutline',
  'mdiBeakerQuestion',
  'mdiBeakerQuestionOutline',
  'mdiBeakerRemove',
  'mdiBeakerRemoveOutline',
  'mdiBed',
  'mdiBedClock',
  'mdiBedDouble',
  'mdiBedDoubleOutline',
  'mdiBedEmpty',
  'mdiBedKing',
  'mdiBedKingOutline',
  'mdiBedOutline',
  'mdiBedQueen',
  'mdiBedQueenOutline',
  'mdiBedSingle',
  'mdiBedSingleOutline',
  'mdiBee',
  'mdiBeeFlower',
  'mdiBeehiveOffOutline',
  'mdiBeehiveOutline',
  'mdiBeekeeper',
  'mdiBeer',
  'mdiBeerOutline',
  'mdiBell',
  'mdiBellAlert',
  'mdiBellAlertOutline',
  'mdiBellBadge',
  'mdiBellBadgeOutline',
  'mdiBellCancel',
  'mdiBellCancelOutline',
  'mdiBellCheck',
  'mdiBellCheckOutline',
  'mdiBellCircle',
  'mdiBellCircleOutline',
  'mdiBellCog',
  'mdiBellCogOutline',
  'mdiBellMinus',
  'mdiBellMinusOutline',
  'mdiBellOff',
  'mdiBellOffOutline',
  'mdiBellOutline',
  'mdiBellPlus',
  'mdiBellPlusOutline',
  'mdiBellRemove',
  'mdiBellRemoveOutline',
  'mdiBellRing',
  'mdiBellRingOutline',
  'mdiBellSleep',
  'mdiBellSleepOutline',
  'mdiBench',
  'mdiBenchBack',
  'mdiBeta',
  'mdiBetamax',
  'mdiBiathlon',
  'mdiBicycle',
  'mdiBicycleBasket',
  'mdiBicycleCargo',
  'mdiBicycleElectric',
  'mdiBicyclePennyFarthing',
  'mdiBike',
  'mdiBikeFast',
  'mdiBikePedal',
  'mdiBikePedalClipless',
  'mdiBikePedalMountain',
  'mdiBillboard',
  'mdiBilliards',
  'mdiBilliardsRack',
  'mdiBinoculars',
  'mdiBio',
  'mdiBiohazard',
  'mdiBird',
  'mdiBitbucket',
  'mdiBitcoin',
  'mdiBlackMesa',
  'mdiBlender',
  'mdiBlenderOutline',
  'mdiBlenderSoftware',
  'mdiBlinds',
  'mdiBlindsHorizontal',
  'mdiBlindsHorizontalClosed',
  'mdiBlindsOpen',
  'mdiBlindsVertical',
  'mdiBlindsVerticalClosed',
  'mdiBlockHelper',
  'mdiBloodBag',
  'mdiBluetooth',
  'mdiBluetoothAudio',
  'mdiBluetoothConnect',
  'mdiBluetoothOff',
  'mdiBluetoothSettings',
  'mdiBluetoothTransfer',
  'mdiBlur',
  'mdiBlurLinear',
  'mdiBlurOff',
  'mdiBlurRadial',
  'mdiBolt',
  'mdiBomb',
  'mdiBombOff',
  'mdiBone',
  'mdiBoneOff',
  'mdiBook',
  'mdiBookAccount',
  'mdiBookAccountOutline',
  'mdiBookAlert',
  'mdiBookAlertOutline',
  'mdiBookAlphabet',
  'mdiBookArrowDown',
  'mdiBookArrowDownOutline',
  'mdiBookArrowLeft',
  'mdiBookArrowLeftOutline',
  'mdiBookArrowRight',
  'mdiBookArrowRightOutline',
  'mdiBookArrowUp',
  'mdiBookArrowUpOutline',
  'mdiBookCancel',
  'mdiBookCancelOutline',
  'mdiBookCheck',
  'mdiBookCheckOutline',
  'mdiBookClock',
  'mdiBookClockOutline',
  'mdiBookCog',
  'mdiBookCogOutline',
  'mdiBookCross',
  'mdiBookEdit',
  'mdiBookEditOutline',
  'mdiBookEducation',
  'mdiBookEducationOutline',
  'mdiBookHeart',
  'mdiBookHeartOutline',
  'mdiBookInformationVariant',
  'mdiBookLock',
  'mdiBookLockOpen',
  'mdiBookLockOpenOutline',
  'mdiBookLockOutline',
  'mdiBookMarker',
  'mdiBookMarkerOutline',
  'mdiBookMinus',
  'mdiBookMinusMultiple',
  'mdiBookMinusMultipleOutline',
  'mdiBookMinusOutline',
  'mdiBookMultiple',
  'mdiBookMultipleOutline',
  'mdiBookMusic',
  'mdiBookMusicOutline',
  'mdiBookOff',
  'mdiBookOffOutline',
  'mdiBookOpen',
  'mdiBookOpenBlankVariant',
  'mdiBookOpenBlankVariantOutline',
  'mdiBookOpenOutline',
  'mdiBookOpenPageVariant',
  'mdiBookOpenPageVariantOutline',
  'mdiBookOpenVariant',
  'mdiBookOpenVariantOutline',
  'mdiBookOutline',
  'mdiBookPlay',
  'mdiBookPlayOutline',
  'mdiBookPlus',
  'mdiBookPlusMultiple',
  'mdiBookPlusMultipleOutline',
  'mdiBookPlusOutline',
  'mdiBookRefresh',
  'mdiBookRefreshOutline',
  'mdiBookRemove',
  'mdiBookRemoveMultiple',
  'mdiBookRemoveMultipleOutline',
  'mdiBookRemoveOutline',
  'mdiBookSearch',
  'mdiBookSearchOutline',
  'mdiBookSettings',
  'mdiBookSettingsOutline',
  'mdiBookSync',
  'mdiBookSyncOutline',
  'mdiBookVariant',
  'mdiBookmark',
  'mdiBookmarkBox',
  'mdiBookmarkBoxMultiple',
  'mdiBookmarkBoxMultipleOutline',
  'mdiBookmarkBoxOutline',
  'mdiBookmarkCheck',
  'mdiBookmarkCheckOutline',
  'mdiBookmarkMinus',
  'mdiBookmarkMinusOutline',
  'mdiBookmarkMultiple',
  'mdiBookmarkMultipleOutline',
  'mdiBookmarkMusic',
  'mdiBookmarkMusicOutline',
  'mdiBookmarkOff',
  'mdiBookmarkOffOutline',
  'mdiBookmarkOutline',
  'mdiBookmarkPlus',
  'mdiBookmarkPlusOutline',
  'mdiBookmarkRemove',
  'mdiBookmarkRemoveOutline',
  'mdiBookshelf',
  'mdiBoomGate',
  'mdiBoomGateAlert',
  'mdiBoomGateAlertOutline',
  'mdiBoomGateArrowDown',
  'mdiBoomGateArrowDownOutline',
  'mdiBoomGateArrowUp',
  'mdiBoomGateArrowUpOutline',
  'mdiBoomGateOutline',
  'mdiBoomGateUp',
  'mdiBoomGateUpOutline',
  'mdiBoombox',
  'mdiBoomerang',
  'mdiBootstrap',
  'mdiBorderAll',
  'mdiBorderAllVariant',
  'mdiBorderBottom',
  'mdiBorderBottomVariant',
  'mdiBorderColor',
  'mdiBorderHorizontal',
  'mdiBorderInside',
  'mdiBorderLeft',
  'mdiBorderLeftVariant',
  'mdiBorderNone',
  'mdiBorderNoneVariant',
  'mdiBorderOutside',
  'mdiBorderRadius',
  'mdiBorderRight',
  'mdiBorderRightVariant',
  'mdiBorderStyle',
  'mdiBorderTop',
  'mdiBorderTopVariant',
  'mdiBorderVertical',
  'mdiBottleSoda',
  'mdiBottleSodaClassic',
  'mdiBottleSodaClassicOutline',
  'mdiBottleSodaOutline',
  'mdiBottleTonic',
  'mdiBottleTonicOutline',
  'mdiBottleTonicPlus',
  'mdiBottleTonicPlusOutline',
  'mdiBottleTonicSkull',
  'mdiBottleTonicSkullOutline',
  'mdiBottleWine',
  'mdiBottleWineOutline',
  'mdiBowArrow',
  'mdiBowTie',
  'mdiBowl',
  'mdiBowlMix',
  'mdiBowlMixOutline',
  'mdiBowlOutline',
  'mdiBowling',
  'mdiBox',
  'mdiBoxCutter',
  'mdiBoxCutterOff',
  'mdiBoxShadow',
  'mdiBoxingGlove',
  'mdiBraille',
  'mdiBrain',
  'mdiBreadSlice',
  'mdiBreadSliceOutline',
  'mdiBridge',
  'mdiBriefcase',
  'mdiBriefcaseAccount',
  'mdiBriefcaseAccountOutline',
  'mdiBriefcaseArrowLeftRight',
  'mdiBriefcaseArrowLeftRightOutline',
  'mdiBriefcaseArrowUpDown',
  'mdiBriefcaseArrowUpDownOutline',
  'mdiBriefcaseCheck',
  'mdiBriefcaseCheckOutline',
  'mdiBriefcaseClock',
  'mdiBriefcaseClockOutline',
  'mdiBriefcaseDownload',
  'mdiBriefcaseDownloadOutline',
  'mdiBriefcaseEdit',
  'mdiBriefcaseEditOutline',
  'mdiBriefcaseEye',
  'mdiBriefcaseEyeOutline',
  'mdiBriefcaseMinus',
  'mdiBriefcaseMinusOutline',
  'mdiBriefcaseOff',
  'mdiBriefcaseOffOutline',
  'mdiBriefcaseOutline',
  'mdiBriefcasePlus',
  'mdiBriefcasePlusOutline',
  'mdiBriefcaseRemove',
  'mdiBriefcaseRemoveOutline',
  'mdiBriefcaseSearch',
  'mdiBriefcaseSearchOutline',
  'mdiBriefcaseUpload',
  'mdiBriefcaseUploadOutline',
  'mdiBriefcaseVariant',
  'mdiBriefcaseVariantOff',
  'mdiBriefcaseVariantOffOutline',
  'mdiBriefcaseVariantOutline',
  'mdiBrightness1',
  'mdiBrightness2',
  'mdiBrightness3',
  'mdiBrightness4',
  'mdiBrightness5',
  'mdiBrightness6',
  'mdiBrightness7',
  'mdiBrightnessAuto',
  'mdiBrightnessPercent',
  'mdiBroadcast',
  'mdiBroadcastOff',
  'mdiBroom',
  'mdiBrush',
  'mdiBrushOff',
  'mdiBrushOutline',
  'mdiBrushVariant',
  'mdiBucket',
  'mdiBucketOutline',
  'mdiBuffet',
  'mdiBug',
  'mdiBugCheck',
  'mdiBugCheckOutline',
  'mdiBugOutline',
  'mdiBugPause',
  'mdiBugPauseOutline',
  'mdiBugPlay',
  'mdiBugPlayOutline',
  'mdiBugStop',
  'mdiBugStopOutline',
  'mdiBugle',
  'mdiBulkheadLight',
  'mdiBulldozer',
  'mdiBullet',
  'mdiBulletinBoard',
  'mdiBullhorn',
  'mdiBullhornOutline',
  'mdiBullhornVariant',
  'mdiBullhornVariantOutline',
  'mdiBullseye',
  'mdiBullseyeArrow',
  'mdiBulma',
  'mdiBunkBed',
  'mdiBunkBedOutline',
  'mdiBus',
  'mdiBusAlert',
  'mdiBusArticulatedEnd',
  'mdiBusArticulatedFront',
  'mdiBusClock',
  'mdiBusDoubleDecker',
  'mdiBusElectric',
  'mdiBusMarker',
  'mdiBusMultiple',
  'mdiBusSchool',
  'mdiBusSide',
  'mdiBusSign',
  'mdiBusStop',
  'mdiBusStopCovered',
  'mdiBusStopUncovered',
  'mdiBusWrench',
  'mdiButterfly',
  'mdiButterflyOutline',
  'mdiButtonCursor',
  'mdiButtonPointer',
  'mdiCabinAFrame',
  'mdiCableData',
  'mdiCached',
  'mdiCactus',
  'mdiCake',
  'mdiCakeLayered',
  'mdiCakeVariant',
  'mdiCakeVariantOutline',
  'mdiCalculator',
  'mdiCalculatorVariant',
  'mdiCalculatorVariantOutline',
  'mdiCalendar',
  'mdiCalendarAccount',
  'mdiCalendarAccountOutline',
  'mdiCalendarAlert',
  'mdiCalendarAlertOutline',
  'mdiCalendarArrowLeft',
  'mdiCalendarArrowRight',
  'mdiCalendarBadge',
  'mdiCalendarBadgeOutline',
  'mdiCalendarBlank',
  'mdiCalendarBlankMultiple',
  'mdiCalendarBlankOutline',
  'mdiCalendarCheck',
  'mdiCalendarCheckOutline',
  'mdiCalendarClock',
  'mdiCalendarClockOutline',
  'mdiCalendarCollapseHorizontal',
  'mdiCalendarCollapseHorizontalOutline',
  'mdiCalendarCursor',
  'mdiCalendarCursorOutline',
  'mdiCalendarEdit',
  'mdiCalendarEditOutline',
  'mdiCalendarEnd',
  'mdiCalendarEndOutline',
  'mdiCalendarExpandHorizontal',
  'mdiCalendarExpandHorizontalOutline',
  'mdiCalendarExport',
  'mdiCalendarExportOutline',
  'mdiCalendarFilter',
  'mdiCalendarFilterOutline',
  'mdiCalendarHeart',
  'mdiCalendarHeartOutline',
  'mdiCalendarImport',
  'mdiCalendarImportOutline',
  'mdiCalendarLock',
  'mdiCalendarLockOpen',
  'mdiCalendarLockOpenOutline',
  'mdiCalendarLockOutline',
  'mdiCalendarMinus',
  'mdiCalendarMinusOutline',
  'mdiCalendarMonth',
  'mdiCalendarMonthOutline',
  'mdiCalendarMultiple',
  'mdiCalendarMultipleCheck',
  'mdiCalendarMultiselect',
  'mdiCalendarMultiselectOutline',
  'mdiCalendarOutline',
  'mdiCalendarPlus',
  'mdiCalendarPlusOutline',
  'mdiCalendarQuestion',
  'mdiCalendarQuestionOutline',
  'mdiCalendarRange',
  'mdiCalendarRangeOutline',
  'mdiCalendarRefresh',
  'mdiCalendarRefreshOutline',
  'mdiCalendarRemove',
  'mdiCalendarRemoveOutline',
  'mdiCalendarSearch',
  'mdiCalendarSearchOutline',
  'mdiCalendarStar',
  'mdiCalendarStarFourPoints',
  'mdiCalendarStarOutline',
  'mdiCalendarStart',
  'mdiCalendarStartOutline',
  'mdiCalendarSync',
  'mdiCalendarSyncOutline',
  'mdiCalendarText',
  'mdiCalendarTextOutline',
  'mdiCalendarToday',
  'mdiCalendarTodayOutline',
  'mdiCalendarWeek',
  'mdiCalendarWeekBegin',
  'mdiCalendarWeekBeginOutline',
  'mdiCalendarWeekOutline',
  'mdiCalendarWeekend',
  'mdiCalendarWeekendOutline',
  'mdiCallMade',
  'mdiCallMerge',
  'mdiCallMissed',
  'mdiCallReceived',
  'mdiCallSplit',
  'mdiCamcorder',
  'mdiCamcorderOff',
  'mdiCamera',
  'mdiCameraAccount',
  'mdiCameraBurst',
  'mdiCameraControl',
  'mdiCameraDocument',
  'mdiCameraDocumentOff',
  'mdiCameraEnhance',
  'mdiCameraEnhanceOutline',
  'mdiCameraFlip',
  'mdiCameraFlipOutline',
  'mdiCameraFront',
  'mdiCameraFrontVariant',
  'mdiCameraGopro',
  'mdiCameraImage',
  'mdiCameraIris',
  'mdiCameraLock',
  'mdiCameraLockOpen',
  'mdiCameraLockOpenOutline',
  'mdiCameraLockOutline',
  'mdiCameraMarker',
  'mdiCameraMarkerOutline',
  'mdiCameraMeteringCenter',
  'mdiCameraMeteringMatrix',
  'mdiCameraMeteringPartial',
  'mdiCameraMeteringSpot',
  'mdiCameraOff',
  'mdiCameraOffOutline',
  'mdiCameraOutline',
  'mdiCameraPartyMode',
  'mdiCameraPlus',
  'mdiCameraPlusOutline',
  'mdiCameraRear',
  'mdiCameraRearVariant',
  'mdiCameraRetake',
  'mdiCameraRetakeOutline',
  'mdiCameraSwitch',
  'mdiCameraSwitchOutline',
  'mdiCameraTimer',
  'mdiCameraWireless',
  'mdiCameraWirelessOutline',
  'mdiCampfire',
  'mdiCancel',
  'mdiCandelabra',
  'mdiCandelabraFire',
  'mdiCandle',
  'mdiCandy',
  'mdiCandyOff',
  'mdiCandyOffOutline',
  'mdiCandyOutline',
  'mdiCandycane',
  'mdiCannabis',
  'mdiCannabisOff',
  'mdiCapsLock',
  'mdiCar',
  'mdiCar2Plus',
  'mdiCar3Plus',
  'mdiCarArrowLeft',
  'mdiCarArrowRight',
  'mdiCarBack',
  'mdiCarBattery',
  'mdiCarBrakeAbs',
  'mdiCarBrakeAlert',
  'mdiCarBrakeFluidLevel',
  'mdiCarBrakeHold',
  'mdiCarBrakeLowPressure',
  'mdiCarBrakeParking',
  'mdiCarBrakeRetarder',
  'mdiCarBrakeTemperature',
  'mdiCarBrakeWornLinings',
  'mdiCarChildSeat',
  'mdiCarClock',
  'mdiCarClutch',
  'mdiCarCog',
  'mdiCarConnected',
  'mdiCarConvertible',
  'mdiCarCoolantLevel',
  'mdiCarCruiseControl',
  'mdiCarDefrostFront',
  'mdiCarDefrostRear',
  'mdiCarDoor',
  'mdiCarDoorLock',
  'mdiCarDoorLockOpen',
  'mdiCarElectric',
  'mdiCarElectricOutline',
  'mdiCarEmergency',
  'mdiCarEsp',
  'mdiCarEstate',
  'mdiCarHatchback',
  'mdiCarInfo',
  'mdiCarKey',
  'mdiCarLiftedPickup',
  'mdiCarLightAlert',
  'mdiCarLightDimmed',
  'mdiCarLightFog',
  'mdiCarLightHigh',
  'mdiCarLimousine',
  'mdiCarMultiple',
  'mdiCarOff',
  'mdiCarOutline',
  'mdiCarParkingLights',
  'mdiCarPickup',
  'mdiCarSearch',
  'mdiCarSearchOutline',
  'mdiCarSeat',
  'mdiCarSeatCooler',
  'mdiCarSeatHeater',
  'mdiCarSelect',
  'mdiCarSettings',
  'mdiCarShiftPattern',
  'mdiCarSide',
  'mdiCarSpeedLimiter',
  'mdiCarSports',
  'mdiCarTireAlert',
  'mdiCarTractionControl',
  'mdiCarTurbocharger',
  'mdiCarWash',
  'mdiCarWindshield',
  'mdiCarWindshieldOutline',
  'mdiCarWireless',
  'mdiCarWrench',
  'mdiCarabiner',
  'mdiCaravan',
  'mdiCard',
  'mdiCardAccountDetails',
  'mdiCardAccountDetailsOutline',
  'mdiCardAccountDetailsStar',
  'mdiCardAccountDetailsStarOutline',
  'mdiCardAccountMail',
  'mdiCardAccountMailOutline',
  'mdiCardAccountPhone',
  'mdiCardAccountPhoneOutline',
  'mdiCardBulleted',
  'mdiCardBulletedOff',
  'mdiCardBulletedOffOutline',
  'mdiCardBulletedOutline',
  'mdiCardBulletedSettings',
  'mdiCardBulletedSettingsOutline',
  'mdiCardMinus',
  'mdiCardMinusOutline',
  'mdiCardMultiple',
  'mdiCardMultipleOutline',
  'mdiCardOff',
  'mdiCardOffOutline',
  'mdiCardOutline',
  'mdiCardPlus',
  'mdiCardPlusOutline',
  'mdiCardRemove',
  'mdiCardRemoveOutline',
  'mdiCardSearch',
  'mdiCardSearchOutline',
  'mdiCardText',
  'mdiCardTextOutline',
  'mdiCards',
  'mdiCardsClub',
  'mdiCardsClubOutline',
  'mdiCardsDiamond',
  'mdiCardsDiamondOutline',
  'mdiCardsHeart',
  'mdiCardsHeartOutline',
  'mdiCardsOutline',
  'mdiCardsPlaying',
  'mdiCardsPlayingClub',
  'mdiCardsPlayingClubMultiple',
  'mdiCardsPlayingClubMultipleOutline',
  'mdiCardsPlayingClubOutline',
  'mdiCardsPlayingDiamond',
  'mdiCardsPlayingDiamondMultiple',
  'mdiCardsPlayingDiamondMultipleOutline',
  'mdiCardsPlayingDiamondOutline',
  'mdiCardsPlayingHeart',
  'mdiCardsPlayingHeartMultiple',
  'mdiCardsPlayingHeartMultipleOutline',
  'mdiCardsPlayingHeartOutline',
  'mdiCardsPlayingOutline',
  'mdiCardsPlayingSpade',
  'mdiCardsPlayingSpadeMultiple',
  'mdiCardsPlayingSpadeMultipleOutline',
  'mdiCardsPlayingSpadeOutline',
  'mdiCardsSpade',
  'mdiCardsSpadeOutline',
  'mdiCardsVariant',
  'mdiCarrot',
  'mdiCart',
  'mdiCartArrowDown',
  'mdiCartArrowRight',
  'mdiCartArrowUp',
  'mdiCartCheck',
  'mdiCartHeart',
  'mdiCartMinus',
  'mdiCartOff',
  'mdiCartOutline',
  'mdiCartPercent',
  'mdiCartPlus',
  'mdiCartRemove',
  'mdiCartVariant',
  'mdiCaseSensitiveAlt',
  'mdiCash',
  'mdiCash100',
  'mdiCashCheck',
  'mdiCashClock',
  'mdiCashEdit',
  'mdiCashFast',
  'mdiCashLock',
  'mdiCashLockOpen',
  'mdiCashMarker',
  'mdiCashMinus',
  'mdiCashMultiple',
  'mdiCashOff',
  'mdiCashPlus',
  'mdiCashRefund',
  'mdiCashRegister',
  'mdiCashRemove',
  'mdiCashSync',
  'mdiCassette',
  'mdiCast',
  'mdiCastAudio',
  'mdiCastAudioVariant',
  'mdiCastConnected',
  'mdiCastEducation',
  'mdiCastOff',
  'mdiCastVariant',
  'mdiCastle',
  'mdiCat',
  'mdiCctv',
  'mdiCctvOff',
  'mdiCeilingFan',
  'mdiCeilingFanLight',
  'mdiCeilingLight',
  'mdiCeilingLightMultiple',
  'mdiCeilingLightMultipleOutline',
  'mdiCeilingLightOutline',
  'mdiCellphone',
  'mdiCellphoneArrowDown',
  'mdiCellphoneArrowDownVariant',
  'mdiCellphoneBasic',
  'mdiCellphoneCharging',
  'mdiCellphoneCheck',
  'mdiCellphoneCog',
  'mdiCellphoneDock',
  'mdiCellphoneInformation',
  'mdiCellphoneKey',
  'mdiCellphoneLink',
  'mdiCellphoneLinkOff',
  'mdiCellphoneLock',
  'mdiCellphoneMarker',
  'mdiCellphoneMessage',
  'mdiCellphoneMessageOff',
  'mdiCellphoneNfc',
  'mdiCellphoneNfcOff',
  'mdiCellphoneOff',
  'mdiCellphonePlay',
  'mdiCellphoneRemove',
  'mdiCellphoneScreenshot',
  'mdiCellphoneSettings',
  'mdiCellphoneSound',
  'mdiCellphoneText',
  'mdiCellphoneWireless',
  'mdiCentos',
  'mdiCertificate',
  'mdiCertificateOutline',
  'mdiChairRolling',
  'mdiChairSchool',
  'mdiChandelier',
  'mdiCharity',
  'mdiCharitySearch',
  'mdiChartArc',
  'mdiChartAreaspline',
  'mdiChartAreasplineVariant',
  'mdiChartBar',
  'mdiChartBarStacked',
  'mdiChartBellCurve',
  'mdiChartBellCurveCumulative',
  'mdiChartBox',
  'mdiChartBoxMultiple',
  'mdiChartBoxMultipleOutline',
  'mdiChartBoxOutline',
  'mdiChartBoxPlusOutline',
  'mdiChartBubble',
  'mdiChartDonut',
  'mdiChartDonutVariant',
  'mdiChartGantt',
  'mdiChartHistogram',
  'mdiChartLine',
  'mdiChartLineStacked',
  'mdiChartLineVariant',
  'mdiChartMultiline',
  'mdiChartMultiple',
  'mdiChartPie',
  'mdiChartPieOutline',
  'mdiChartPpf',
  'mdiChartSankey',
  'mdiChartSankeyVariant',
  'mdiChartScatterPlot',
  'mdiChartScatterPlotHexbin',
  'mdiChartTimeline',
  'mdiChartTimelineVariant',
  'mdiChartTimelineVariantShimmer',
  'mdiChartTree',
  'mdiChartWaterfall',
  'mdiChat',
  'mdiChatAlert',
  'mdiChatAlertOutline',
  'mdiChatMinus',
  'mdiChatMinusOutline',
  'mdiChatOutline',
  'mdiChatPlus',
  'mdiChatPlusOutline',
  'mdiChatProcessing',
  'mdiChatProcessingOutline',
  'mdiChatQuestion',
  'mdiChatQuestionOutline',
  'mdiChatRemove',
  'mdiChatRemoveOutline',
  'mdiChatSleep',
  'mdiChatSleepOutline',
  'mdiCheck',
  'mdiCheckAll',
  'mdiCheckBold',
  'mdiCheckCircle',
  'mdiCheckCircleOutline',
  'mdiCheckDecagram',
  'mdiCheckDecagramOutline',
  'mdiCheckNetwork',
  'mdiCheckNetworkOutline',
  'mdiCheckOutline',
  'mdiCheckUnderline',
  'mdiCheckUnderlineCircle',
  'mdiCheckUnderlineCircleOutline',
  'mdiCheckbook',
  'mdiCheckbookArrowLeft',
  'mdiCheckbookArrowRight',
  'mdiCheckboxBlank',
  'mdiCheckboxBlankBadge',
  'mdiCheckboxBlankBadgeOutline',
  'mdiCheckboxBlankCircle',
  'mdiCheckboxBlankCircleOutline',
  'mdiCheckboxBlankOff',
  'mdiCheckboxBlankOffOutline',
  'mdiCheckboxBlankOutline',
  'mdiCheckboxIntermediate',
  'mdiCheckboxIntermediateVariant',
  'mdiCheckboxMarked',
  'mdiCheckboxMarkedCircle',
  'mdiCheckboxMarkedCircleAutoOutline',
  'mdiCheckboxMarkedCircleMinusOutline',
  'mdiCheckboxMarkedCircleOutline',
  'mdiCheckboxMarkedCirclePlusOutline',
  'mdiCheckboxMarkedOutline',
  'mdiCheckboxMultipleBlank',
  'mdiCheckboxMultipleBlankCircle',
  'mdiCheckboxMultipleBlankCircleOutline',
  'mdiCheckboxMultipleBlankOutline',
  'mdiCheckboxMultipleMarked',
  'mdiCheckboxMultipleMarkedCircle',
  'mdiCheckboxMultipleMarkedCircleOutline',
  'mdiCheckboxMultipleMarkedOutline',
  'mdiCheckboxMultipleOutline',
  'mdiCheckboxOutline',
  'mdiCheckerboard',
  'mdiCheckerboardMinus',
  'mdiCheckerboardPlus',
  'mdiCheckerboardRemove',
  'mdiCheese',
  'mdiCheeseOff',
  'mdiChefHat',
  'mdiChemicalWeapon',
  'mdiChessBishop',
  'mdiChessKing',
  'mdiChessKnight',
  'mdiChessPawn',
  'mdiChessQueen',
  'mdiChessRook',
  'mdiChevronDoubleDown',
  'mdiChevronDoubleLeft',
  'mdiChevronDoubleRight',
  'mdiChevronDoubleUp',
  'mdiChevronDown',
  'mdiChevronDownBox',
  'mdiChevronDownBoxOutline',
  'mdiChevronDownCircle',
  'mdiChevronDownCircleOutline',
  'mdiChevronLeft',
  'mdiChevronLeftBox',
  'mdiChevronLeftBoxOutline',
  'mdiChevronLeftCircle',
  'mdiChevronLeftCircleOutline',
  'mdiChevronRight',
  'mdiChevronRightBox',
  'mdiChevronRightBoxOutline',
  'mdiChevronRightCircle',
  'mdiChevronRightCircleOutline',
  'mdiChevronTripleDown',
  'mdiChevronTripleLeft',
  'mdiChevronTripleRight',
  'mdiChevronTripleUp',
  'mdiChevronUp',
  'mdiChevronUpBox',
  'mdiChevronUpBoxOutline',
  'mdiChevronUpCircle',
  'mdiChevronUpCircleOutline',
  'mdiChiliAlert',
  'mdiChiliAlertOutline',
  'mdiChiliHot',
  'mdiChiliHotOutline',
  'mdiChiliMedium',
  'mdiChiliMediumOutline',
  'mdiChiliMild',
  'mdiChiliMildOutline',
  'mdiChiliOff',
  'mdiChiliOffOutline',
  'mdiChip',
  'mdiChurch',
  'mdiChurchOutline',
  'mdiCigar',
  'mdiCigarOff',
  'mdiCircle',
  'mdiCircleBox',
  'mdiCircleBoxOutline',
  'mdiCircleDouble',
  'mdiCircleEditOutline',
  'mdiCircleExpand',
  'mdiCircleHalf',
  'mdiCircleHalfFull',
  'mdiCircleMedium',
  'mdiCircleMultiple',
  'mdiCircleMultipleOutline',
  'mdiCircleOffOutline',
  'mdiCircleOpacity',
  'mdiCircleOutline',
  'mdiCircleSlice1',
  'mdiCircleSlice2',
  'mdiCircleSlice3',
  'mdiCircleSlice4',
  'mdiCircleSlice5',
  'mdiCircleSlice6',
  'mdiCircleSlice7',
  'mdiCircleSlice8',
  'mdiCircleSmall',
  'mdiCircularSaw',
  'mdiCity',
  'mdiCitySwitch',
  'mdiCityVariant',
  'mdiCityVariantOutline',
  'mdiClipboard',
  'mdiClipboardAccount',
  'mdiClipboardAccountOutline',
  'mdiClipboardAlert',
  'mdiClipboardAlertOutline',
  'mdiClipboardArrowDown',
  'mdiClipboardArrowDownOutline',
  'mdiClipboardArrowLeft',
  'mdiClipboardArrowLeftOutline',
  'mdiClipboardArrowRight',
  'mdiClipboardArrowRightOutline',
  'mdiClipboardArrowUp',
  'mdiClipboardArrowUpOutline',
  'mdiClipboardCheck',
  'mdiClipboardCheckMultiple',
  'mdiClipboardCheckMultipleOutline',
  'mdiClipboardCheckOutline',
  'mdiClipboardClock',
  'mdiClipboardClockOutline',
  'mdiClipboardEdit',
  'mdiClipboardEditOutline',
  'mdiClipboardFile',
  'mdiClipboardFileOutline',
  'mdiClipboardFlow',
  'mdiClipboardFlowOutline',
  'mdiClipboardList',
  'mdiClipboardListOutline',
  'mdiClipboardMinus',
  'mdiClipboardMinusOutline',
  'mdiClipboardMultiple',
  'mdiClipboardMultipleOutline',
  'mdiClipboardOff',
  'mdiClipboardOffOutline',
  'mdiClipboardOutline',
  'mdiClipboardPlay',
  'mdiClipboardPlayMultiple',
  'mdiClipboardPlayMultipleOutline',
  'mdiClipboardPlayOutline',
  'mdiClipboardPlus',
  'mdiClipboardPlusOutline',
  'mdiClipboardPulse',
  'mdiClipboardPulseOutline',
  'mdiClipboardRemove',
  'mdiClipboardRemoveOutline',
  'mdiClipboardSearch',
  'mdiClipboardSearchOutline',
  'mdiClipboardText',
  'mdiClipboardTextClock',
  'mdiClipboardTextClockOutline',
  'mdiClipboardTextMultiple',
  'mdiClipboardTextMultipleOutline',
  'mdiClipboardTextOff',
  'mdiClipboardTextOffOutline',
  'mdiClipboardTextOutline',
  'mdiClipboardTextPlay',
  'mdiClipboardTextPlayOutline',
  'mdiClipboardTextSearch',
  'mdiClipboardTextSearchOutline',
  'mdiClippy',
  'mdiClock',
  'mdiClockAlert',
  'mdiClockAlertOutline',
  'mdiClockCheck',
  'mdiClockCheckOutline',
  'mdiClockDigital',
  'mdiClockEdit',
  'mdiClockEditOutline',
  'mdiClockEnd',
  'mdiClockFast',
  'mdiClockIn',
  'mdiClockMinus',
  'mdiClockMinusOutline',
  'mdiClockOut',
  'mdiClockOutline',
  'mdiClockPlus',
  'mdiClockPlusOutline',
  'mdiClockRemove',
  'mdiClockRemoveOutline',
  'mdiClockStarFourPoints',
  'mdiClockStarFourPointsOutline',
  'mdiClockStart',
  'mdiClockTimeEight',
  'mdiClockTimeEightOutline',
  'mdiClockTimeEleven',
  'mdiClockTimeElevenOutline',
  'mdiClockTimeFive',
  'mdiClockTimeFiveOutline',
  'mdiClockTimeFour',
  'mdiClockTimeFourOutline',
  'mdiClockTimeNine',
  'mdiClockTimeNineOutline',
  'mdiClockTimeOne',
  'mdiClockTimeOneOutline',
  'mdiClockTimeSeven',
  'mdiClockTimeSevenOutline',
  'mdiClockTimeSix',
  'mdiClockTimeSixOutline',
  'mdiClockTimeTen',
  'mdiClockTimeTenOutline',
  'mdiClockTimeThree',
  'mdiClockTimeThreeOutline',
  'mdiClockTimeTwelve',
  'mdiClockTimeTwelveOutline',
  'mdiClockTimeTwo',
  'mdiClockTimeTwoOutline',
  'mdiClose',
  'mdiCloseBox',
  'mdiCloseBoxMultiple',
  'mdiCloseBoxMultipleOutline',
  'mdiCloseBoxOutline',
  'mdiCloseCircle',
  'mdiCloseCircleMultiple',
  'mdiCloseCircleMultipleOutline',
  'mdiCloseCircleOutline',
  'mdiCloseNetwork',
  'mdiCloseNetworkOutline',
  'mdiCloseOctagon',
  'mdiCloseOctagonOutline',
  'mdiCloseOutline',
  'mdiCloseThick',
  'mdiClosedCaption',
  'mdiClosedCaptionOutline',
  'mdiCloud',
  'mdiCloudAlert',
  'mdiCloudAlertOutline',
  'mdiCloudArrowDown',
  'mdiCloudArrowDownOutline',
  'mdiCloudArrowLeft',
  'mdiCloudArrowLeftOutline',
  'mdiCloudArrowRight',
  'mdiCloudArrowRightOutline',
  'mdiCloudArrowUp',
  'mdiCloudArrowUpOutline',
  'mdiCloudBraces',
  'mdiCloudCancel',
  'mdiCloudCancelOutline',
  'mdiCloudCheck',
  'mdiCloudCheckOutline',
  'mdiCloudCheckVariant',
  'mdiCloudCheckVariantOutline',
  'mdiCloudCircle',
  'mdiCloudCircleOutline',
  'mdiCloudClock',
  'mdiCloudClockOutline',
  'mdiCloudCog',
  'mdiCloudCogOutline',
  'mdiCloudDownload',
  'mdiCloudDownloadOutline',
  'mdiCloudKey',
  'mdiCloudKeyOutline',
  'mdiCloudLock',
  'mdiCloudLockOpen',
  'mdiCloudLockOpenOutline',
  'mdiCloudLockOutline',
  'mdiCloudMinus',
  'mdiCloudMinusOutline',
  'mdiCloudOff',
  'mdiCloudOffOutline',
  'mdiCloudOutline',
  'mdiCloudPercent',
  'mdiCloudPercentOutline',
  'mdiCloudPlus',
  'mdiCloudPlusOutline',
  'mdiCloudPrint',
  'mdiCloudPrintOutline',
  'mdiCloudQuestion',
  'mdiCloudQuestionOutline',
  'mdiCloudRefresh',
  'mdiCloudRefreshOutline',
  'mdiCloudRefreshVariant',
  'mdiCloudRefreshVariantOutline',
  'mdiCloudRemove',
  'mdiCloudRemoveOutline',
  'mdiCloudSearch',
  'mdiCloudSearchOutline',
  'mdiCloudSync',
  'mdiCloudSyncOutline',
  'mdiCloudTags',
  'mdiCloudUpload',
  'mdiCloudUploadOutline',
  'mdiClouds',
  'mdiClover',
  'mdiCloverOutline',
  'mdiCoachLamp',
  'mdiCoachLampVariant',
  'mdiCoatRack',
  'mdiCodeArray',
  'mdiCodeBlockBraces',
  'mdiCodeBlockBrackets',
  'mdiCodeBlockParentheses',
  'mdiCodeBlockTags',
  'mdiCodeBraces',
  'mdiCodeBracesBox',
  'mdiCodeBrackets',
  'mdiCodeEqual',
  'mdiCodeGreaterThan',
  'mdiCodeGreaterThanOrEqual',
  'mdiCodeJson',
  'mdiCodeLessThan',
  'mdiCodeLessThanOrEqual',
  'mdiCodeNotEqual',
  'mdiCodeNotEqualVariant',
  'mdiCodeParentheses',
  'mdiCodeParenthesesBox',
  'mdiCodeString',
  'mdiCodeTags',
  'mdiCodeTagsCheck',
  'mdiCodepen',
  'mdiCoffee',
  'mdiCoffeeMaker',
  'mdiCoffeeMakerCheck',
  'mdiCoffeeMakerCheckOutline',
  'mdiCoffeeMakerOutline',
  'mdiCoffeeOff',
  'mdiCoffeeOffOutline',
  'mdiCoffeeOutline',
  'mdiCoffeeToGo',
  'mdiCoffeeToGoOutline',
  'mdiCoffin',
  'mdiCog',
  'mdiCogBox',
  'mdiCogClockwise',
  'mdiCogCounterclockwise',
  'mdiCogOff',
  'mdiCogOffOutline',
  'mdiCogOutline',
  'mdiCogPause',
  'mdiCogPauseOutline',
  'mdiCogPlay',
  'mdiCogPlayOutline',
  'mdiCogRefresh',
  'mdiCogRefreshOutline',
  'mdiCogStop',
  'mdiCogStopOutline',
  'mdiCogSync',
  'mdiCogSyncOutline',
  'mdiCogTransfer',
  'mdiCogTransferOutline',
  'mdiCogs',
  'mdiCollage',
  'mdiCollapseAll',
  'mdiCollapseAllOutline',
  'mdiColorHelper',
  'mdiComma',
  'mdiCommaBox',
  'mdiCommaBoxOutline',
  'mdiCommaCircle',
  'mdiCommaCircleOutline',
  'mdiComment',
  'mdiCommentAccount',
  'mdiCommentAccountOutline',
  'mdiCommentAlert',
  'mdiCommentAlertOutline',
  'mdiCommentArrowLeft',
  'mdiCommentArrowLeftOutline',
  'mdiCommentArrowRight',
  'mdiCommentArrowRightOutline',
  'mdiCommentBookmark',
  'mdiCommentBookmarkOutline',
  'mdiCommentCheck',
  'mdiCommentCheckOutline',
  'mdiCommentEdit',
  'mdiCommentEditOutline',
  'mdiCommentEye',
  'mdiCommentEyeOutline',
  'mdiCommentFlash',
  'mdiCommentFlashOutline',
  'mdiCommentMinus',
  'mdiCommentMinusOutline',
  'mdiCommentMultiple',
  'mdiCommentMultipleOutline',
  'mdiCommentOff',
  'mdiCommentOffOutline',
  'mdiCommentOutline',
  'mdiCommentPlus',
  'mdiCommentPlusOutline',
  'mdiCommentProcessing',
  'mdiCommentProcessingOutline',
  'mdiCommentQuestion',
  'mdiCommentQuestionOutline',
  'mdiCommentQuote',
  'mdiCommentQuoteOutline',
  'mdiCommentRemove',
  'mdiCommentRemoveOutline',
  'mdiCommentSearch',
  'mdiCommentSearchOutline',
  'mdiCommentText',
  'mdiCommentTextMultiple',
  'mdiCommentTextMultipleOutline',
  'mdiCommentTextOutline',
  'mdiCompare',
  'mdiCompareHorizontal',
  'mdiCompareRemove',
  'mdiCompareVertical',
  'mdiCompass',
  'mdiCompassOff',
  'mdiCompassOffOutline',
  'mdiCompassOutline',
  'mdiCompassRose',
  'mdiCompost',
  'mdiCone',
  'mdiConeOff',
  'mdiConnection',
  'mdiConsole',
  'mdiConsoleLine',
  'mdiConsoleNetwork',
  'mdiConsoleNetworkOutline',
  'mdiConsolidate',
  'mdiContactlessPayment',
  'mdiContactlessPaymentCircle',
  'mdiContactlessPaymentCircleOutline',
  'mdiContacts',
  'mdiContactsOutline',
  'mdiContain',
  'mdiContainEnd',
  'mdiContainStart',
  'mdiContentCopy',
  'mdiContentCut',
  'mdiContentDuplicate',
  'mdiContentPaste',
  'mdiContentSave',
  'mdiContentSaveAlert',
  'mdiContentSaveAlertOutline',
  'mdiContentSaveAll',
  'mdiContentSaveAllOutline',
  'mdiContentSaveCheck',
  'mdiContentSaveCheckOutline',
  'mdiContentSaveCog',
  'mdiContentSaveCogOutline',
  'mdiContentSaveEdit',
  'mdiContentSaveEditOutline',
  'mdiContentSaveMinus',
  'mdiContentSaveMinusOutline',
  'mdiContentSaveMove',
  'mdiContentSaveMoveOutline',
  'mdiContentSaveOff',
  'mdiContentSaveOffOutline',
  'mdiContentSaveOutline',
  'mdiContentSavePlus',
  'mdiContentSavePlusOutline',
  'mdiContentSaveSettings',
  'mdiContentSaveSettingsOutline',
  'mdiContrast',
  'mdiContrastBox',
  'mdiContrastCircle',
  'mdiController',
  'mdiControllerClassic',
  'mdiControllerClassicOutline',
  'mdiControllerOff',
  'mdiCookie',
  'mdiCookieAlert',
  'mdiCookieAlertOutline',
  'mdiCookieCheck',
  'mdiCookieCheckOutline',
  'mdiCookieClock',
  'mdiCookieClockOutline',
  'mdiCookieCog',
  'mdiCookieCogOutline',
  'mdiCookieEdit',
  'mdiCookieEditOutline',
  'mdiCookieLock',
  'mdiCookieLockOutline',
  'mdiCookieMinus',
  'mdiCookieMinusOutline',
  'mdiCookieOff',
  'mdiCookieOffOutline',
  'mdiCookieOutline',
  'mdiCookiePlus',
  'mdiCookiePlusOutline',
  'mdiCookieRefresh',
  'mdiCookieRefreshOutline',
  'mdiCookieRemove',
  'mdiCookieRemoveOutline',
  'mdiCookieSettings',
  'mdiCookieSettingsOutline',
  'mdiCoolantTemperature',
  'mdiCopyleft',
  'mdiCopyright',
  'mdiCordova',
  'mdiCorn',
  'mdiCornOff',
  'mdiCosineWave',
  'mdiCounter',
  'mdiCountertop',
  'mdiCountertopOutline',
  'mdiCow',
  'mdiCowOff',
  'mdiCpu32Bit',
  'mdiCpu64Bit',
  'mdiCradle',
  'mdiCradleOutline',
  'mdiCrane',
  'mdiCreation',
  'mdiCreationOutline',
  'mdiCreativeCommons',
  'mdiCreditCard',
  'mdiCreditCardCheck',
  'mdiCreditCardCheckOutline',
  'mdiCreditCardChip',
  'mdiCreditCardChipOutline',
  'mdiCreditCardClock',
  'mdiCreditCardClockOutline',
  'mdiCreditCardEdit',
  'mdiCreditCardEditOutline',
  'mdiCreditCardFast',
  'mdiCreditCardFastOutline',
  'mdiCreditCardLock',
  'mdiCreditCardLockOutline',
  'mdiCreditCardMarker',
  'mdiCreditCardMarkerOutline',
  'mdiCreditCardMinus',
  'mdiCreditCardMinusOutline',
  'mdiCreditCardMultiple',
  'mdiCreditCardMultipleOutline',
  'mdiCreditCardOff',
  'mdiCreditCardOffOutline',
  'mdiCreditCardOutline',
  'mdiCreditCardPlus',
  'mdiCreditCardPlusOutline',
  'mdiCreditCardRefresh',
  'mdiCreditCardRefreshOutline',
  'mdiCreditCardRefund',
  'mdiCreditCardRefundOutline',
  'mdiCreditCardRemove',
  'mdiCreditCardRemoveOutline',
  'mdiCreditCardScan',
  'mdiCreditCardScanOutline',
  'mdiCreditCardSearch',
  'mdiCreditCardSearchOutline',
  'mdiCreditCardSettings',
  'mdiCreditCardSettingsOutline',
  'mdiCreditCardSync',
  'mdiCreditCardSyncOutline',
  'mdiCreditCardWireless',
  'mdiCreditCardWirelessOff',
  'mdiCreditCardWirelessOffOutline',
  'mdiCreditCardWirelessOutline',
  'mdiCricket',
  'mdiCrop',
  'mdiCropFree',
  'mdiCropLandscape',
  'mdiCropPortrait',
  'mdiCropRotate',
  'mdiCropSquare',
  'mdiCross',
  'mdiCrossBolnisi',
  'mdiCrossCeltic',
  'mdiCrossOutline',
  'mdiCrosshairs',
  'mdiCrosshairsGps',
  'mdiCrosshairsOff',
  'mdiCrosshairsQuestion',
  'mdiCrowd',
  'mdiCrown',
  'mdiCrownCircle',
  'mdiCrownCircleOutline',
  'mdiCrownOutline',
  'mdiCryengine',
  'mdiCrystalBall',
  'mdiCube',
  'mdiCubeOff',
  'mdiCubeOffOutline',
  'mdiCubeOutline',
  'mdiCubeScan',
  'mdiCubeSend',
  'mdiCubeUnfolded',
  'mdiCup',
  'mdiCupOff',
  'mdiCupOffOutline',
  'mdiCupOutline',
  'mdiCupWater',
  'mdiCupboard',
  'mdiCupboardOutline',
  'mdiCupcake',
  'mdiCurling',
  'mdiCurrencyBdt',
  'mdiCurrencyBrl',
  'mdiCurrencyBtc',
  'mdiCurrencyCny',
  'mdiCurrencyEth',
  'mdiCurrencyEur',
  'mdiCurrencyEurOff',
  'mdiCurrencyFra',
  'mdiCurrencyGbp',
  'mdiCurrencyIls',
  'mdiCurrencyInr',
  'mdiCurrencyJpy',
  'mdiCurrencyKrw',
  'mdiCurrencyKzt',
  'mdiCurrencyMnt',
  'mdiCurrencyNgn',
  'mdiCurrencyPhp',
  'mdiCurrencyRial',
  'mdiCurrencyRub',
  'mdiCurrencyRupee',
  'mdiCurrencySign',
  'mdiCurrencyThb',
  'mdiCurrencyTry',
  'mdiCurrencyTwd',
  'mdiCurrencyUah',
  'mdiCurrencyUsd',
  'mdiCurrencyUsdOff',
  'mdiCurrentAc',
  'mdiCurrentDc',
  'mdiCursorDefault',
  'mdiCursorDefaultClick',
  'mdiCursorDefaultClickOutline',
  'mdiCursorDefaultGesture',
  'mdiCursorDefaultGestureOutline',
  'mdiCursorDefaultOutline',
  'mdiCursorMove',
  'mdiCursorPointer',
  'mdiCursorText',
  'mdiCurtains',
  'mdiCurtainsClosed',
  'mdiCylinder',
  'mdiCylinderOff',
  'mdiDanceBallroom',
  'mdiDancePole',
  'mdiDataMatrix',
  'mdiDataMatrixEdit',
  'mdiDataMatrixMinus',
  'mdiDataMatrixPlus',
  'mdiDataMatrixRemove',
  'mdiDataMatrixScan',
  'mdiDatabase',
  'mdiDatabaseAlert',
  'mdiDatabaseAlertOutline',
  'mdiDatabaseArrowDown',
  'mdiDatabaseArrowDownOutline',
  'mdiDatabaseArrowLeft',
  'mdiDatabaseArrowLeftOutline',
  'mdiDatabaseArrowRight',
  'mdiDatabaseArrowRightOutline',
  'mdiDatabaseArrowUp',
  'mdiDatabaseArrowUpOutline',
  'mdiDatabaseCheck',
  'mdiDatabaseCheckOutline',
  'mdiDatabaseClock',
  'mdiDatabaseClockOutline',
  'mdiDatabaseCog',
  'mdiDatabaseCogOutline',
  'mdiDatabaseEdit',
  'mdiDatabaseEditOutline',
  'mdiDatabaseExport',
  'mdiDatabaseExportOutline',
  'mdiDatabaseEye',
  'mdiDatabaseEyeOff',
  'mdiDatabaseEyeOffOutline',
  'mdiDatabaseEyeOutline',
  'mdiDatabaseImport',
  'mdiDatabaseImportOutline',
  'mdiDatabaseLock',
  'mdiDatabaseLockOutline',
  'mdiDatabaseMarker',
  'mdiDatabaseMarkerOutline',
  'mdiDatabaseMinus',
  'mdiDatabaseMinusOutline',
  'mdiDatabaseOff',
  'mdiDatabaseOffOutline',
  'mdiDatabaseOutline',
  'mdiDatabasePlus',
  'mdiDatabasePlusOutline',
  'mdiDatabaseRefresh',
  'mdiDatabaseRefreshOutline',
  'mdiDatabaseRemove',
  'mdiDatabaseRemoveOutline',
  'mdiDatabaseSearch',
  'mdiDatabaseSearchOutline',
  'mdiDatabaseSettings',
  'mdiDatabaseSettingsOutline',
  'mdiDatabaseSync',
  'mdiDatabaseSyncOutline',
  'mdiDeathStar',
  'mdiDeathStarVariant',
  'mdiDeathlyHallows',
  'mdiDebian',
  'mdiDebugStepInto',
  'mdiDebugStepOut',
  'mdiDebugStepOver',
  'mdiDecagram',
  'mdiDecagramOutline',
  'mdiDecimal',
  'mdiDecimalComma',
  'mdiDecimalCommaDecrease',
  'mdiDecimalCommaIncrease',
  'mdiDecimalDecrease',
  'mdiDecimalIncrease',
  'mdiDelete',
  'mdiDeleteAlert',
  'mdiDeleteAlertOutline',
  'mdiDeleteCircle',
  'mdiDeleteCircleOutline',
  'mdiDeleteClock',
  'mdiDeleteClockOutline',
  'mdiDeleteEmpty',
  'mdiDeleteEmptyOutline',
  'mdiDeleteForever',
  'mdiDeleteForeverOutline',
  'mdiDeleteOff',
  'mdiDeleteOffOutline',
  'mdiDeleteOutline',
  'mdiDeleteRestore',
  'mdiDeleteSweep',
  'mdiDeleteSweepOutline',
  'mdiDeleteVariant',
  'mdiDelta',
  'mdiDesk',
  'mdiDeskLamp',
  'mdiDeskLampOff',
  'mdiDeskLampOn',
  'mdiDeskphone',
  'mdiDesktopClassic',
  'mdiDesktopTower',
  'mdiDesktopTowerMonitor',
  'mdiDetails',
  'mdiDevTo',
  'mdiDeveloperBoard',
  'mdiDeviantart',
  'mdiDevices',
  'mdiDharmachakra',
  'mdiDiabetes',
  'mdiDialpad',
  'mdiDiameter',
  'mdiDiameterOutline',
  'mdiDiameterVariant',
  'mdiDiamond',
  'mdiDiamondOutline',
  'mdiDiamondStone',
  'mdiDiaperOutline',
  'mdiDice1',
  'mdiDice1Outline',
  'mdiDice2',
  'mdiDice2Outline',
  'mdiDice3',
  'mdiDice3Outline',
  'mdiDice4',
  'mdiDice4Outline',
  'mdiDice5',
  'mdiDice5Outline',
  'mdiDice6',
  'mdiDice6Outline',
  'mdiDiceD10',
  'mdiDiceD10Outline',
  'mdiDiceD12',
  'mdiDiceD12Outline',
  'mdiDiceD20',
  'mdiDiceD20Outline',
  'mdiDiceD4',
  'mdiDiceD4Outline',
  'mdiDiceD6',
  'mdiDiceD6Outline',
  'mdiDiceD8',
  'mdiDiceD8Outline',
  'mdiDiceMultiple',
  'mdiDiceMultipleOutline',
  'mdiDigitalOcean',
  'mdiDipSwitch',
  'mdiDirections',
  'mdiDirectionsFork',
  'mdiDisc',
  'mdiDiscAlert',
  'mdiDiscPlayer',
  'mdiDishwasher',
  'mdiDishwasherAlert',
  'mdiDishwasherOff',
  'mdiDisqus',
  'mdiDistributeHorizontalCenter',
  'mdiDistributeHorizontalLeft',
  'mdiDistributeHorizontalRight',
  'mdiDistributeVerticalBottom',
  'mdiDistributeVerticalCenter',
  'mdiDistributeVerticalTop',
  'mdiDiversify',
  'mdiDiving',
  'mdiDivingFlippers',
  'mdiDivingHelmet',
  'mdiDivingScuba',
  'mdiDivingScubaFlag',
  'mdiDivingScubaMask',
  'mdiDivingScubaTank',
  'mdiDivingScubaTankMultiple',
  'mdiDivingSnorkel',
  'mdiDivision',
  'mdiDivisionBox',
  'mdiDlna',
  'mdiDna',
  'mdiDns',
  'mdiDnsOutline',
  'mdiDockBottom',
  'mdiDockLeft',
  'mdiDockRight',
  'mdiDockTop',
  'mdiDockWindow',
  'mdiDocker',
  'mdiDoctor',
  'mdiDog',
  'mdiDogService',
  'mdiDogSide',
  'mdiDogSideOff',
  'mdiDolby',
  'mdiDolly',
  'mdiDolphin',
  'mdiDomain',
  'mdiDomainOff',
  'mdiDomainPlus',
  'mdiDomainRemove',
  'mdiDomainSwitch',
  'mdiDomeLight',
  'mdiDominoMask',
  'mdiDonkey',
  'mdiDoor',
  'mdiDoorClosed',
  'mdiDoorClosedCancel',
  'mdiDoorClosedLock',
  'mdiDoorOpen',
  'mdiDoorSliding',
  'mdiDoorSlidingLock',
  'mdiDoorSlidingOpen',
  'mdiDoorbell',
  'mdiDoorbellVideo',
  'mdiDotNet',
  'mdiDotsCircle',
  'mdiDotsGrid',
  'mdiDotsHexagon',
  'mdiDotsHorizontal',
  'mdiDotsHorizontalCircle',
  'mdiDotsHorizontalCircleOutline',
  'mdiDotsSquare',
  'mdiDotsTriangle',
  'mdiDotsVertical',
  'mdiDotsVerticalCircle',
  'mdiDotsVerticalCircleOutline',
  'mdiDownload',
  'mdiDownloadBox',
  'mdiDownloadBoxOutline',
  'mdiDownloadCircle',
  'mdiDownloadCircleOutline',
  'mdiDownloadLock',
  'mdiDownloadLockOutline',
  'mdiDownloadMultiple',
  'mdiDownloadMultipleOutline',
  'mdiDownloadNetwork',
  'mdiDownloadNetworkOutline',
  'mdiDownloadOff',
  'mdiDownloadOffOutline',
  'mdiDownloadOutline',
  'mdiDrag',
  'mdiDragHorizontal',
  'mdiDragHorizontalVariant',
  'mdiDragVariant',
  'mdiDragVertical',
  'mdiDragVerticalVariant',
  'mdiDramaMasks',
  'mdiDraw',
  'mdiDrawPen',
  'mdiDrawing',
  'mdiDrawingBox',
  'mdiDresser',
  'mdiDresserOutline',
  'mdiDrone',
  'mdiDropbox',
  'mdiDrupal',
  'mdiDuck',
  'mdiDumbbell',
  'mdiDumpTruck',
  'mdiEarHearing',
  'mdiEarHearingLoop',
  'mdiEarHearingOff',
  'mdiEarbuds',
  'mdiEarbudsOff',
  'mdiEarbudsOffOutline',
  'mdiEarbudsOutline',
  'mdiEarth',
  'mdiEarthArrowDown',
  'mdiEarthArrowLeft',
  'mdiEarthArrowRight',
  'mdiEarthArrowUp',
  'mdiEarthBox',
  'mdiEarthBoxMinus',
  'mdiEarthBoxOff',
  'mdiEarthBoxPlus',
  'mdiEarthBoxRemove',
  'mdiEarthMinus',
  'mdiEarthOff',
  'mdiEarthPlus',
  'mdiEarthRemove',
  'mdiEgg',
  'mdiEggEaster',
  'mdiEggFried',
  'mdiEggOff',
  'mdiEggOffOutline',
  'mdiEggOutline',
  'mdiEiffelTower',
  'mdiEightTrack',
  'mdiEject',
  'mdiEjectCircle',
  'mdiEjectCircleOutline',
  'mdiEjectOutline',
  'mdiElectricSwitch',
  'mdiElectricSwitchClosed',
  'mdiElectronFramework',
  'mdiElephant',
  'mdiElevationDecline',
  'mdiElevationRise',
  'mdiElevator',
  'mdiElevatorDown',
  'mdiElevatorPassenger',
  'mdiElevatorPassengerOff',
  'mdiElevatorPassengerOffOutline',
  'mdiElevatorPassengerOutline',
  'mdiElevatorUp',
  'mdiEllipse',
  'mdiEllipseOutline',
  'mdiEmail',
  'mdiEmailAlert',
  'mdiEmailAlertOutline',
  'mdiEmailArrowLeft',
  'mdiEmailArrowLeftOutline',
  'mdiEmailArrowRight',
  'mdiEmailArrowRightOutline',
  'mdiEmailBox',
  'mdiEmailCheck',
  'mdiEmailCheckOutline',
  'mdiEmailEdit',
  'mdiEmailEditOutline',
  'mdiEmailFast',
  'mdiEmailFastOutline',
  'mdiEmailHeartOutline',
  'mdiEmailLock',
  'mdiEmailLockOutline',
  'mdiEmailMarkAsUnread',
  'mdiEmailMinus',
  'mdiEmailMinusOutline',
  'mdiEmailMultiple',
  'mdiEmailMultipleOutline',
  'mdiEmailNewsletter',
  'mdiEmailOff',
  'mdiEmailOffOutline',
  'mdiEmailOpen',
  'mdiEmailOpenHeartOutline',
  'mdiEmailOpenMultiple',
  'mdiEmailOpenMultipleOutline',
  'mdiEmailOpenOutline',
  'mdiEmailOutline',
  'mdiEmailPlus',
  'mdiEmailPlusOutline',
  'mdiEmailRemove',
  'mdiEmailRemoveOutline',
  'mdiEmailSeal',
  'mdiEmailSealOutline',
  'mdiEmailSearch',
  'mdiEmailSearchOutline',
  'mdiEmailSync',
  'mdiEmailSyncOutline',
  'mdiEmailVariant',
  'mdiEmber',
  'mdiEmby',
  'mdiEmoticon',
  'mdiEmoticonAngry',
  'mdiEmoticonAngryOutline',
  'mdiEmoticonConfused',
  'mdiEmoticonConfusedOutline',
  'mdiEmoticonCool',
  'mdiEmoticonCoolOutline',
  'mdiEmoticonCry',
  'mdiEmoticonCryOutline',
  'mdiEmoticonDead',
  'mdiEmoticonDeadOutline',
  'mdiEmoticonDevil',
  'mdiEmoticonDevilOutline',
  'mdiEmoticonExcited',
  'mdiEmoticonExcitedOutline',
  'mdiEmoticonFrown',
  'mdiEmoticonFrownOutline',
  'mdiEmoticonHappy',
  'mdiEmoticonHappyOutline',
  'mdiEmoticonKiss',
  'mdiEmoticonKissOutline',
  'mdiEmoticonLol',
  'mdiEmoticonLolOutline',
  'mdiEmoticonMinus',
  'mdiEmoticonMinusOutline',
  'mdiEmoticonNeutral',
  'mdiEmoticonNeutralOutline',
  'mdiEmoticonOutline',
  'mdiEmoticonPlus',
  'mdiEmoticonPlusOutline',
  'mdiEmoticonPoop',
  'mdiEmoticonPoopOutline',
  'mdiEmoticonRemove',
  'mdiEmoticonRemoveOutline',
  'mdiEmoticonSad',
  'mdiEmoticonSadOutline',
  'mdiEmoticonSick',
  'mdiEmoticonSickOutline',
  'mdiEmoticonTongue',
  'mdiEmoticonTongueOutline',
  'mdiEmoticonWink',
  'mdiEmoticonWinkOutline',
  'mdiEngine',
  'mdiEngineOff',
  'mdiEngineOffOutline',
  'mdiEngineOutline',
  'mdiEpsilon',
  'mdiEqual',
  'mdiEqualBox',
  'mdiEqualizer',
  'mdiEqualizerOutline',
  'mdiEraser',
  'mdiEraserVariant',
  'mdiEscalator',
  'mdiEscalatorBox',
  'mdiEscalatorDown',
  'mdiEscalatorUp',
  'mdiEslint',
  'mdiEt',
  'mdiEthereum',
  'mdiEthernet',
  'mdiEthernetCable',
  'mdiEthernetCableOff',
  'mdiEthernetOff',
  'mdiEvPlugCcs1',
  'mdiEvPlugCcs2',
  'mdiEvPlugChademo',
  'mdiEvPlugTesla',
  'mdiEvPlugType1',
  'mdiEvPlugType2',
  'mdiEvStation',
  'mdiEvernote',
  'mdiExcavator',
  'mdiExclamation',
  'mdiExclamationThick',
  'mdiExitRun',
  'mdiExitToApp',
  'mdiExpandAll',
  'mdiExpandAllOutline',
  'mdiExpansionCard',
  'mdiExpansionCardVariant',
  'mdiExponent',
  'mdiExponentBox',
  'mdiExport',
  'mdiExportVariant',
  'mdiEye',
  'mdiEyeArrowLeft',
  'mdiEyeArrowLeftOutline',
  'mdiEyeArrowRight',
  'mdiEyeArrowRightOutline',
  'mdiEyeCheck',
  'mdiEyeCheckOutline',
  'mdiEyeCircle',
  'mdiEyeCircleOutline',
  'mdiEyeClosed',
  'mdiEyeLock',
  'mdiEyeLockOpen',
  'mdiEyeLockOpenOutline',
  'mdiEyeLockOutline',
  'mdiEyeMinus',
  'mdiEyeMinusOutline',
  'mdiEyeOff',
  'mdiEyeOffOutline',
  'mdiEyeOutline',
  'mdiEyePlus',
  'mdiEyePlusOutline',
  'mdiEyeRefresh',
  'mdiEyeRefreshOutline',
  'mdiEyeRemove',
  'mdiEyeRemoveOutline',
  'mdiEyeSettings',
  'mdiEyeSettingsOutline',
  'mdiEyedropper',
  'mdiEyedropperMinus',
  'mdiEyedropperOff',
  'mdiEyedropperPlus',
  'mdiEyedropperRemove',
  'mdiEyedropperVariant',
  'mdiFaceAgent',
  'mdiFaceMan',
  'mdiFaceManOutline',
  'mdiFaceManProfile',
  'mdiFaceManShimmer',
  'mdiFaceManShimmerOutline',
  'mdiFaceMask',
  'mdiFaceMaskOutline',
  'mdiFaceRecognition',
  'mdiFaceWoman',
  'mdiFaceWomanOutline',
  'mdiFaceWomanProfile',
  'mdiFaceWomanShimmer',
  'mdiFaceWomanShimmerOutline',
  'mdiFacebook',
  'mdiFacebookGaming',
  'mdiFacebookMessenger',
  'mdiFacebookWorkplace',
  'mdiFactory',
  'mdiFamilyTree',
  'mdiFan',
  'mdiFanAlert',
  'mdiFanAuto',
  'mdiFanChevronDown',
  'mdiFanChevronUp',
  'mdiFanClock',
  'mdiFanMinus',
  'mdiFanOff',
  'mdiFanPlus',
  'mdiFanRemove',
  'mdiFanSpeed1',
  'mdiFanSpeed2',
  'mdiFanSpeed3',
  'mdiFastForward',
  'mdiFastForward10',
  'mdiFastForward15',
  'mdiFastForward30',
  'mdiFastForward45',
  'mdiFastForward5',
  'mdiFastForward60',
  'mdiFastForwardOutline',
  'mdiFaucet',
  'mdiFaucetVariant',
  'mdiFax',
  'mdiFeather',
  'mdiFeatureSearch',
  'mdiFeatureSearchOutline',
  'mdiFedora',
  'mdiFence',
  'mdiFenceElectric',
  'mdiFencing',
  'mdiFerrisWheel',
  'mdiFerry',
  'mdiFile',
  'mdiFileAccount',
  'mdiFileAccountOutline',
  'mdiFileAlert',
  'mdiFileAlertOutline',
  'mdiFileArrowLeftRight',
  'mdiFileArrowLeftRightOutline',
  'mdiFileArrowUpDown',
  'mdiFileArrowUpDownOutline',
  'mdiFileCabinet',
  'mdiFileCad',
  'mdiFileCadBox',
  'mdiFileCancel',
  'mdiFileCancelOutline',
  'mdiFileCertificate',
  'mdiFileCertificateOutline',
  'mdiFileChart',
  'mdiFileChartCheck',
  'mdiFileChartCheckOutline',
  'mdiFileChartOutline',
  'mdiFileCheck',
  'mdiFileCheckOutline',
  'mdiFileClock',
  'mdiFileClockOutline',
  'mdiFileCloud',
  'mdiFileCloudOutline',
  'mdiFileCode',
  'mdiFileCodeOutline',
  'mdiFileCog',
  'mdiFileCogOutline',
  'mdiFileCompare',
  'mdiFileDelimited',
  'mdiFileDelimitedOutline',
  'mdiFileDocument',
  'mdiFileDocumentAlert',
  'mdiFileDocumentAlertOutline',
  'mdiFileDocumentArrowRight',
  'mdiFileDocumentArrowRightOutline',
  'mdiFileDocumentCheck',
  'mdiFileDocumentCheckOutline',
  'mdiFileDocumentEdit',
  'mdiFileDocumentEditOutline',
  'mdiFileDocumentMinus',
  'mdiFileDocumentMinusOutline',
  'mdiFileDocumentMultiple',
  'mdiFileDocumentMultipleOutline',
  'mdiFileDocumentOutline',
  'mdiFileDocumentPlus',
  'mdiFileDocumentPlusOutline',
  'mdiFileDocumentRefresh',
  'mdiFileDocumentRefreshOutline',
  'mdiFileDocumentRemove',
  'mdiFileDocumentRemoveOutline',
  'mdiFileDownload',
  'mdiFileDownloadOutline',
  'mdiFileEdit',
  'mdiFileEditOutline',
  'mdiFileExcel',
  'mdiFileExcelBox',
  'mdiFileExcelBoxOutline',
  'mdiFileExcelOutline',
  'mdiFileExport',
  'mdiFileExportOutline',
  'mdiFileEye',
  'mdiFileEyeOutline',
  'mdiFileFind',
  'mdiFileFindOutline',
  'mdiFileGifBox',
  'mdiFileHidden',
  'mdiFileImage',
  'mdiFileImageMarker',
  'mdiFileImageMarkerOutline',
  'mdiFileImageMinus',
  'mdiFileImageMinusOutline',
  'mdiFileImageOutline',
  'mdiFileImagePlus',
  'mdiFileImagePlusOutline',
  'mdiFileImageRemove',
  'mdiFileImageRemoveOutline',
  'mdiFileImport',
  'mdiFileImportOutline',
  'mdiFileJpgBox',
  'mdiFileKey',
  'mdiFileKeyOutline',
  'mdiFileLink',
  'mdiFileLinkOutline',
  'mdiFileLock',
  'mdiFileLockOpen',
  'mdiFileLockOpenOutline',
  'mdiFileLockOutline',
  'mdiFileMarker',
  'mdiFileMarkerOutline',
  'mdiFileMinus',
  'mdiFileMinusOutline',
  'mdiFileMove',
  'mdiFileMoveOutline',
  'mdiFileMultiple',
  'mdiFileMultipleOutline',
  'mdiFileMusic',
  'mdiFileMusicOutline',
  'mdiFileOutline',
  'mdiFilePdfBox',
  'mdiFilePercent',
  'mdiFilePercentOutline',
  'mdiFilePhone',
  'mdiFilePhoneOutline',
  'mdiFilePlus',
  'mdiFilePlusOutline',
  'mdiFilePngBox',
  'mdiFilePowerpoint',
  'mdiFilePowerpointBox',
  'mdiFilePowerpointBoxOutline',
  'mdiFilePowerpointOutline',
  'mdiFilePresentationBox',
  'mdiFileQuestion',
  'mdiFileQuestionOutline',
  'mdiFileRefresh',
  'mdiFileRefreshOutline',
  'mdiFileRemove',
  'mdiFileRemoveOutline',
  'mdiFileReplace',
  'mdiFileReplaceOutline',
  'mdiFileRestore',
  'mdiFileRestoreOutline',
  'mdiFileRotateLeft',
  'mdiFileRotateLeftOutline',
  'mdiFileRotateRight',
  'mdiFileRotateRightOutline',
  'mdiFileSearch',
  'mdiFileSearchOutline',
  'mdiFileSend',
  'mdiFileSendOutline',
  'mdiFileSettings',
  'mdiFileSettingsOutline',
  'mdiFileSign',
  'mdiFileStar',
  'mdiFileStarFourPoints',
  'mdiFileStarFourPointsOutline',
  'mdiFileStarOutline',
  'mdiFileSwap',
  'mdiFileSwapOutline',
  'mdiFileSync',
  'mdiFileSyncOutline',
  'mdiFileTable',
  'mdiFileTableBox',
  'mdiFileTableBoxMultiple',
  'mdiFileTableBoxMultipleOutline',
  'mdiFileTableBoxOutline',
  'mdiFileTableOutline',
  'mdiFileTree',
  'mdiFileTreeOutline',
  'mdiFileUndo',
  'mdiFileUndoOutline',
  'mdiFileUpload',
  'mdiFileUploadOutline',
  'mdiFileVideo',
  'mdiFileVideoOutline',
  'mdiFileWord',
  'mdiFileWordBox',
  'mdiFileWordBoxOutline',
  'mdiFileWordOutline',
  'mdiFileXmlBox',
  'mdiFilm',
  'mdiFilmstrip',
  'mdiFilmstripBox',
  'mdiFilmstripBoxMultiple',
  'mdiFilmstripOff',
  'mdiFilter',
  'mdiFilterCheck',
  'mdiFilterCheckOutline',
  'mdiFilterCog',
  'mdiFilterCogOutline',
  'mdiFilterMenu',
  'mdiFilterMenuOutline',
  'mdiFilterMinus',
  'mdiFilterMinusOutline',
  'mdiFilterMultiple',
  'mdiFilterMultipleOutline',
  'mdiFilterOff',
  'mdiFilterOffOutline',
  'mdiFilterOutline',
  'mdiFilterPlus',
  'mdiFilterPlusOutline',
  'mdiFilterRemove',
  'mdiFilterRemoveOutline',
  'mdiFilterSettings',
  'mdiFilterSettingsOutline',
  'mdiFilterVariant',
  'mdiFilterVariantMinus',
  'mdiFilterVariantPlus',
  'mdiFilterVariantRemove',
  'mdiFinance',
  'mdiFindReplace',
  'mdiFingerprint',
  'mdiFingerprintOff',
  'mdiFire',
  'mdiFireAlert',
  'mdiFireCircle',
  'mdiFireExtinguisher',
  'mdiFireHydrant',
  'mdiFireHydrantAlert',
  'mdiFireHydrantOff',
  'mdiFireOff',
  'mdiFireStation',
  'mdiFireTruck',
  'mdiFirebase',
  'mdiFirefox',
  'mdiFireplace',
  'mdiFireplaceOff',
  'mdiFirewire',
  'mdiFirework',
  'mdiFireworkOff',
  'mdiFish',
  'mdiFishOff',
  'mdiFishbowl',
  'mdiFishbowlOutline',
  'mdiFitToPage',
  'mdiFitToPageOutline',
  'mdiFitToScreen',
  'mdiFitToScreenOutline',
  'mdiFlag',
  'mdiFlagCheckered',
  'mdiFlagMinus',
  'mdiFlagMinusOutline',
  'mdiFlagOff',
  'mdiFlagOffOutline',
  'mdiFlagOutline',
  'mdiFlagPlus',
  'mdiFlagPlusOutline',
  'mdiFlagRemove',
  'mdiFlagRemoveOutline',
  'mdiFlagTriangle',
  'mdiFlagVariant',
  'mdiFlagVariantMinus',
  'mdiFlagVariantMinusOutline',
  'mdiFlagVariantOff',
  'mdiFlagVariantOffOutline',
  'mdiFlagVariantOutline',
  'mdiFlagVariantPlus',
  'mdiFlagVariantPlusOutline',
  'mdiFlagVariantRemove',
  'mdiFlagVariantRemoveOutline',
  'mdiFlare',
  'mdiFlash',
  'mdiFlashAlert',
  'mdiFlashAlertOutline',
  'mdiFlashAuto',
  'mdiFlashOff',
  'mdiFlashOffOutline',
  'mdiFlashOutline',
  'mdiFlashRedEye',
  'mdiFlashTriangle',
  'mdiFlashTriangleOutline',
  'mdiFlashlight',
  'mdiFlashlightOff',
  'mdiFlask',
  'mdiFlaskEmpty',
  'mdiFlaskEmptyMinus',
  'mdiFlaskEmptyMinusOutline',
  'mdiFlaskEmptyOff',
  'mdiFlaskEmptyOffOutline',
  'mdiFlaskEmptyOutline',
  'mdiFlaskEmptyPlus',
  'mdiFlaskEmptyPlusOutline',
  'mdiFlaskEmptyRemove',
  'mdiFlaskEmptyRemoveOutline',
  'mdiFlaskMinus',
  'mdiFlaskMinusOutline',
  'mdiFlaskOff',
  'mdiFlaskOffOutline',
  'mdiFlaskOutline',
  'mdiFlaskPlus',
  'mdiFlaskPlusOutline',
  'mdiFlaskRemove',
  'mdiFlaskRemoveOutline',
  'mdiFlaskRoundBottom',
  'mdiFlaskRoundBottomEmpty',
  'mdiFlaskRoundBottomEmptyOutline',
  'mdiFlaskRoundBottomOutline',
  'mdiFleurDeLis',
  'mdiFlipHorizontal',
  'mdiFlipToBack',
  'mdiFlipToFront',
  'mdiFlipVertical',
  'mdiFloorLamp',
  'mdiFloorLampDual',
  'mdiFloorLampDualOutline',
  'mdiFloorLampOutline',
  'mdiFloorLampTorchiere',
  'mdiFloorLampTorchiereOutline',
  'mdiFloorLampTorchiereVariant',
  'mdiFloorLampTorchiereVariantOutline',
  'mdiFloorPlan',
  'mdiFloppy',
  'mdiFloppyVariant',
  'mdiFlower',
  'mdiFlowerOutline',
  'mdiFlowerPollen',
  'mdiFlowerPollenOutline',
  'mdiFlowerPoppy',
  'mdiFlowerTulip',
  'mdiFlowerTulipOutline',
  'mdiFocusAuto',
  'mdiFocusField',
  'mdiFocusFieldHorizontal',
  'mdiFocusFieldVertical',
  'mdiFolder',
  'mdiFolderAccount',
  'mdiFolderAccountOutline',
  'mdiFolderAlert',
  'mdiFolderAlertOutline',
  'mdiFolderArrowDown',
  'mdiFolderArrowDownOutline',
  'mdiFolderArrowLeft',
  'mdiFolderArrowLeftOutline',
  'mdiFolderArrowLeftRight',
  'mdiFolderArrowLeftRightOutline',
  'mdiFolderArrowRight',
  'mdiFolderArrowRightOutline',
  'mdiFolderArrowUp',
  'mdiFolderArrowUpDown',
  'mdiFolderArrowUpDownOutline',
  'mdiFolderArrowUpOutline',
  'mdiFolderCancel',
  'mdiFolderCancelOutline',
  'mdiFolderCheck',
  'mdiFolderCheckOutline',
  'mdiFolderClock',
  'mdiFolderClockOutline',
  'mdiFolderCog',
  'mdiFolderCogOutline',
  'mdiFolderDownload',
  'mdiFolderDownloadOutline',
  'mdiFolderEdit',
  'mdiFolderEditOutline',
  'mdiFolderEye',
  'mdiFolderEyeOutline',
  'mdiFolderFile',
  'mdiFolderFileOutline',
  'mdiFolderGoogleDrive',
  'mdiFolderHeart',
  'mdiFolderHeartOutline',
  'mdiFolderHidden',
  'mdiFolderHome',
  'mdiFolderHomeOutline',
  'mdiFolderImage',
  'mdiFolderInformation',
  'mdiFolderInformationOutline',
  'mdiFolderKey',
  'mdiFolderKeyNetwork',
  'mdiFolderKeyNetworkOutline',
  'mdiFolderKeyOutline',
  'mdiFolderLock',
  'mdiFolderLockOpen',
  'mdiFolderLockOpenOutline',
  'mdiFolderLockOutline',
  'mdiFolderMarker',
  'mdiFolderMarkerOutline',
  'mdiFolderMinus',
  'mdiFolderMinusOutline',
  'mdiFolderMove',
  'mdiFolderMoveOutline',
  'mdiFolderMultiple',
  'mdiFolderMultipleImage',
  'mdiFolderMultipleOutline',
  'mdiFolderMultiplePlus',
  'mdiFolderMultiplePlusOutline',
  'mdiFolderMusic',
  'mdiFolderMusicOutline',
  'mdiFolderNetwork',
  'mdiFolderNetworkOutline',
  'mdiFolderOff',
  'mdiFolderOffOutline',
  'mdiFolderOpen',
  'mdiFolderOpenOutline',
  'mdiFolderOutline',
  'mdiFolderPlay',
  'mdiFolderPlayOutline',
  'mdiFolderPlus',
  'mdiFolderPlusOutline',
  'mdiFolderPound',
  'mdiFolderPoundOutline',
  'mdiFolderQuestion',
  'mdiFolderQuestionOutline',
  'mdiFolderRefresh',
  'mdiFolderRefreshOutline',
  'mdiFolderRemove',
  'mdiFolderRemoveOutline',
  'mdiFolderSearch',
  'mdiFolderSearchOutline',
  'mdiFolderSettings',
  'mdiFolderSettingsOutline',
  'mdiFolderStar',
  'mdiFolderStarMultiple',
  'mdiFolderStarMultipleOutline',
  'mdiFolderStarOutline',
  'mdiFolderSwap',
  'mdiFolderSwapOutline',
  'mdiFolderSync',
  'mdiFolderSyncOutline',
  'mdiFolderTable',
  'mdiFolderTableOutline',
  'mdiFolderText',
  'mdiFolderTextOutline',
  'mdiFolderUpload',
  'mdiFolderUploadOutline',
  'mdiFolderWrench',
  'mdiFolderWrenchOutline',
  'mdiFolderZip',
  'mdiFolderZipOutline',
  'mdiFontAwesome',
  'mdiFood',
  'mdiFoodApple',
  'mdiFoodAppleOutline',
  'mdiFoodCroissant',
  'mdiFoodDrumstick',
  'mdiFoodDrumstickOff',
  'mdiFoodDrumstickOffOutline',
  'mdiFoodDrumstickOutline',
  'mdiFoodForkDrink',
  'mdiFoodHalal',
  'mdiFoodHotDog',
  'mdiFoodKosher',
  'mdiFoodOff',
  'mdiFoodOffOutline',
  'mdiFoodOutline',
  'mdiFoodSteak',
  'mdiFoodSteakOff',
  'mdiFoodTakeoutBox',
  'mdiFoodTakeoutBoxOutline',
  'mdiFoodTurkey',
  'mdiFoodVariant',
  'mdiFoodVariantOff',
  'mdiFootPrint',
  'mdiFootball',
  'mdiFootballAustralian',
  'mdiFootballHelmet',
  'mdiForest',
  'mdiForestOutline',
  'mdiForklift',
  'mdiFormDropdown',
  'mdiFormSelect',
  'mdiFormTextarea',
  'mdiFormTextbox',
  'mdiFormTextboxLock',
  'mdiFormTextboxPassword',
  'mdiFormatAlignBottom',
  'mdiFormatAlignCenter',
  'mdiFormatAlignJustify',
  'mdiFormatAlignLeft',
  'mdiFormatAlignMiddle',
  'mdiFormatAlignRight',
  'mdiFormatAlignTop',
  'mdiFormatAnnotationMinus',
  'mdiFormatAnnotationPlus',
  'mdiFormatBold',
  'mdiFormatClear',
  'mdiFormatColorFill',
  'mdiFormatColorHighlight',
  'mdiFormatColorMarkerCancel',
  'mdiFormatColorText',
  'mdiFormatColumns',
  'mdiFormatFloatCenter',
  'mdiFormatFloatLeft',
  'mdiFormatFloatNone',
  'mdiFormatFloatRight',
  'mdiFormatFont',
  'mdiFormatFontSizeDecrease',
  'mdiFormatFontSizeIncrease',
  'mdiFormatHeader1',
  'mdiFormatHeader2',
  'mdiFormatHeader3',
  'mdiFormatHeader4',
  'mdiFormatHeader5',
  'mdiFormatHeader6',
  'mdiFormatHeaderDecrease',
  'mdiFormatHeaderEqual',
  'mdiFormatHeaderIncrease',
  'mdiFormatHeaderPound',
  'mdiFormatHorizontalAlignCenter',
  'mdiFormatHorizontalAlignLeft',
  'mdiFormatHorizontalAlignRight',
  'mdiFormatIndentDecrease',
  'mdiFormatIndentIncrease',
  'mdiFormatItalic',
  'mdiFormatLetterCase',
  'mdiFormatLetterCaseLower',
  'mdiFormatLetterCaseUpper',
  'mdiFormatLetterEndsWith',
  'mdiFormatLetterMatches',
  'mdiFormatLetterSpacing',
  'mdiFormatLetterSpacingVariant',
  'mdiFormatLetterStartsWith',
  'mdiFormatLineHeight',
  'mdiFormatLineSpacing',
  'mdiFormatLineStyle',
  'mdiFormatLineWeight',
  'mdiFormatListBulleted',
  'mdiFormatListBulletedSquare',
  'mdiFormatListBulletedTriangle',
  'mdiFormatListBulletedType',
  'mdiFormatListCheckbox',
  'mdiFormatListChecks',
  'mdiFormatListGroup',
  'mdiFormatListGroupPlus',
  'mdiFormatListNumbered',
  'mdiFormatListNumberedRtl',
  'mdiFormatListText',
  'mdiFormatOverline',
  'mdiFormatPageBreak',
  'mdiFormatPageSplit',
  'mdiFormatPaint',
  'mdiFormatParagraph',
  'mdiFormatParagraphSpacing',
  'mdiFormatPilcrow',
  'mdiFormatPilcrowArrowLeft',
  'mdiFormatPilcrowArrowRight',
  'mdiFormatQuoteClose',
  'mdiFormatQuoteCloseOutline',
  'mdiFormatQuoteOpen',
  'mdiFormatQuoteOpenOutline',
  'mdiFormatRotate90',
  'mdiFormatSection',
  'mdiFormatSize',
  'mdiFormatStrikethrough',
  'mdiFormatStrikethroughVariant',
  'mdiFormatSubscript',
  'mdiFormatSuperscript',
  'mdiFormatText',
  'mdiFormatTextRotationAngleDown',
  'mdiFormatTextRotationAngleUp',
  'mdiFormatTextRotationDown',
  'mdiFormatTextRotationDownVertical',
  'mdiFormatTextRotationNone',
  'mdiFormatTextRotationUp',
  'mdiFormatTextRotationVertical',
  'mdiFormatTextVariant',
  'mdiFormatTextVariantOutline',
  'mdiFormatTextWrappingClip',
  'mdiFormatTextWrappingOverflow',
  'mdiFormatTextWrappingWrap',
  'mdiFormatTextbox',
  'mdiFormatTitle',
  'mdiFormatUnderline',
  'mdiFormatUnderlineWavy',
  'mdiFormatVerticalAlignBottom',
  'mdiFormatVerticalAlignCenter',
  'mdiFormatVerticalAlignTop',
  'mdiFormatWrapInline',
  'mdiFormatWrapSquare',
  'mdiFormatWrapTight',
  'mdiFormatWrapTopBottom',
  'mdiForum',
  'mdiForumMinus',
  'mdiForumMinusOutline',
  'mdiForumOutline',
  'mdiForumPlus',
  'mdiForumPlusOutline',
  'mdiForumRemove',
  'mdiForumRemoveOutline',
  'mdiForward',
  'mdiForwardburger',
  'mdiFountain',
  'mdiFountainPen',
  'mdiFountainPenTip',
  'mdiFractionOneHalf',
  'mdiFreebsd',
  'mdiFrenchFries',
  'mdiFrequentlyAskedQuestions',
  'mdiFridge',
  'mdiFridgeAlert',
  'mdiFridgeAlertOutline',
  'mdiFridgeBottom',
  'mdiFridgeIndustrial',
  'mdiFridgeIndustrialAlert',
  'mdiFridgeIndustrialAlertOutline',
  'mdiFridgeIndustrialOff',
  'mdiFridgeIndustrialOffOutline',
  'mdiFridgeIndustrialOutline',
  'mdiFridgeOff',
  'mdiFridgeOffOutline',
  'mdiFridgeOutline',
  'mdiFridgeTop',
  'mdiFridgeVariant',
  'mdiFridgeVariantAlert',
  'mdiFridgeVariantAlertOutline',
  'mdiFridgeVariantOff',
  'mdiFridgeVariantOffOutline',
  'mdiFridgeVariantOutline',
  'mdiFruitCherries',
  'mdiFruitCherriesOff',
  'mdiFruitCitrus',
  'mdiFruitCitrusOff',
  'mdiFruitGrapes',
  'mdiFruitGrapesOutline',
  'mdiFruitPear',
  'mdiFruitPineapple',
  'mdiFruitWatermelon',
  'mdiFuel',
  'mdiFuelCell',
  'mdiFullscreen',
  'mdiFullscreenExit',
  'mdiFunction',
  'mdiFunctionVariant',
  'mdiFuriganaHorizontal',
  'mdiFuriganaVertical',
  'mdiFuse',
  'mdiFuseAlert',
  'mdiFuseBlade',
  'mdiFuseOff',
  'mdiGamepad',
  'mdiGamepadCircle',
  'mdiGamepadCircleDown',
  'mdiGamepadCircleLeft',
  'mdiGamepadCircleOutline',
  'mdiGamepadCircleRight',
  'mdiGamepadCircleUp',
  'mdiGamepadDown',
  'mdiGamepadLeft',
  'mdiGamepadOutline',
  'mdiGamepadRight',
  'mdiGamepadRound',
  'mdiGamepadRoundDown',
  'mdiGamepadRoundLeft',
  'mdiGamepadRoundOutline',
  'mdiGamepadRoundRight',
  'mdiGamepadRoundUp',
  'mdiGamepadSquare',
  'mdiGamepadSquareOutline',
  'mdiGamepadUp',
  'mdiGamepadVariant',
  'mdiGamepadVariantOutline',
  'mdiGamma',
  'mdiGantryCrane',
  'mdiGarage',
  'mdiGarageAlert',
  'mdiGarageAlertVariant',
  'mdiGarageLock',
  'mdiGarageOpen',
  'mdiGarageOpenVariant',
  'mdiGarageVariant',
  'mdiGarageVariantLock',
  'mdiGasBurner',
  'mdiGasCylinder',
  'mdiGasStation',
  'mdiGasStationInUse',
  'mdiGasStationInUseOutline',
  'mdiGasStationOff',
  'mdiGasStationOffOutline',
  'mdiGasStationOutline',
  'mdiGate',
  'mdiGateAlert',
  'mdiGateAnd',
  'mdiGateArrowLeft',
  'mdiGateArrowRight',
  'mdiGateBuffer',
  'mdiGateNand',
  'mdiGateNor',
  'mdiGateNot',
  'mdiGateOpen',
  'mdiGateOr',
  'mdiGateXnor',
  'mdiGateXor',
  'mdiGatsby',
  'mdiGauge',
  'mdiGaugeEmpty',
  'mdiGaugeFull',
  'mdiGaugeLow',
  'mdiGavel',
  'mdiGenderFemale',
  'mdiGenderMale',
  'mdiGenderMaleFemale',
  'mdiGenderMaleFemaleVariant',
  'mdiGenderNonBinary',
  'mdiGenderTransgender',
  'mdiGeneratorMobile',
  'mdiGeneratorPortable',
  'mdiGeneratorStationary',
  'mdiGentoo',
  'mdiGesture',
  'mdiGestureDoubleTap',
  'mdiGesturePinch',
  'mdiGestureSpread',
  'mdiGestureSwipe',
  'mdiGestureSwipeDown',
  'mdiGestureSwipeHorizontal',
  'mdiGestureSwipeLeft',
  'mdiGestureSwipeRight',
  'mdiGestureSwipeUp',
  'mdiGestureSwipeVertical',
  'mdiGestureTap',
  'mdiGestureTapBox',
  'mdiGestureTapButton',
  'mdiGestureTapHold',
  'mdiGestureTwoDoubleTap',
  'mdiGestureTwoTap',
  'mdiGhost',
  'mdiGhostOff',
  'mdiGhostOffOutline',
  'mdiGhostOutline',
  'mdiGift',
  'mdiGiftOff',
  'mdiGiftOffOutline',
  'mdiGiftOpen',
  'mdiGiftOpenOutline',
  'mdiGiftOutline',
  'mdiGit',
  'mdiGithub',
  'mdiGitlab',
  'mdiGlassCocktail',
  'mdiGlassCocktailOff',
  'mdiGlassFlute',
  'mdiGlassFragile',
  'mdiGlassMug',
  'mdiGlassMugOff',
  'mdiGlassMugVariant',
  'mdiGlassMugVariantOff',
  'mdiGlassPintOutline',
  'mdiGlassStange',
  'mdiGlassTulip',
  'mdiGlassWine',
  'mdiGlasses',
  'mdiGlobeLight',
  'mdiGlobeLightOutline',
  'mdiGlobeModel',
  'mdiGmail',
  'mdiGnome',
  'mdiGoKart',
  'mdiGoKartTrack',
  'mdiGog',
  'mdiGold',
  'mdiGolf',
  'mdiGolfCart',
  'mdiGolfTee',
  'mdiGondola',
  'mdiGoodreads',
  'mdiGoogle',
  'mdiGoogleAds',
  'mdiGoogleAnalytics',
  'mdiGoogleAssistant',
  'mdiGoogleCardboard',
  'mdiGoogleChrome',
  'mdiGoogleCircles',
  'mdiGoogleCirclesCommunities',
  'mdiGoogleCirclesExtended',
  'mdiGoogleCirclesGroup',
  'mdiGoogleClassroom',
  'mdiGoogleCloud',
  'mdiGoogleDownasaur',
  'mdiGoogleDrive',
  'mdiGoogleEarth',
  'mdiGoogleFit',
  'mdiGoogleGlass',
  'mdiGoogleHangouts',
  'mdiGoogleKeep',
  'mdiGoogleLens',
  'mdiGoogleMaps',
  'mdiGoogleMyBusiness',
  'mdiGoogleNearby',
  'mdiGooglePlay',
  'mdiGooglePlus',
  'mdiGooglePodcast',
  'mdiGoogleSpreadsheet',
  'mdiGoogleStreetView',
  'mdiGoogleTranslate',
  'mdiGradientHorizontal',
  'mdiGradientVertical',
  'mdiGrain',
  'mdiGraph',
  'mdiGraphOutline',
  'mdiGraphql',
  'mdiGrass',
  'mdiGraveStone',
  'mdiGreasePencil',
  'mdiGreaterThan',
  'mdiGreaterThanOrEqual',
  'mdiGreenhouse',
  'mdiGrid',
  'mdiGridLarge',
  'mdiGridOff',
  'mdiGrill',
  'mdiGrillOutline',
  'mdiGroup',
  'mdiGuitarAcoustic',
  'mdiGuitarElectric',
  'mdiGuitarPick',
  'mdiGuitarPickOutline',
  'mdiGuyFawkesMask',
  'mdiGymnastics',
  'mdiHail',
  'mdiHairDryer',
  'mdiHairDryerOutline',
  'mdiHalloween',
  'mdiHamburger',
  'mdiHamburgerCheck',
  'mdiHamburgerMinus',
  'mdiHamburgerOff',
  'mdiHamburgerPlus',
  'mdiHamburgerRemove',
  'mdiHammer',
  'mdiHammerScrewdriver',
  'mdiHammerSickle',
  'mdiHammerWrench',
  'mdiHandBackLeft',
  'mdiHandBackLeftOff',
  'mdiHandBackLeftOffOutline',
  'mdiHandBackLeftOutline',
  'mdiHandBackRight',
  'mdiHandBackRightOff',
  'mdiHandBackRightOffOutline',
  'mdiHandBackRightOutline',
  'mdiHandClap',
  'mdiHandClapOff',
  'mdiHandCoin',
  'mdiHandCoinOutline',
  'mdiHandCycle',
  'mdiHandExtended',
  'mdiHandExtendedOutline',
  'mdiHandFrontLeft',
  'mdiHandFrontLeftOutline',
  'mdiHandFrontRight',
  'mdiHandFrontRightOutline',
  'mdiHandHeart',
  'mdiHandHeartOutline',
  'mdiHandOkay',
  'mdiHandPeace',
  'mdiHandPeaceVariant',
  'mdiHandPointingDown',
  'mdiHandPointingLeft',
  'mdiHandPointingRight',
  'mdiHandPointingUp',
  'mdiHandSaw',
  'mdiHandWash',
  'mdiHandWashOutline',
  'mdiHandWater',
  'mdiHandWave',
  'mdiHandWaveOutline',
  'mdiHandball',
  'mdiHandcuffs',
  'mdiHandsPray',
  'mdiHandshake',
  'mdiHandshakeOutline',
  'mdiHanger',
  'mdiHardHat',
  'mdiHarddisk',
  'mdiHarddiskPlus',
  'mdiHarddiskRemove',
  'mdiHatFedora',
  'mdiHazardLights',
  'mdiHdmiPort',
  'mdiHdr',
  'mdiHdrOff',
  'mdiHead',
  'mdiHeadAlert',
  'mdiHeadAlertOutline',
  'mdiHeadCheck',
  'mdiHeadCheckOutline',
  'mdiHeadCog',
  'mdiHeadCogOutline',
  'mdiHeadDotsHorizontal',
  'mdiHeadDotsHorizontalOutline',
  'mdiHeadFlash',
  'mdiHeadFlashOutline',
  'mdiHeadHeart',
  'mdiHeadHeartOutline',
  'mdiHeadLightbulb',
  'mdiHeadLightbulbOutline',
  'mdiHeadMinus',
  'mdiHeadMinusOutline',
  'mdiHeadOutline',
  'mdiHeadPlus',
  'mdiHeadPlusOutline',
  'mdiHeadQuestion',
  'mdiHeadQuestionOutline',
  'mdiHeadRemove',
  'mdiHeadRemoveOutline',
  'mdiHeadSnowflake',
  'mdiHeadSnowflakeOutline',
  'mdiHeadSync',
  'mdiHeadSyncOutline',
  'mdiHeadphones',
  'mdiHeadphonesBluetooth',
  'mdiHeadphonesBox',
  'mdiHeadphonesOff',
  'mdiHeadphonesSettings',
  'mdiHeadset',
  'mdiHeadsetDock',
  'mdiHeadsetOff',
  'mdiHeart',
  'mdiHeartBox',
  'mdiHeartBoxOutline',
  'mdiHeartBroken',
  'mdiHeartBrokenOutline',
  'mdiHeartCircle',
  'mdiHeartCircleOutline',
  'mdiHeartCog',
  'mdiHeartCogOutline',
  'mdiHeartFlash',
  'mdiHeartHalf',
  'mdiHeartHalfFull',
  'mdiHeartHalfOutline',
  'mdiHeartMinus',
  'mdiHeartMinusOutline',
  'mdiHeartMultiple',
  'mdiHeartMultipleOutline',
  'mdiHeartOff',
  'mdiHeartOffOutline',
  'mdiHeartOutline',
  'mdiHeartPlus',
  'mdiHeartPlusOutline',
  'mdiHeartPulse',
  'mdiHeartRemove',
  'mdiHeartRemoveOutline',
  'mdiHeartSearch',
  'mdiHeartSettings',
  'mdiHeartSettingsOutline',
  'mdiHeatPump',
  'mdiHeatPumpOutline',
  'mdiHeatWave',
  'mdiHeatingCoil',
  'mdiHelicopter',
  'mdiHelp',
  'mdiHelpBox',
  'mdiHelpBoxMultiple',
  'mdiHelpBoxMultipleOutline',
  'mdiHelpBoxOutline',
  'mdiHelpCircle',
  'mdiHelpCircleOutline',
  'mdiHelpNetwork',
  'mdiHelpNetworkOutline',
  'mdiHelpRhombus',
  'mdiHelpRhombusOutline',
  'mdiHexadecimal',
  'mdiHexagon',
  'mdiHexagonMultiple',
  'mdiHexagonMultipleOutline',
  'mdiHexagonOutline',
  'mdiHexagonSlice1',
  'mdiHexagonSlice2',
  'mdiHexagonSlice3',
  'mdiHexagonSlice4',
  'mdiHexagonSlice5',
  'mdiHexagonSlice6',
  'mdiHexagram',
  'mdiHexagramOutline',
  'mdiHighDefinition',
  'mdiHighDefinitionBox',
  'mdiHighway',
  'mdiHiking',
  'mdiHistory',
  'mdiHockeyPuck',
  'mdiHockeySticks',
  'mdiHololens',
  'mdiHome',
  'mdiHomeAccount',
  'mdiHomeAlert',
  'mdiHomeAlertOutline',
  'mdiHomeAnalytics',
  'mdiHomeAssistant',
  'mdiHomeAutomation',
  'mdiHomeBattery',
  'mdiHomeBatteryOutline',
  'mdiHomeCircle',
  'mdiHomeCircleOutline',
  'mdiHomeCity',
  'mdiHomeCityOutline',
  'mdiHomeClock',
  'mdiHomeClockOutline',
  'mdiHomeEdit',
  'mdiHomeEditOutline',
  'mdiHomeExportOutline',
  'mdiHomeFlood',
  'mdiHomeFloor0',
  'mdiHomeFloor1',
  'mdiHomeFloor2',
  'mdiHomeFloor3',
  'mdiHomeFloorA',
  'mdiHomeFloorB',
  'mdiHomeFloorG',
  'mdiHomeFloorL',
  'mdiHomeFloorNegative1',
  'mdiHomeGroup',
  'mdiHomeGroupMinus',
  'mdiHomeGroupPlus',
  'mdiHomeGroupRemove',
  'mdiHomeHeart',
  'mdiHomeImportOutline',
  'mdiHomeLightbulb',
  'mdiHomeLightbulbOutline',
  'mdiHomeLightningBolt',
  'mdiHomeLightningBoltOutline',
  'mdiHomeLock',
  'mdiHomeLockOpen',
  'mdiHomeMapMarker',
  'mdiHomeMinus',
  'mdiHomeMinusOutline',
  'mdiHomeModern',
  'mdiHomeOff',
  'mdiHomeOffOutline',
  'mdiHomeOutline',
  'mdiHomePercent',
  'mdiHomePercentOutline',
  'mdiHomePlus',
  'mdiHomePlusOutline',
  'mdiHomeRemove',
  'mdiHomeRemoveOutline',
  'mdiHomeRoof',
  'mdiHomeSearch',
  'mdiHomeSearchOutline',
  'mdiHomeSilo',
  'mdiHomeSiloOutline',
  'mdiHomeSoundIn',
  'mdiHomeSoundInOutline',
  'mdiHomeSoundOut',
  'mdiHomeSoundOutOutline',
  'mdiHomeSwitch',
  'mdiHomeSwitchOutline',
  'mdiHomeThermometer',
  'mdiHomeThermometerOutline',
  'mdiHomeVariant',
  'mdiHomeVariantOutline',
  'mdiHook',
  'mdiHookOff',
  'mdiHoopHouse',
  'mdiHops',
  'mdiHorizontalRotateClockwise',
  'mdiHorizontalRotateCounterclockwise',
  'mdiHorse',
  'mdiHorseHuman',
  'mdiHorseVariant',
  'mdiHorseVariantFast',
  'mdiHorseshoe',
  'mdiHospital',
  'mdiHospitalBox',
  'mdiHospitalBoxOutline',
  'mdiHospitalBuilding',
  'mdiHospitalMarker',
  'mdiHotTub',
  'mdiHours12',
  'mdiHours24',
  'mdiHub',
  'mdiHubOutline',
  'mdiHubspot',
  'mdiHulu',
  'mdiHuman',
  'mdiHumanBabyChangingTable',
  'mdiHumanCane',
  'mdiHumanCapacityDecrease',
  'mdiHumanCapacityIncrease',
  'mdiHumanChild',
  'mdiHumanDolly',
  'mdiHumanEdit',
  'mdiHumanFemale',
  'mdiHumanFemaleBoy',
  'mdiHumanFemaleDance',
  'mdiHumanFemaleFemale',
  'mdiHumanFemaleFemaleChild',
  'mdiHumanFemaleGirl',
  'mdiHumanGreeting',
  'mdiHumanGreetingProximity',
  'mdiHumanGreetingVariant',
  'mdiHumanHandsdown',
  'mdiHumanHandsup',
  'mdiHumanMale',
  'mdiHumanMaleBoard',
  'mdiHumanMaleBoardPoll',
  'mdiHumanMaleBoy',
  'mdiHumanMaleChild',
  'mdiHumanMaleFemale',
  'mdiHumanMaleFemaleChild',
  'mdiHumanMaleGirl',
  'mdiHumanMaleHeight',
  'mdiHumanMaleHeightVariant',
  'mdiHumanMaleMale',
  'mdiHumanMaleMaleChild',
  'mdiHumanNonBinary',
  'mdiHumanPregnant',
  'mdiHumanQueue',
  'mdiHumanScooter',
  'mdiHumanWalker',
  'mdiHumanWheelchair',
  'mdiHumanWhiteCane',
  'mdiHumbleBundle',
  'mdiHvac',
  'mdiHvacOff',
  'mdiHydraulicOilLevel',
  'mdiHydraulicOilTemperature',
  'mdiHydroPower',
  'mdiHydrogenStation',
  'mdiIceCream',
  'mdiIceCreamOff',
  'mdiIcePop',
  'mdiIdCard',
  'mdiIdentifier',
  'mdiIdeogramCjk',
  'mdiIdeogramCjkVariant',
  'mdiImage',
  'mdiImageAlbum',
  'mdiImageArea',
  'mdiImageAreaClose',
  'mdiImageAutoAdjust',
  'mdiImageBroken',
  'mdiImageBrokenVariant',
  'mdiImageCheck',
  'mdiImageCheckOutline',
  'mdiImageEdit',
  'mdiImageEditOutline',
  'mdiImageFilterBlackWhite',
  'mdiImageFilterCenterFocus',
  'mdiImageFilterCenterFocusStrong',
  'mdiImageFilterCenterFocusStrongOutline',
  'mdiImageFilterCenterFocusWeak',
  'mdiImageFilterDrama',
  'mdiImageFilterDramaOutline',
  'mdiImageFilterFrames',
  'mdiImageFilterHdr',
  'mdiImageFilterHdrOutline',
  'mdiImageFilterNone',
  'mdiImageFilterTiltShift',
  'mdiImageFilterVintage',
  'mdiImageFrame',
  'mdiImageLock',
  'mdiImageLockOutline',
  'mdiImageMarker',
  'mdiImageMarkerOutline',
  'mdiImageMinus',
  'mdiImageMinusOutline',
  'mdiImageMove',
  'mdiImageMultiple',
  'mdiImageMultipleOutline',
  'mdiImageOff',
  'mdiImageOffOutline',
  'mdiImageOutline',
  'mdiImagePlus',
  'mdiImagePlusOutline',
  'mdiImageRefresh',
  'mdiImageRefreshOutline',
  'mdiImageRemove',
  'mdiImageRemoveOutline',
  'mdiImageSearch',
  'mdiImageSearchOutline',
  'mdiImageSizeSelectActual',
  'mdiImageSizeSelectLarge',
  'mdiImageSizeSelectSmall',
  'mdiImageSync',
  'mdiImageSyncOutline',
  'mdiImageText',
  'mdiImport',
  'mdiInbox',
  'mdiInboxArrowDown',
  'mdiInboxArrowDownOutline',
  'mdiInboxArrowUp',
  'mdiInboxArrowUpOutline',
  'mdiInboxFull',
  'mdiInboxFullOutline',
  'mdiInboxMultiple',
  'mdiInboxMultipleOutline',
  'mdiInboxOutline',
  'mdiInboxRemove',
  'mdiInboxRemoveOutline',
  'mdiIncognito',
  'mdiIncognitoCircle',
  'mdiIncognitoCircleOff',
  'mdiIncognitoOff',
  'mdiInduction',
  'mdiInfinity',
  'mdiInformation',
  'mdiInformationBox',
  'mdiInformationBoxOutline',
  'mdiInformationOff',
  'mdiInformationOffOutline',
  'mdiInformationOutline',
  'mdiInformationSlabBox',
  'mdiInformationSlabBoxOutline',
  'mdiInformationSlabCircle',
  'mdiInformationSlabCircleOutline',
  'mdiInformationSlabSymbol',
  'mdiInformationSymbol',
  'mdiInformationVariant',
  'mdiInformationVariantBox',
  'mdiInformationVariantBoxOutline',
  'mdiInformationVariantCircle',
  'mdiInformationVariantCircleOutline',
  'mdiInstagram',
  'mdiInstrumentTriangle',
  'mdiIntegratedCircuitChip',
  'mdiInvertColors',
  'mdiInvertColorsOff',
  'mdiInvoice',
  'mdiInvoiceArrowLeft',
  'mdiInvoiceArrowLeftOutline',
  'mdiInvoiceArrowRight',
  'mdiInvoiceArrowRightOutline',
  'mdiInvoiceCheck',
  'mdiInvoiceCheckOutline',
  'mdiInvoiceClock',
  'mdiInvoiceClockOutline',
  'mdiInvoiceEdit',
  'mdiInvoiceEditOutline',
  'mdiInvoiceExportOutline',
  'mdiInvoiceFast',
  'mdiInvoiceFastOutline',
  'mdiInvoiceImport',
  'mdiInvoiceImportOutline',
  'mdiInvoiceList',
  'mdiInvoiceListOutline',
  'mdiInvoiceMinus',
  'mdiInvoiceMinusOutline',
  'mdiInvoiceMultiple',
  'mdiInvoiceMultipleOutline',
  'mdiInvoiceOutline',
  'mdiInvoicePlus',
  'mdiInvoicePlusOutline',
  'mdiInvoiceRemove',
  'mdiInvoiceRemoveOutline',
  'mdiInvoiceSend',
  'mdiInvoiceSendOutline',
  'mdiInvoiceText',
  'mdiInvoiceTextArrowLeft',
  'mdiInvoiceTextArrowLeftOutline',
  'mdiInvoiceTextArrowRight',
  'mdiInvoiceTextArrowRightOutline',
  'mdiInvoiceTextCheck',
  'mdiInvoiceTextCheckOutline',
  'mdiInvoiceTextClock',
  'mdiInvoiceTextClockOutline',
  'mdiInvoiceTextEdit',
  'mdiInvoiceTextEditOutline',
  'mdiInvoiceTextFast',
  'mdiInvoiceTextFastOutline',
  'mdiInvoiceTextMinus',
  'mdiInvoiceTextMinusOutline',
  'mdiInvoiceTextMultiple',
  'mdiInvoiceTextMultipleOutline',
  'mdiInvoiceTextOutline',
  'mdiInvoiceTextPlus',
  'mdiInvoiceTextPlusOutline',
  'mdiInvoiceTextRemove',
  'mdiInvoiceTextRemoveOutline',
  'mdiInvoiceTextSend',
  'mdiInvoiceTextSendOutline',
  'mdiIobroker',
  'mdiIp',
  'mdiIpNetwork',
  'mdiIpNetworkOutline',
  'mdiIpOutline',
  'mdiIpod',
  'mdiIron',
  'mdiIronBoard',
  'mdiIronOutline',
  'mdiIsland',
  'mdiIslandVariant',
  'mdiIvBag',
  'mdiJabber',
  'mdiJeepney',
  'mdiJellyfish',
  'mdiJellyfishOutline',
  'mdiJira',
  'mdiJquery',
  'mdiJsfiddle',
  'mdiJumpRope',
  'mdiKabaddi',
  'mdiKangaroo',
  'mdiKarate',
  'mdiKayaking',
  'mdiKeg',
  'mdiKettle',
  'mdiKettleAlert',
  'mdiKettleAlertOutline',
  'mdiKettleOff',
  'mdiKettleOffOutline',
  'mdiKettleOutline',
  'mdiKettlePourOver',
  'mdiKettleSteam',
  'mdiKettleSteamOutline',
  'mdiKettlebell',
  'mdiKey',
  'mdiKeyAlert',
  'mdiKeyAlertOutline',
  'mdiKeyArrowRight',
  'mdiKeyChain',
  'mdiKeyChainVariant',
  'mdiKeyChange',
  'mdiKeyLink',
  'mdiKeyMinus',
  'mdiKeyOutline',
  'mdiKeyPlus',
  'mdiKeyRemove',
  'mdiKeyStar',
  'mdiKeyVariant',
  'mdiKeyWireless',
  'mdiKeyboard',
  'mdiKeyboardBackspace',
  'mdiKeyboardCaps',
  'mdiKeyboardClose',
  'mdiKeyboardCloseOutline',
  'mdiKeyboardEsc',
  'mdiKeyboardF1',
  'mdiKeyboardF10',
  'mdiKeyboardF11',
  'mdiKeyboardF12',
  'mdiKeyboardF2',
  'mdiKeyboardF3',
  'mdiKeyboardF4',
  'mdiKeyboardF5',
  'mdiKeyboardF6',
  'mdiKeyboardF7',
  'mdiKeyboardF8',
  'mdiKeyboardF9',
  'mdiKeyboardOff',
  'mdiKeyboardOffOutline',
  'mdiKeyboardOutline',
  'mdiKeyboardReturn',
  'mdiKeyboardSettings',
  'mdiKeyboardSettingsOutline',
  'mdiKeyboardSpace',
  'mdiKeyboardTab',
  'mdiKeyboardTabReverse',
  'mdiKeyboardVariant',
  'mdiKhanda',
  'mdiKickstarter',
  'mdiKite',
  'mdiKiteOutline',
  'mdiKitesurfing',
  'mdiKlingon',
  'mdiKnife',
  'mdiKnifeMilitary',
  'mdiKnob',
  'mdiKoala',
  'mdiKodi',
  'mdiKubernetes',
  'mdiLabel',
  'mdiLabelMultiple',
  'mdiLabelMultipleOutline',
  'mdiLabelOff',
  'mdiLabelOffOutline',
  'mdiLabelOutline',
  'mdiLabelPercent',
  'mdiLabelPercentOutline',
  'mdiLabelVariant',
  'mdiLabelVariantOutline',
  'mdiLadder',
  'mdiLadybug',
  'mdiLambda',
  'mdiLamp',
  'mdiLampOutline',
  'mdiLamps',
  'mdiLampsOutline',
  'mdiLan',
  'mdiLanCheck',
  'mdiLanConnect',
  'mdiLanDisconnect',
  'mdiLanPending',
  'mdiLandFields',
  'mdiLandPlots',
  'mdiLandPlotsCircle',
  'mdiLandPlotsCircleVariant',
  'mdiLandPlotsMarker',
  'mdiLandRowsHorizontal',
  'mdiLandRowsVertical',
  'mdiLandslide',
  'mdiLandslideOutline',
  'mdiLanguageC',
  'mdiLanguageCpp',
  'mdiLanguageCsharp',
  'mdiLanguageCss3',
  'mdiLanguageFortran',
  'mdiLanguageGo',
  'mdiLanguageHaskell',
  'mdiLanguageHtml5',
  'mdiLanguageJava',
  'mdiLanguageJavascript',
  'mdiLanguageKotlin',
  'mdiLanguageLua',
  'mdiLanguageMarkdown',
  'mdiLanguageMarkdownOutline',
  'mdiLanguagePhp',
  'mdiLanguagePython',
  'mdiLanguageR',
  'mdiLanguageRuby',
  'mdiLanguageRubyOnRails',
  'mdiLanguageRust',
  'mdiLanguageSwift',
  'mdiLanguageTypescript',
  'mdiLanguageXaml',
  'mdiLaptop',
  'mdiLaptopAccount',
  'mdiLaptopOff',
  'mdiLaravel',
  'mdiLaserPointer',
  'mdiLasso',
  'mdiLastpass',
  'mdiLatitude',
  'mdiLaunch',
  'mdiLavaLamp',
  'mdiLayers',
  'mdiLayersEdit',
  'mdiLayersMinus',
  'mdiLayersOff',
  'mdiLayersOffOutline',
  'mdiLayersOutline',
  'mdiLayersPlus',
  'mdiLayersRemove',
  'mdiLayersSearch',
  'mdiLayersSearchOutline',
  'mdiLayersTriple',
  'mdiLayersTripleOutline',
  'mdiLeadPencil',
  'mdiLeaf',
  'mdiLeafCircle',
  'mdiLeafCircleOutline',
  'mdiLeafMaple',
  'mdiLeafMapleOff',
  'mdiLeafOff',
  'mdiLeak',
  'mdiLeakOff',
  'mdiLectern',
  'mdiLedOff',
  'mdiLedOn',
  'mdiLedOutline',
  'mdiLedStrip',
  'mdiLedStripVariant',
  'mdiLedStripVariantOff',
  'mdiLedVariantOff',
  'mdiLedVariantOn',
  'mdiLedVariantOutline',
  'mdiLeek',
  'mdiLessThan',
  'mdiLessThanOrEqual',
  'mdiLibrary',
  'mdiLibraryOutline',
  'mdiLibraryShelves',
  'mdiLicense',
  'mdiLifebuoy',
  'mdiLightFloodDown',
  'mdiLightFloodUp',
  'mdiLightRecessed',
  'mdiLightSwitch',
  'mdiLightSwitchOff',
  'mdiLightbulb',
  'mdiLightbulbAlert',
  'mdiLightbulbAlertOutline',
  'mdiLightbulbAuto',
  'mdiLightbulbAutoOutline',
  'mdiLightbulbCfl',
  'mdiLightbulbCflOff',
  'mdiLightbulbCflSpiral',
  'mdiLightbulbCflSpiralOff',
  'mdiLightbulbFluorescentTube',
  'mdiLightbulbFluorescentTubeOutline',
  'mdiLightbulbGroup',
  'mdiLightbulbGroupOff',
  'mdiLightbulbGroupOffOutline',
  'mdiLightbulbGroupOutline',
  'mdiLightbulbMultiple',
  'mdiLightbulbMultipleOff',
  'mdiLightbulbMultipleOffOutline',
  'mdiLightbulbMultipleOutline',
  'mdiLightbulbNight',
  'mdiLightbulbNightOutline',
  'mdiLightbulbOff',
  'mdiLightbulbOffOutline',
  'mdiLightbulbOn',
  'mdiLightbulbOn10',
  'mdiLightbulbOn20',
  'mdiLightbulbOn30',
  'mdiLightbulbOn40',
  'mdiLightbulbOn50',
  'mdiLightbulbOn60',
  'mdiLightbulbOn70',
  'mdiLightbulbOn80',
  'mdiLightbulbOn90',
  'mdiLightbulbOnOutline',
  'mdiLightbulbOutline',
  'mdiLightbulbQuestion',
  'mdiLightbulbQuestionOutline',
  'mdiLightbulbSpot',
  'mdiLightbulbSpotOff',
  'mdiLightbulbVariant',
  'mdiLightbulbVariantOutline',
  'mdiLighthouse',
  'mdiLighthouseOn',
  'mdiLightningBolt',
  'mdiLightningBoltCircle',
  'mdiLightningBoltOutline',
  'mdiLineScan',
  'mdiLingerie',
  'mdiLink',
  'mdiLinkBox',
  'mdiLinkBoxOutline',
  'mdiLinkBoxVariant',
  'mdiLinkBoxVariantOutline',
  'mdiLinkCircle',
  'mdiLinkCircleOutline',
  'mdiLinkEdit',
  'mdiLinkLock',
  'mdiLinkOff',
  'mdiLinkPlus',
  'mdiLinkVariant',
  'mdiLinkVariantMinus',
  'mdiLinkVariantOff',
  'mdiLinkVariantPlus',
  'mdiLinkVariantRemove',
  'mdiLinkedin',
  'mdiLinux',
  'mdiLinuxMint',
  'mdiLipstick',
  'mdiLiquidSpot',
  'mdiLiquor',
  'mdiListBox',
  'mdiListBoxOutline',
  'mdiListStatus',
  'mdiLitecoin',
  'mdiLoading',
  'mdiLocationEnter',
  'mdiLocationExit',
  'mdiLock',
  'mdiLockAlert',
  'mdiLockAlertOutline',
  'mdiLockCheck',
  'mdiLockCheckOutline',
  'mdiLockClock',
  'mdiLockMinus',
  'mdiLockMinusOutline',
  'mdiLockOff',
  'mdiLockOffOutline',
  'mdiLockOpen',
  'mdiLockOpenAlert',
  'mdiLockOpenAlertOutline',
  'mdiLockOpenCheck',
  'mdiLockOpenCheckOutline',
  'mdiLockOpenMinus',
  'mdiLockOpenMinusOutline',
  'mdiLockOpenOutline',
  'mdiLockOpenPlus',
  'mdiLockOpenPlusOutline',
  'mdiLockOpenRemove',
  'mdiLockOpenRemoveOutline',
  'mdiLockOpenVariant',
  'mdiLockOpenVariantOutline',
  'mdiLockOutline',
  'mdiLockPattern',
  'mdiLockPercent',
  'mdiLockPercentOpen',
  'mdiLockPercentOpenOutline',
  'mdiLockPercentOpenVariant',
  'mdiLockPercentOpenVariantOutline',
  'mdiLockPercentOutline',
  'mdiLockPlus',
  'mdiLockPlusOutline',
  'mdiLockQuestion',
  'mdiLockRemove',
  'mdiLockRemoveOutline',
  'mdiLockReset',
  'mdiLockSmart',
  'mdiLocker',
  'mdiLockerMultiple',
  'mdiLogin',
  'mdiLoginVariant',
  'mdiLogout',
  'mdiLogoutVariant',
  'mdiLongitude',
  'mdiLooks',
  'mdiLotion',
  'mdiLotionOutline',
  'mdiLotionPlus',
  'mdiLotionPlusOutline',
  'mdiLoupe',
  'mdiLumx',
  'mdiLungs',
  'mdiMace',
  'mdiMagazinePistol',
  'mdiMagazineRifle',
  'mdiMagicStaff',
  'mdiMagnet',
  'mdiMagnetOn',
  'mdiMagnify',
  'mdiMagnifyClose',
  'mdiMagnifyExpand',
  'mdiMagnifyMinus',
  'mdiMagnifyMinusCursor',
  'mdiMagnifyMinusOutline',
  'mdiMagnifyPlus',
  'mdiMagnifyPlusCursor',
  'mdiMagnifyPlusOutline',
  'mdiMagnifyRemoveCursor',
  'mdiMagnifyRemoveOutline',
  'mdiMagnifyScan',
  'mdiMail',
  'mdiMailbox',
  'mdiMailboxOpen',
  'mdiMailboxOpenOutline',
  'mdiMailboxOpenUp',
  'mdiMailboxOpenUpOutline',
  'mdiMailboxOutline',
  'mdiMailboxUp',
  'mdiMailboxUpOutline',
  'mdiManjaro',
  'mdiMap',
  'mdiMapCheck',
  'mdiMapCheckOutline',
  'mdiMapClock',
  'mdiMapClockOutline',
  'mdiMapLegend',
  'mdiMapMarker',
  'mdiMapMarkerAccount',
  'mdiMapMarkerAccountOutline',
  'mdiMapMarkerAlert',
  'mdiMapMarkerAlertOutline',
  'mdiMapMarkerCheck',
  'mdiMapMarkerCheckOutline',
  'mdiMapMarkerCircle',
  'mdiMapMarkerDistance',
  'mdiMapMarkerDown',
  'mdiMapMarkerLeft',
  'mdiMapMarkerLeftOutline',
  'mdiMapMarkerMinus',
  'mdiMapMarkerMinusOutline',
  'mdiMapMarkerMultiple',
  'mdiMapMarkerMultipleOutline',
  'mdiMapMarkerOff',
  'mdiMapMarkerOffOutline',
  'mdiMapMarkerOutline',
  'mdiMapMarkerPath',
  'mdiMapMarkerPlus',
  'mdiMapMarkerPlusOutline',
  'mdiMapMarkerQuestion',
  'mdiMapMarkerQuestionOutline',
  'mdiMapMarkerRadius',
  'mdiMapMarkerRadiusOutline',
  'mdiMapMarkerRemove',
  'mdiMapMarkerRemoveOutline',
  'mdiMapMarkerRemoveVariant',
  'mdiMapMarkerRight',
  'mdiMapMarkerRightOutline',
  'mdiMapMarkerStar',
  'mdiMapMarkerStarOutline',
  'mdiMapMarkerUp',
  'mdiMapMinus',
  'mdiMapOutline',
  'mdiMapPlus',
  'mdiMapSearch',
  'mdiMapSearchOutline',
  'mdiMapbox',
  'mdiMargin',
  'mdiMarker',
  'mdiMarkerCancel',
  'mdiMarkerCheck',
  'mdiMastodon',
  'mdiMaterialDesign',
  'mdiMaterialUi',
  'mdiMathCompass',
  'mdiMathCos',
  'mdiMathIntegral',
  'mdiMathIntegralBox',
  'mdiMathLog',
  'mdiMathNorm',
  'mdiMathNormBox',
  'mdiMathSin',
  'mdiMathTan',
  'mdiMatrix',
  'mdiMedal',
  'mdiMedalOutline',
  'mdiMedicalBag',
  'mdiMedicalCottonSwab',
  'mdiMedication',
  'mdiMedicationOutline',
  'mdiMeditation',
  'mdiMemory',
  'mdiMemoryArrowDown',
  'mdiMenorah',
  'mdiMenorahFire',
  'mdiMenu',
  'mdiMenuClose',
  'mdiMenuDown',
  'mdiMenuDownOutline',
  'mdiMenuLeft',
  'mdiMenuLeftOutline',
  'mdiMenuOpen',
  'mdiMenuRight',
  'mdiMenuRightOutline',
  'mdiMenuSwap',
  'mdiMenuSwapOutline',
  'mdiMenuUp',
  'mdiMenuUpOutline',
  'mdiMerge',
  'mdiMessage',
  'mdiMessageAlert',
  'mdiMessageAlertOutline',
  'mdiMessageArrowLeft',
  'mdiMessageArrowLeftOutline',
  'mdiMessageArrowRight',
  'mdiMessageArrowRightOutline',
  'mdiMessageBadge',
  'mdiMessageBadgeOutline',
  'mdiMessageBookmark',
  'mdiMessageBookmarkOutline',
  'mdiMessageBulleted',
  'mdiMessageBulletedOff',
  'mdiMessageCheck',
  'mdiMessageCheckOutline',
  'mdiMessageCog',
  'mdiMessageCogOutline',
  'mdiMessageDraw',
  'mdiMessageFast',
  'mdiMessageFastOutline',
  'mdiMessageFlash',
  'mdiMessageFlashOutline',
  'mdiMessageImage',
  'mdiMessageImageOutline',
  'mdiMessageLock',
  'mdiMessageLockOutline',
  'mdiMessageMinus',
  'mdiMessageMinusOutline',
  'mdiMessageOff',
  'mdiMessageOffOutline',
  'mdiMessageOutline',
  'mdiMessagePlus',
  'mdiMessagePlusOutline',
  'mdiMessageProcessing',
  'mdiMessageProcessingOutline',
  'mdiMessageQuestion',
  'mdiMessageQuestionOutline',
  'mdiMessageReply',
  'mdiMessageReplyOutline',
  'mdiMessageReplyText',
  'mdiMessageReplyTextOutline',
  'mdiMessageSettings',
  'mdiMessageSettingsOutline',
  'mdiMessageStar',
  'mdiMessageStarOutline',
  'mdiMessageText',
  'mdiMessageTextClock',
  'mdiMessageTextClockOutline',
  'mdiMessageTextFast',
  'mdiMessageTextFastOutline',
  'mdiMessageTextLock',
  'mdiMessageTextLockOutline',
  'mdiMessageTextOutline',
  'mdiMessageVideo',
  'mdiMeteor',
  'mdiMeterElectric',
  'mdiMeterElectricOutline',
  'mdiMeterGas',
  'mdiMeterGasOutline',
  'mdiMetronome',
  'mdiMetronomeTick',
  'mdiMicroSd',
  'mdiMicrophone',
  'mdiMicrophoneMessage',
  'mdiMicrophoneMessageOff',
  'mdiMicrophoneMinus',
  'mdiMicrophoneOff',
  'mdiMicrophoneOutline',
  'mdiMicrophonePlus',
  'mdiMicrophoneQuestion',
  'mdiMicrophoneQuestionOutline',
  'mdiMicrophoneSettings',
  'mdiMicrophoneVariant',
  'mdiMicrophoneVariantOff',
  'mdiMicroscope',
  'mdiMicrosoft',
  'mdiMicrosoftAccess',
  'mdiMicrosoftAzure',
  'mdiMicrosoftAzureDevops',
  'mdiMicrosoftBing',
  'mdiMicrosoftDynamics365',
  'mdiMicrosoftEdge',
  'mdiMicrosoftExcel',
  'mdiMicrosoftInternetExplorer',
  'mdiMicrosoftOffice',
  'mdiMicrosoftOnedrive',
  'mdiMicrosoftOnenote',
  'mdiMicrosoftOutlook',
  'mdiMicrosoftPowerpoint',
  'mdiMicrosoftSharepoint',
  'mdiMicrosoftTeams',
  'mdiMicrosoftVisualStudio',
  'mdiMicrosoftVisualStudioCode',
  'mdiMicrosoftWindows',
  'mdiMicrosoftWindowsClassic',
  'mdiMicrosoftWord',
  'mdiMicrosoftXbox',
  'mdiMicrosoftXboxController',
  'mdiMicrosoftXboxControllerBatteryAlert',
  'mdiMicrosoftXboxControllerBatteryCharging',
  'mdiMicrosoftXboxControllerBatteryEmpty',
  'mdiMicrosoftXboxControllerBatteryFull',
  'mdiMicrosoftXboxControllerBatteryLow',
  'mdiMicrosoftXboxControllerBatteryMedium',
  'mdiMicrosoftXboxControllerBatteryUnknown',
  'mdiMicrosoftXboxControllerMenu',
  'mdiMicrosoftXboxControllerOff',
  'mdiMicrosoftXboxControllerView',
  'mdiMicrowave',
  'mdiMicrowaveOff',
  'mdiMiddleware',
  'mdiMiddlewareOutline',
  'mdiMidi',
  'mdiMidiPort',
  'mdiMine',
  'mdiMinecraft',
  'mdiMiniSd',
  'mdiMinidisc',
  'mdiMinus',
  'mdiMinusBox',
  'mdiMinusBoxMultiple',
  'mdiMinusBoxMultipleOutline',
  'mdiMinusBoxOutline',
  'mdiMinusCircle',
  'mdiMinusCircleMultiple',
  'mdiMinusCircleMultipleOutline',
  'mdiMinusCircleOff',
  'mdiMinusCircleOffOutline',
  'mdiMinusCircleOutline',
  'mdiMinusNetwork',
  'mdiMinusNetworkOutline',
  'mdiMinusThick',
  'mdiMirror',
  'mdiMirrorRectangle',
  'mdiMirrorVariant',
  'mdiMixedMartialArts',
  'mdiMixedReality',
  'mdiMolecule',
  'mdiMoleculeCo',
  'mdiMoleculeCo2',
  'mdiMonitor',
  'mdiMonitorAccount',
  'mdiMonitorArrowDown',
  'mdiMonitorArrowDownVariant',
  'mdiMonitorCellphone',
  'mdiMonitorCellphoneStar',
  'mdiMonitorDashboard',
  'mdiMonitorEdit',
  'mdiMonitorEye',
  'mdiMonitorLock',
  'mdiMonitorMultiple',
  'mdiMonitorOff',
  'mdiMonitorScreenshot',
  'mdiMonitorShare',
  'mdiMonitorShimmer',
  'mdiMonitorSmall',
  'mdiMonitorSpeaker',
  'mdiMonitorSpeakerOff',
  'mdiMonitorStar',
  'mdiMonitorVertical',
  'mdiMoonFirstQuarter',
  'mdiMoonFull',
  'mdiMoonLastQuarter',
  'mdiMoonNew',
  'mdiMoonWaningCrescent',
  'mdiMoonWaningGibbous',
  'mdiMoonWaxingCrescent',
  'mdiMoonWaxingGibbous',
  'mdiMoped',
  'mdiMopedElectric',
  'mdiMopedElectricOutline',
  'mdiMopedOutline',
  'mdiMore',
  'mdiMortarPestle',
  'mdiMortarPestlePlus',
  'mdiMosque',
  'mdiMosqueOutline',
  'mdiMotherHeart',
  'mdiMotherNurse',
  'mdiMotion',
  'mdiMotionOutline',
  'mdiMotionPause',
  'mdiMotionPauseOutline',
  'mdiMotionPlay',
  'mdiMotionPlayOutline',
  'mdiMotionSensor',
  'mdiMotionSensorOff',
  'mdiMotorbike',
  'mdiMotorbikeElectric',
  'mdiMotorbikeOff',
  'mdiMouse',
  'mdiMouseBluetooth',
  'mdiMouseLeftClick',
  'mdiMouseLeftClickOutline',
  'mdiMouseMoveDown',
  'mdiMouseMoveUp',
  'mdiMouseMoveVertical',
  'mdiMouseOff',
  'mdiMouseOutline',
  'mdiMouseRightClick',
  'mdiMouseRightClickOutline',
  'mdiMouseScrollWheel',
  'mdiMouseVariant',
  'mdiMouseVariantOff',
  'mdiMoveResize',
  'mdiMoveResizeVariant',
  'mdiMovie',
  'mdiMovieCheck',
  'mdiMovieCheckOutline',
  'mdiMovieCog',
  'mdiMovieCogOutline',
  'mdiMovieEdit',
  'mdiMovieEditOutline',
  'mdiMovieFilter',
  'mdiMovieFilterOutline',
  'mdiMovieMinus',
  'mdiMovieMinusOutline',
  'mdiMovieOff',
  'mdiMovieOffOutline',
  'mdiMovieOpen',
  'mdiMovieOpenCheck',
  'mdiMovieOpenCheckOutline',
  'mdiMovieOpenCog',
  'mdiMovieOpenCogOutline',
  'mdiMovieOpenEdit',
  'mdiMovieOpenEditOutline',
  'mdiMovieOpenMinus',
  'mdiMovieOpenMinusOutline',
  'mdiMovieOpenOff',
  'mdiMovieOpenOffOutline',
  'mdiMovieOpenOutline',
  'mdiMovieOpenPlay',
  'mdiMovieOpenPlayOutline',
  'mdiMovieOpenPlus',
  'mdiMovieOpenPlusOutline',
  'mdiMovieOpenRemove',
  'mdiMovieOpenRemoveOutline',
  'mdiMovieOpenSettings',
  'mdiMovieOpenSettingsOutline',
  'mdiMovieOpenStar',
  'mdiMovieOpenStarOutline',
  'mdiMovieOutline',
  'mdiMoviePlay',
  'mdiMoviePlayOutline',
  'mdiMoviePlus',
  'mdiMoviePlusOutline',
  'mdiMovieRemove',
  'mdiMovieRemoveOutline',
  'mdiMovieRoll',
  'mdiMovieSearch',
  'mdiMovieSearchOutline',
  'mdiMovieSettings',
  'mdiMovieSettingsOutline',
  'mdiMovieStar',
  'mdiMovieStarOutline',
  'mdiMower',
  'mdiMowerBag',
  'mdiMowerBagOn',
  'mdiMowerOn',
  'mdiMuffin',
  'mdiMulticast',
  'mdiMultimedia',
  'mdiMultiplication',
  'mdiMultiplicationBox',
  'mdiMushroom',
  'mdiMushroomOff',
  'mdiMushroomOffOutline',
  'mdiMushroomOutline',
  'mdiMusic',
  'mdiMusicAccidentalDoubleFlat',
  'mdiMusicAccidentalDoubleSharp',
  'mdiMusicAccidentalFlat',
  'mdiMusicAccidentalNatural',
  'mdiMusicAccidentalSharp',
  'mdiMusicBox',
  'mdiMusicBoxMultiple',
  'mdiMusicBoxMultipleOutline',
  'mdiMusicBoxOutline',
  'mdiMusicCircle',
  'mdiMusicCircleOutline',
  'mdiMusicClefAlto',
  'mdiMusicClefBass',
  'mdiMusicClefTreble',
  'mdiMusicNote',
  'mdiMusicNoteBluetooth',
  'mdiMusicNoteBluetoothOff',
  'mdiMusicNoteEighth',
  'mdiMusicNoteEighthDotted',
  'mdiMusicNoteHalf',
  'mdiMusicNoteHalfDotted',
  'mdiMusicNoteMinus',
  'mdiMusicNoteOff',
  'mdiMusicNoteOffOutline',
  'mdiMusicNoteOutline',
  'mdiMusicNotePlus',
  'mdiMusicNoteQuarter',
  'mdiMusicNoteQuarterDotted',
  'mdiMusicNoteSixteenth',
  'mdiMusicNoteSixteenthDotted',
  'mdiMusicNoteWhole',
  'mdiMusicNoteWholeDotted',
  'mdiMusicOff',
  'mdiMusicRestEighth',
  'mdiMusicRestHalf',
  'mdiMusicRestQuarter',
  'mdiMusicRestSixteenth',
  'mdiMusicRestWhole',
  'mdiMustache',
  'mdiNail',
  'mdiNas',
  'mdiNativescript',
  'mdiNature',
  'mdiNatureOutline',
  'mdiNaturePeople',
  'mdiNaturePeopleOutline',
  'mdiNavigation',
  'mdiNavigationOutline',
  'mdiNavigationVariant',
  'mdiNavigationVariantOutline',
  'mdiNearMe',
  'mdiNecklace',
  'mdiNeedle',
  'mdiNeedleOff',
  'mdiNetflix',
  'mdiNetwork',
  'mdiNetworkOff',
  'mdiNetworkOffOutline',
  'mdiNetworkOutline',
  'mdiNetworkPos',
  'mdiNetworkStrength1',
  'mdiNetworkStrength1Alert',
  'mdiNetworkStrength2',
  'mdiNetworkStrength2Alert',
  'mdiNetworkStrength3',
  'mdiNetworkStrength3Alert',
  'mdiNetworkStrength4',
  'mdiNetworkStrength4Alert',
  'mdiNetworkStrength4Cog',
  'mdiNetworkStrengthOff',
  'mdiNetworkStrengthOffOutline',
  'mdiNetworkStrengthOutline',
  'mdiNewBox',
  'mdiNewspaper',
  'mdiNewspaperCheck',
  'mdiNewspaperMinus',
  'mdiNewspaperPlus',
  'mdiNewspaperRemove',
  'mdiNewspaperVariant',
  'mdiNewspaperVariantMultiple',
  'mdiNewspaperVariantMultipleOutline',
  'mdiNewspaperVariantOutline',
  'mdiNfc',
  'mdiNfcSearchVariant',
  'mdiNfcTap',
  'mdiNfcVariant',
  'mdiNfcVariantOff',
  'mdiNinja',
  'mdiNintendoGameBoy',
  'mdiNintendoSwitch',
  'mdiNintendoWii',
  'mdiNintendoWiiu',
  'mdiNix',
  'mdiNodejs',
  'mdiNoodles',
  'mdiNotEqual',
  'mdiNotEqualVariant',
  'mdiNote',
  'mdiNoteAlert',
  'mdiNoteAlertOutline',
  'mdiNoteCheck',
  'mdiNoteCheckOutline',
  'mdiNoteEdit',
  'mdiNoteEditOutline',
  'mdiNoteMinus',
  'mdiNoteMinusOutline',
  'mdiNoteMultiple',
  'mdiNoteMultipleOutline',
  'mdiNoteOff',
  'mdiNoteOffOutline',
  'mdiNoteOutline',
  'mdiNotePlus',
  'mdiNotePlusOutline',
  'mdiNoteRemove',
  'mdiNoteRemoveOutline',
  'mdiNoteSearch',
  'mdiNoteSearchOutline',
  'mdiNoteText',
  'mdiNoteTextOutline',
  'mdiNotebook',
  'mdiNotebookCheck',
  'mdiNotebookCheckOutline',
  'mdiNotebookEdit',
  'mdiNotebookEditOutline',
  'mdiNotebookHeart',
  'mdiNotebookHeartOutline',
  'mdiNotebookMinus',
  'mdiNotebookMinusOutline',
  'mdiNotebookMultiple',
  'mdiNotebookOutline',
  'mdiNotebookPlus',
  'mdiNotebookPlusOutline',
  'mdiNotebookRemove',
  'mdiNotebookRemoveOutline',
  'mdiNotificationClearAll',
  'mdiNpm',
  'mdiNuke',
  'mdiNull',
  'mdiNumeric',
  'mdiNumeric0',
  'mdiNumeric0Box',
  'mdiNumeric0BoxMultiple',
  'mdiNumeric0BoxMultipleOutline',
  'mdiNumeric0BoxOutline',
  'mdiNumeric0Circle',
  'mdiNumeric0CircleOutline',
  'mdiNumeric1',
  'mdiNumeric10',
  'mdiNumeric10Box',
  'mdiNumeric10BoxMultiple',
  'mdiNumeric10BoxMultipleOutline',
  'mdiNumeric10BoxOutline',
  'mdiNumeric10Circle',
  'mdiNumeric10CircleOutline',
  'mdiNumeric1Box',
  'mdiNumeric1BoxMultiple',
  'mdiNumeric1BoxMultipleOutline',
  'mdiNumeric1BoxOutline',
  'mdiNumeric1Circle',
  'mdiNumeric1CircleOutline',
  'mdiNumeric2',
  'mdiNumeric2Box',
  'mdiNumeric2BoxMultiple',
  'mdiNumeric2BoxMultipleOutline',
  'mdiNumeric2BoxOutline',
  'mdiNumeric2Circle',
  'mdiNumeric2CircleOutline',
  'mdiNumeric3',
  'mdiNumeric3Box',
  'mdiNumeric3BoxMultiple',
  'mdiNumeric3BoxMultipleOutline',
  'mdiNumeric3BoxOutline',
  'mdiNumeric3Circle',
  'mdiNumeric3CircleOutline',
  'mdiNumeric4',
  'mdiNumeric4Box',
  'mdiNumeric4BoxMultiple',
  'mdiNumeric4BoxMultipleOutline',
  'mdiNumeric4BoxOutline',
  'mdiNumeric4Circle',
  'mdiNumeric4CircleOutline',
  'mdiNumeric5',
  'mdiNumeric5Box',
  'mdiNumeric5BoxMultiple',
  'mdiNumeric5BoxMultipleOutline',
  'mdiNumeric5BoxOutline',
  'mdiNumeric5Circle',
  'mdiNumeric5CircleOutline',
  'mdiNumeric6',
  'mdiNumeric6Box',
  'mdiNumeric6BoxMultiple',
  'mdiNumeric6BoxMultipleOutline',
  'mdiNumeric6BoxOutline',
  'mdiNumeric6Circle',
  'mdiNumeric6CircleOutline',
  'mdiNumeric7',
  'mdiNumeric7Box',
  'mdiNumeric7BoxMultiple',
  'mdiNumeric7BoxMultipleOutline',
  'mdiNumeric7BoxOutline',
  'mdiNumeric7Circle',
  'mdiNumeric7CircleOutline',
  'mdiNumeric8',
  'mdiNumeric8Box',
  'mdiNumeric8BoxMultiple',
  'mdiNumeric8BoxMultipleOutline',
  'mdiNumeric8BoxOutline',
  'mdiNumeric8Circle',
  'mdiNumeric8CircleOutline',
  'mdiNumeric9',
  'mdiNumeric9Box',
  'mdiNumeric9BoxMultiple',
  'mdiNumeric9BoxMultipleOutline',
  'mdiNumeric9BoxOutline',
  'mdiNumeric9Circle',
  'mdiNumeric9CircleOutline',
  'mdiNumeric9Plus',
  'mdiNumeric9PlusBox',
  'mdiNumeric9PlusBoxMultiple',
  'mdiNumeric9PlusBoxMultipleOutline',
  'mdiNumeric9PlusBoxOutline',
  'mdiNumeric9PlusCircle',
  'mdiNumeric9PlusCircleOutline',
  'mdiNumericNegative1',
  'mdiNumericOff',
  'mdiNumericPositive1',
  'mdiNut',
  'mdiNutrition',
  'mdiNuxt',
  'mdiOar',
  'mdiOcarina',
  'mdiOci',
  'mdiOcr',
  'mdiOctagon',
  'mdiOctagonOutline',
  'mdiOctagram',
  'mdiOctagramEdit',
  'mdiOctagramEditOutline',
  'mdiOctagramMinus',
  'mdiOctagramMinusOutline',
  'mdiOctagramOutline',
  'mdiOctagramPlus',
  'mdiOctagramPlusOutline',
  'mdiOctahedron',
  'mdiOctahedronOff',
  'mdiOdnoklassniki',
  'mdiOffer',
  'mdiOfficeBuilding',
  'mdiOfficeBuildingCog',
  'mdiOfficeBuildingCogOutline',
  'mdiOfficeBuildingMarker',
  'mdiOfficeBuildingMarkerOutline',
  'mdiOfficeBuildingMinus',
  'mdiOfficeBuildingMinusOutline',
  'mdiOfficeBuildingOutline',
  'mdiOfficeBuildingPlus',
  'mdiOfficeBuildingPlusOutline',
  'mdiOfficeBuildingRemove',
  'mdiOfficeBuildingRemoveOutline',
  'mdiOil',
  'mdiOilLamp',
  'mdiOilLevel',
  'mdiOilTemperature',
  'mdiOm',
  'mdiOmega',
  'mdiOneUp',
  'mdiOnepassword',
  'mdiOpacity',
  'mdiOpenInApp',
  'mdiOpenInNew',
  'mdiOpenSourceInitiative',
  'mdiOpenid',
  'mdiOpera',
  'mdiOrbit',
  'mdiOrbitVariant',
  'mdiOrderAlphabeticalAscending',
  'mdiOrderAlphabeticalDescending',
  'mdiOrderBoolAscending',
  'mdiOrderBoolAscendingVariant',
  'mdiOrderBoolDescending',
  'mdiOrderBoolDescendingVariant',
  'mdiOrderNumericAscending',
  'mdiOrderNumericDescending',
  'mdiOrigin',
  'mdiOrnament',
  'mdiOrnamentVariant',
  'mdiOutdoorLamp',
  'mdiOverscan',
  'mdiOwl',
  'mdiPacMan',
  'mdiPackage',
  'mdiPackageCheck',
  'mdiPackageDown',
  'mdiPackageUp',
  'mdiPackageVariant',
  'mdiPackageVariantClosed',
  'mdiPackageVariantClosedCheck',
  'mdiPackageVariantClosedMinus',
  'mdiPackageVariantClosedPlus',
  'mdiPackageVariantClosedRemove',
  'mdiPackageVariantMinus',
  'mdiPackageVariantPlus',
  'mdiPackageVariantRemove',
  'mdiPageFirst',
  'mdiPageLast',
  'mdiPageLayoutBody',
  'mdiPageLayoutFooter',
  'mdiPageLayoutHeader',
  'mdiPageLayoutHeaderFooter',
  'mdiPageLayoutSidebarLeft',
  'mdiPageLayoutSidebarRight',
  'mdiPageNext',
  'mdiPageNextOutline',
  'mdiPagePrevious',
  'mdiPagePreviousOutline',
  'mdiPail',
  'mdiPailMinus',
  'mdiPailMinusOutline',
  'mdiPailOff',
  'mdiPailOffOutline',
  'mdiPailOutline',
  'mdiPailPlus',
  'mdiPailPlusOutline',
  'mdiPailRemove',
  'mdiPailRemoveOutline',
  'mdiPalette',
  'mdiPaletteAdvanced',
  'mdiPaletteOutline',
  'mdiPaletteSwatch',
  'mdiPaletteSwatchOutline',
  'mdiPaletteSwatchVariant',
  'mdiPalmTree',
  'mdiPan',
  'mdiPanBottomLeft',
  'mdiPanBottomRight',
  'mdiPanDown',
  'mdiPanHorizontal',
  'mdiPanLeft',
  'mdiPanRight',
  'mdiPanTopLeft',
  'mdiPanTopRight',
  'mdiPanUp',
  'mdiPanVertical',
  'mdiPanda',
  'mdiPandora',
  'mdiPanorama',
  'mdiPanoramaFisheye',
  'mdiPanoramaHorizontal',
  'mdiPanoramaHorizontalOutline',
  'mdiPanoramaOutline',
  'mdiPanoramaSphere',
  'mdiPanoramaSphereOutline',
  'mdiPanoramaVariant',
  'mdiPanoramaVariantOutline',
  'mdiPanoramaVertical',
  'mdiPanoramaVerticalOutline',
  'mdiPanoramaWideAngle',
  'mdiPanoramaWideAngleOutline',
  'mdiPaperCutVertical',
  'mdiPaperRoll',
  'mdiPaperRollOutline',
  'mdiPaperclip',
  'mdiPaperclipCheck',
  'mdiPaperclipLock',
  'mdiPaperclipMinus',
  'mdiPaperclipOff',
  'mdiPaperclipPlus',
  'mdiPaperclipRemove',
  'mdiParachute',
  'mdiParachuteOutline',
  'mdiParagliding',
  'mdiParking',
  'mdiPartyPopper',
  'mdiPassport',
  'mdiPassportAlert',
  'mdiPassportBiometric',
  'mdiPassportCancel',
  'mdiPassportCheck',
  'mdiPassportMinus',
  'mdiPassportPlus',
  'mdiPassportRemove',
  'mdiPasta',
  'mdiPatioHeater',
  'mdiPatreon',
  'mdiPause',
  'mdiPauseBox',
  'mdiPauseBoxOutline',
  'mdiPauseCircle',
  'mdiPauseCircleOutline',
  'mdiPauseOctagon',
  'mdiPauseOctagonOutline',
  'mdiPaw',
  'mdiPawOff',
  'mdiPawOffOutline',
  'mdiPawOutline',
  'mdiPeace',
  'mdiPeanut',
  'mdiPeanutOff',
  'mdiPeanutOffOutline',
  'mdiPeanutOutline',
  'mdiPen',
  'mdiPenLock',
  'mdiPenMinus',
  'mdiPenOff',
  'mdiPenPlus',
  'mdiPenRemove',
  'mdiPencil',
  'mdiPencilBox',
  'mdiPencilBoxMultiple',
  'mdiPencilBoxMultipleOutline',
  'mdiPencilBoxOutline',
  'mdiPencilCircle',
  'mdiPencilCircleOutline',
  'mdiPencilLock',
  'mdiPencilLockOutline',
  'mdiPencilMinus',
  'mdiPencilMinusOutline',
  'mdiPencilOff',
  'mdiPencilOffOutline',
  'mdiPencilOutline',
  'mdiPencilPlus',
  'mdiPencilPlusOutline',
  'mdiPencilRemove',
  'mdiPencilRemoveOutline',
  'mdiPencilRuler',
  'mdiPencilRulerOutline',
  'mdiPenguin',
  'mdiPentagon',
  'mdiPentagonOutline',
  'mdiPentagram',
  'mdiPercent',
  'mdiPercentBox',
  'mdiPercentBoxOutline',
  'mdiPercentCircle',
  'mdiPercentCircleOutline',
  'mdiPercentOutline',
  'mdiPeriodicTable',
  'mdiPerspectiveLess',
  'mdiPerspectiveMore',
  'mdiPh',
  'mdiPhone',
  'mdiPhoneAlert',
  'mdiPhoneAlertOutline',
  'mdiPhoneBluetooth',
  'mdiPhoneBluetoothOutline',
  'mdiPhoneCancel',
  'mdiPhoneCancelOutline',
  'mdiPhoneCheck',
  'mdiPhoneCheckOutline',
  'mdiPhoneClassic',
  'mdiPhoneClassicOff',
  'mdiPhoneClock',
  'mdiPhoneDial',
  'mdiPhoneDialOutline',
  'mdiPhoneForward',
  'mdiPhoneForwardOutline',
  'mdiPhoneHangup',
  'mdiPhoneHangupOutline',
  'mdiPhoneInTalk',
  'mdiPhoneInTalkOutline',
  'mdiPhoneIncoming',
  'mdiPhoneIncomingOutgoing',
  'mdiPhoneIncomingOutgoingOutline',
  'mdiPhoneIncomingOutline',
  'mdiPhoneLock',
  'mdiPhoneLockOutline',
  'mdiPhoneLog',
  'mdiPhoneLogOutline',
  'mdiPhoneMessage',
  'mdiPhoneMessageOutline',
  'mdiPhoneMinus',
  'mdiPhoneMinusOutline',
  'mdiPhoneMissed',
  'mdiPhoneMissedOutline',
  'mdiPhoneOff',
  'mdiPhoneOffOutline',
  'mdiPhoneOutgoing',
  'mdiPhoneOutgoingOutline',
  'mdiPhoneOutline',
  'mdiPhonePaused',
  'mdiPhonePausedOutline',
  'mdiPhonePlus',
  'mdiPhonePlusOutline',
  'mdiPhoneRefresh',
  'mdiPhoneRefreshOutline',
  'mdiPhoneRemove',
  'mdiPhoneRemoveOutline',
  'mdiPhoneReturn',
  'mdiPhoneReturnOutline',
  'mdiPhoneRing',
  'mdiPhoneRingOutline',
  'mdiPhoneRotateLandscape',
  'mdiPhoneRotatePortrait',
  'mdiPhoneSettings',
  'mdiPhoneSettingsOutline',
  'mdiPhoneSync',
  'mdiPhoneSyncOutline',
  'mdiPhoneVoip',
  'mdiPi',
  'mdiPiBox',
  'mdiPiHole',
  'mdiPiano',
  'mdiPianoOff',
  'mdiPickaxe',
  'mdiPictureInPictureBottomRight',
  'mdiPictureInPictureBottomRightOutline',
  'mdiPictureInPictureTopRight',
  'mdiPictureInPictureTopRightOutline',
  'mdiPier',
  'mdiPierCrane',
  'mdiPig',
  'mdiPigVariant',
  'mdiPigVariantOutline',
  'mdiPiggyBank',
  'mdiPiggyBankOutline',
  'mdiPill',
  'mdiPillMultiple',
  'mdiPillOff',
  'mdiPillar',
  'mdiPin',
  'mdiPinOff',
  'mdiPinOffOutline',
  'mdiPinOutline',
  'mdiPineTree',
  'mdiPineTreeBox',
  'mdiPineTreeFire',
  'mdiPineTreeVariant',
  'mdiPineTreeVariantOutline',
  'mdiPinterest',
  'mdiPinwheel',
  'mdiPinwheelOutline',
  'mdiPipe',
  'mdiPipeDisconnected',
  'mdiPipeLeak',
  'mdiPipeValve',
  'mdiPipeWrench',
  'mdiPirate',
  'mdiPistol',
  'mdiPiston',
  'mdiPitchfork',
  'mdiPizza',
  'mdiPlaneCar',
  'mdiPlaneTrain',
  'mdiPlay',
  'mdiPlayBox',
  'mdiPlayBoxEditOutline',
  'mdiPlayBoxLock',
  'mdiPlayBoxLockOpen',
  'mdiPlayBoxLockOpenOutline',
  'mdiPlayBoxLockOutline',
  'mdiPlayBoxMultiple',
  'mdiPlayBoxMultipleOutline',
  'mdiPlayBoxOutline',
  'mdiPlayCircle',
  'mdiPlayCircleOutline',
  'mdiPlayNetwork',
  'mdiPlayNetworkOutline',
  'mdiPlayOutline',
  'mdiPlayPause',
  'mdiPlayProtectedContent',
  'mdiPlaySpeed',
  'mdiPlaylistCheck',
  'mdiPlaylistEdit',
  'mdiPlaylistMinus',
  'mdiPlaylistMusic',
  'mdiPlaylistMusicOutline',
  'mdiPlaylistPlay',
  'mdiPlaylistPlus',
  'mdiPlaylistRemove',
  'mdiPlaylistStar',
  'mdiPlex',
  'mdiPliers',
  'mdiPlus',
  'mdiPlusBox',
  'mdiPlusBoxMultiple',
  'mdiPlusBoxMultipleOutline',
  'mdiPlusBoxOutline',
  'mdiPlusCircle',
  'mdiPlusCircleMultiple',
  'mdiPlusCircleMultipleOutline',
  'mdiPlusCircleOutline',
  'mdiPlusLock',
  'mdiPlusLockOpen',
  'mdiPlusMinus',
  'mdiPlusMinusBox',
  'mdiPlusMinusVariant',
  'mdiPlusNetwork',
  'mdiPlusNetworkOutline',
  'mdiPlusOutline',
  'mdiPlusThick',
  'mdiPocket',
  'mdiPodcast',
  'mdiPodium',
  'mdiPodiumBronze',
  'mdiPodiumGold',
  'mdiPodiumSilver',
  'mdiPointOfSale',
  'mdiPokeball',
  'mdiPokemonGo',
  'mdiPokerChip',
  'mdiPolaroid',
  'mdiPoliceBadge',
  'mdiPoliceBadgeOutline',
  'mdiPoliceStation',
  'mdiPoll',
  'mdiPolo',
  'mdiPolymer',
  'mdiPool',
  'mdiPoolThermometer',
  'mdiPopcorn',
  'mdiPost',
  'mdiPostLamp',
  'mdiPostOutline',
  'mdiPostageStamp',
  'mdiPot',
  'mdiPotMix',
  'mdiPotMixOutline',
  'mdiPotOutline',
  'mdiPotSteam',
  'mdiPotSteamOutline',
  'mdiPound',
  'mdiPoundBox',
  'mdiPoundBoxOutline',
  'mdiPower',
  'mdiPowerCycle',
  'mdiPowerOff',
  'mdiPowerOn',
  'mdiPowerPlug',
  'mdiPowerPlugBattery',
  'mdiPowerPlugBatteryOutline',
  'mdiPowerPlugOff',
  'mdiPowerPlugOffOutline',
  'mdiPowerPlugOutline',
  'mdiPowerSettings',
  'mdiPowerSleep',
  'mdiPowerSocket',
  'mdiPowerSocketAu',
  'mdiPowerSocketCh',
  'mdiPowerSocketDe',
  'mdiPowerSocketEu',
  'mdiPowerSocketFr',
  'mdiPowerSocketIt',
  'mdiPowerSocketJp',
  'mdiPowerSocketUk',
  'mdiPowerSocketUs',
  'mdiPowerStandby',
  'mdiPowershell',
  'mdiPrescription',
  'mdiPresentation',
  'mdiPresentationPlay',
  'mdiPretzel',
  'mdiPrinter',
  'mdiPrinter3d',
  'mdiPrinter3dNozzle',
  'mdiPrinter3dNozzleAlert',
  'mdiPrinter3dNozzleAlertOutline',
  'mdiPrinter3dNozzleHeat',
  'mdiPrinter3dNozzleHeatOutline',
  'mdiPrinter3dNozzleOff',
  'mdiPrinter3dNozzleOffOutline',
  'mdiPrinter3dNozzleOutline',
  'mdiPrinter3dOff',
  'mdiPrinterAlert',
  'mdiPrinterCheck',
  'mdiPrinterEye',
  'mdiPrinterOff',
  'mdiPrinterOffOutline',
  'mdiPrinterOutline',
  'mdiPrinterPos',
  'mdiPrinterPosAlert',
  'mdiPrinterPosAlertOutline',
  'mdiPrinterPosCancel',
  'mdiPrinterPosCancelOutline',
  'mdiPrinterPosCheck',
  'mdiPrinterPosCheckOutline',
  'mdiPrinterPosCog',
  'mdiPrinterPosCogOutline',
  'mdiPrinterPosEdit',
  'mdiPrinterPosEditOutline',
  'mdiPrinterPosMinus',
  'mdiPrinterPosMinusOutline',
  'mdiPrinterPosNetwork',
  'mdiPrinterPosNetworkOutline',
  'mdiPrinterPosOff',
  'mdiPrinterPosOffOutline',
  'mdiPrinterPosOutline',
  'mdiPrinterPosPause',
  'mdiPrinterPosPauseOutline',
  'mdiPrinterPosPlay',
  'mdiPrinterPosPlayOutline',
  'mdiPrinterPosPlus',
  'mdiPrinterPosPlusOutline',
  'mdiPrinterPosRefresh',
  'mdiPrinterPosRefreshOutline',
  'mdiPrinterPosRemove',
  'mdiPrinterPosRemoveOutline',
  'mdiPrinterPosStar',
  'mdiPrinterPosStarOutline',
  'mdiPrinterPosStop',
  'mdiPrinterPosStopOutline',
  'mdiPrinterPosSync',
  'mdiPrinterPosSyncOutline',
  'mdiPrinterPosWrench',
  'mdiPrinterPosWrenchOutline',
  'mdiPrinterSearch',
  'mdiPrinterSettings',
  'mdiPrinterWireless',
  'mdiPriorityHigh',
  'mdiPriorityLow',
  'mdiProfessionalHexagon',
  'mdiProgressAlert',
  'mdiProgressCheck',
  'mdiProgressClock',
  'mdiProgressClose',
  'mdiProgressDownload',
  'mdiProgressHelper',
  'mdiProgressPencil',
  'mdiProgressQuestion',
  'mdiProgressStar',
  'mdiProgressStarFourPoints',
  'mdiProgressTag',
  'mdiProgressUpload',
  'mdiProgressWrench',
  'mdiProjector',
  'mdiProjectorOff',
  'mdiProjectorScreen',
  'mdiProjectorScreenOff',
  'mdiProjectorScreenOffOutline',
  'mdiProjectorScreenOutline',
  'mdiProjectorScreenVariant',
  'mdiProjectorScreenVariantOff',
  'mdiProjectorScreenVariantOffOutline',
  'mdiProjectorScreenVariantOutline',
  'mdiPropaneTank',
  'mdiPropaneTankOutline',
  'mdiProtocol',
  'mdiPublish',
  'mdiPublishOff',
  'mdiPulse',
  'mdiPump',
  'mdiPumpOff',
  'mdiPumpkin',
  'mdiPurse',
  'mdiPurseOutline',
  'mdiPuzzle',
  'mdiPuzzleCheck',
  'mdiPuzzleCheckOutline',
  'mdiPuzzleEdit',
  'mdiPuzzleEditOutline',
  'mdiPuzzleHeart',
  'mdiPuzzleHeartOutline',
  'mdiPuzzleMinus',
  'mdiPuzzleMinusOutline',
  'mdiPuzzleOutline',
  'mdiPuzzlePlus',
  'mdiPuzzlePlusOutline',
  'mdiPuzzleRemove',
  'mdiPuzzleRemoveOutline',
  'mdiPuzzleStar',
  'mdiPuzzleStarOutline',
  'mdiPyramid',
  'mdiPyramidOff',
  'mdiQi',
  'mdiQqchat',
  'mdiQrcode',
  'mdiQrcodeEdit',
  'mdiQrcodeMinus',
  'mdiQrcodePlus',
  'mdiQrcodeRemove',
  'mdiQrcodeScan',
  'mdiQuadcopter',
  'mdiQualityHigh',
  'mdiQualityLow',
  'mdiQualityMedium',
  'mdiQueueFirstInLastOut',
  'mdiQuora',
  'mdiRabbit',
  'mdiRabbitVariant',
  'mdiRabbitVariantOutline',
  'mdiRacingHelmet',
  'mdiRacquetball',
  'mdiRadar',
  'mdiRadiator',
  'mdiRadiatorDisabled',
  'mdiRadiatorOff',
  'mdiRadio',
  'mdiRadioAm',
  'mdiRadioFm',
  'mdiRadioHandheld',
  'mdiRadioOff',
  'mdiRadioTower',
  'mdiRadioactive',
  'mdiRadioactiveCircle',
  'mdiRadioactiveCircleOutline',
  'mdiRadioactiveOff',
  'mdiRadioboxBlank',
  'mdiRadioboxIndeterminateVariant',
  'mdiRadioboxMarked',
  'mdiRadiologyBox',
  'mdiRadiologyBoxOutline',
  'mdiRadius',
  'mdiRadiusOutline',
  'mdiRailroadLight',
  'mdiRake',
  'mdiRaspberryPi',
  'mdiRaw',
  'mdiRawOff',
  'mdiRayEnd',
  'mdiRayEndArrow',
  'mdiRayStart',
  'mdiRayStartArrow',
  'mdiRayStartEnd',
  'mdiRayStartVertexEnd',
  'mdiRayVertex',
  'mdiRazorDoubleEdge',
  'mdiRazorSingleEdge',
  'mdiReact',
  'mdiRead',
  'mdiReceipt',
  'mdiReceiptClock',
  'mdiReceiptClockOutline',
  'mdiReceiptOutline',
  'mdiReceiptSend',
  'mdiReceiptSendOutline',
  'mdiReceiptText',
  'mdiReceiptTextArrowLeft',
  'mdiReceiptTextArrowLeftOutline',
  'mdiReceiptTextArrowRight',
  'mdiReceiptTextArrowRightOutline',
  'mdiReceiptTextCheck',
  'mdiReceiptTextCheckOutline',
  'mdiReceiptTextClock',
  'mdiReceiptTextClockOutline',
  'mdiReceiptTextEdit',
  'mdiReceiptTextEditOutline',
  'mdiReceiptTextMinus',
  'mdiReceiptTextMinusOutline',
  'mdiReceiptTextOutline',
  'mdiReceiptTextPlus',
  'mdiReceiptTextPlusOutline',
  'mdiReceiptTextRemove',
  'mdiReceiptTextRemoveOutline',
  'mdiReceiptTextSend',
  'mdiReceiptTextSendOutline',
  'mdiRecord',
  'mdiRecordCircle',
  'mdiRecordCircleOutline',
  'mdiRecordPlayer',
  'mdiRecordRec',
  'mdiRectangle',
  'mdiRectangleOutline',
  'mdiRecycle',
  'mdiRecycleVariant',
  'mdiReddit',
  'mdiRedhat',
  'mdiRedo',
  'mdiRedoVariant',
  'mdiReflectHorizontal',
  'mdiReflectVertical',
  'mdiRefresh',
  'mdiRefreshAuto',
  'mdiRefreshCircle',
  'mdiRegex',
  'mdiRegisteredTrademark',
  'mdiReiterate',
  'mdiRelationManyToMany',
  'mdiRelationManyToOne',
  'mdiRelationManyToOneOrMany',
  'mdiRelationManyToOnlyOne',
  'mdiRelationManyToZeroOrMany',
  'mdiRelationManyToZeroOrOne',
  'mdiRelationOneOrManyToMany',
  'mdiRelationOneOrManyToOne',
  'mdiRelationOneOrManyToOneOrMany',
  'mdiRelationOneOrManyToOnlyOne',
  'mdiRelationOneOrManyToZeroOrMany',
  'mdiRelationOneOrManyToZeroOrOne',
  'mdiRelationOneToMany',
  'mdiRelationOneToOne',
  'mdiRelationOneToOneOrMany',
  'mdiRelationOneToOnlyOne',
  'mdiRelationOneToZeroOrMany',
  'mdiRelationOneToZeroOrOne',
  'mdiRelationOnlyOneToMany',
  'mdiRelationOnlyOneToOne',
  'mdiRelationOnlyOneToOneOrMany',
  'mdiRelationOnlyOneToOnlyOne',
  'mdiRelationOnlyOneToZeroOrMany',
  'mdiRelationOnlyOneToZeroOrOne',
  'mdiRelationZeroOrManyToMany',
  'mdiRelationZeroOrManyToOne',
  'mdiRelationZeroOrManyToOneOrMany',
  'mdiRelationZeroOrManyToOnlyOne',
  'mdiRelationZeroOrManyToZeroOrMany',
  'mdiRelationZeroOrManyToZeroOrOne',
  'mdiRelationZeroOrOneToMany',
  'mdiRelationZeroOrOneToOne',
  'mdiRelationZeroOrOneToOneOrMany',
  'mdiRelationZeroOrOneToOnlyOne',
  'mdiRelationZeroOrOneToZeroOrMany',
  'mdiRelationZeroOrOneToZeroOrOne',
  'mdiRelativeScale',
  'mdiReload',
  'mdiReloadAlert',
  'mdiReminder',
  'mdiRemote',
  'mdiRemoteDesktop',
  'mdiRemoteOff',
  'mdiRemoteTv',
  'mdiRemoteTvOff',
  'mdiRename',
  'mdiRenameBox',
  'mdiRenameBoxOutline',
  'mdiRenameOutline',
  'mdiReorderHorizontal',
  'mdiReorderVertical',
  'mdiRepeat',
  'mdiRepeatOff',
  'mdiRepeatOnce',
  'mdiRepeatVariant',
  'mdiReplay',
  'mdiReply',
  'mdiReplyAll',
  'mdiReplyAllOutline',
  'mdiReplyCircle',
  'mdiReplyOutline',
  'mdiReproduction',
  'mdiResistor',
  'mdiResistorNodes',
  'mdiResize',
  'mdiResizeBottomRight',
  'mdiResponsive',
  'mdiRestart',
  'mdiRestartAlert',
  'mdiRestartOff',
  'mdiRestore',
  'mdiRestoreAlert',
  'mdiRewind',
  'mdiRewind10',
  'mdiRewind15',
  'mdiRewind30',
  'mdiRewind45',
  'mdiRewind5',
  'mdiRewind60',
  'mdiRewindOutline',
  'mdiRhombus',
  'mdiRhombusMedium',
  'mdiRhombusMediumOutline',
  'mdiRhombusOutline',
  'mdiRhombusSplit',
  'mdiRhombusSplitOutline',
  'mdiRibbon',
  'mdiRice',
  'mdiRickshaw',
  'mdiRickshawElectric',
  'mdiRing',
  'mdiRivet',
  'mdiRoad',
  'mdiRoadVariant',
  'mdiRobber',
  'mdiRobot',
  'mdiRobotAngry',
  'mdiRobotAngryOutline',
  'mdiRobotConfused',
  'mdiRobotConfusedOutline',
  'mdiRobotDead',
  'mdiRobotDeadOutline',
  'mdiRobotExcited',
  'mdiRobotExcitedOutline',
  'mdiRobotHappy',
  'mdiRobotHappyOutline',
  'mdiRobotIndustrial',
  'mdiRobotIndustrialOutline',
  'mdiRobotLove',
  'mdiRobotLoveOutline',
  'mdiRobotMower',
  'mdiRobotMowerOutline',
  'mdiRobotOff',
  'mdiRobotOffOutline',
  'mdiRobotOutline',
  'mdiRobotVacuum',
  'mdiRobotVacuumAlert',
  'mdiRobotVacuumOff',
  'mdiRobotVacuumVariant',
  'mdiRobotVacuumVariantAlert',
  'mdiRobotVacuumVariantOff',
  'mdiRocket',
  'mdiRocketLaunch',
  'mdiRocketLaunchOutline',
  'mdiRocketOutline',
  'mdiRodent',
  'mdiRollerShade',
  'mdiRollerShadeClosed',
  'mdiRollerSkate',
  'mdiRollerSkateOff',
  'mdiRollerblade',
  'mdiRollerbladeOff',
  'mdiRollupjs',
  'mdiRolodex',
  'mdiRolodexOutline',
  'mdiRomanNumeral1',
  'mdiRomanNumeral10',
  'mdiRomanNumeral2',
  'mdiRomanNumeral3',
  'mdiRomanNumeral4',
  'mdiRomanNumeral5',
  'mdiRomanNumeral6',
  'mdiRomanNumeral7',
  'mdiRomanNumeral8',
  'mdiRomanNumeral9',
  'mdiRoomService',
  'mdiRoomServiceOutline',
  'mdiRotate360',
  'mdiRotate3d',
  'mdiRotate3dVariant',
  'mdiRotateLeft',
  'mdiRotateLeftVariant',
  'mdiRotateOrbit',
  'mdiRotateRight',
  'mdiRotateRightVariant',
  'mdiRoundedCorner',
  'mdiRouter',
  'mdiRouterNetwork',
  'mdiRouterNetworkWireless',
  'mdiRouterWireless',
  'mdiRouterWirelessOff',
  'mdiRouterWirelessSettings',
  'mdiRoutes',
  'mdiRoutesClock',
  'mdiRowing',
  'mdiRss',
  'mdiRssBox',
  'mdiRssOff',
  'mdiRug',
  'mdiRugby',
  'mdiRuler',
  'mdiRulerSquare',
  'mdiRulerSquareCompass',
  'mdiRun',
  'mdiRunFast',
  'mdiRvTruck',
  'mdiSack',
  'mdiSackOutline',
  'mdiSackPercent',
  'mdiSafe',
  'mdiSafeSquare',
  'mdiSafeSquareOutline',
  'mdiSafetyGoggles',
  'mdiSailBoat',
  'mdiSailBoatSink',
  'mdiSale',
  'mdiSaleOutline',
  'mdiSalesforce',
  'mdiSass',
  'mdiSatellite',
  'mdiSatelliteUplink',
  'mdiSatelliteVariant',
  'mdiSausage',
  'mdiSausageOff',
  'mdiSawBlade',
  'mdiSawtoothWave',
  'mdiSaxophone',
  'mdiScale',
  'mdiScaleBalance',
  'mdiScaleBathroom',
  'mdiScaleOff',
  'mdiScaleUnbalanced',
  'mdiScanHelper',
  'mdiScanner',
  'mdiScannerOff',
  'mdiScatterPlot',
  'mdiScatterPlotOutline',
  'mdiScent',
  'mdiScentOff',
  'mdiSchool',
  'mdiSchoolOutline',
  'mdiScissorsCutting',
  'mdiScooter',
  'mdiScooterElectric',
  'mdiScoreboard',
  'mdiScoreboardOutline',
  'mdiScreenRotation',
  'mdiScreenRotationLock',
  'mdiScrewFlatTop',
  'mdiScrewLag',
  'mdiScrewMachineFlatTop',
  'mdiScrewMachineRoundTop',
  'mdiScrewRoundTop',
  'mdiScrewdriver',
  'mdiScript',
  'mdiScriptOutline',
  'mdiScriptText',
  'mdiScriptTextKey',
  'mdiScriptTextKeyOutline',
  'mdiScriptTextOutline',
  'mdiScriptTextPlay',
  'mdiScriptTextPlayOutline',
  'mdiSd',
  'mdiSeal',
  'mdiSealVariant',
  'mdiSearchWeb',
  'mdiSeat',
  'mdiSeatFlat',
  'mdiSeatFlatAngled',
  'mdiSeatIndividualSuite',
  'mdiSeatLegroomExtra',
  'mdiSeatLegroomNormal',
  'mdiSeatLegroomReduced',
  'mdiSeatOutline',
  'mdiSeatPassenger',
  'mdiSeatReclineExtra',
  'mdiSeatReclineNormal',
  'mdiSeatbelt',
  'mdiSecurity',
  'mdiSecurityNetwork',
  'mdiSeed',
  'mdiSeedOff',
  'mdiSeedOffOutline',
  'mdiSeedOutline',
  'mdiSeedPlus',
  'mdiSeedPlusOutline',
  'mdiSeesaw',
  'mdiSegment',
  'mdiSelect',
  'mdiSelectAll',
  'mdiSelectArrowDown',
  'mdiSelectArrowUp',
  'mdiSelectColor',
  'mdiSelectCompare',
  'mdiSelectDrag',
  'mdiSelectGroup',
  'mdiSelectInverse',
  'mdiSelectMarker',
  'mdiSelectMultiple',
  'mdiSelectMultipleMarker',
  'mdiSelectOff',
  'mdiSelectPlace',
  'mdiSelectRemove',
  'mdiSelectSearch',
  'mdiSelection',
  'mdiSelectionDrag',
  'mdiSelectionEllipse',
  'mdiSelectionEllipseArrowInside',
  'mdiSelectionEllipseRemove',
  'mdiSelectionMarker',
  'mdiSelectionMultiple',
  'mdiSelectionMultipleMarker',
  'mdiSelectionOff',
  'mdiSelectionRemove',
  'mdiSelectionSearch',
  'mdiSemanticWeb',
  'mdiSend',
  'mdiSendCheck',
  'mdiSendCheckOutline',
  'mdiSendCircle',
  'mdiSendCircleOutline',
  'mdiSendClock',
  'mdiSendClockOutline',
  'mdiSendLock',
  'mdiSendLockOutline',
  'mdiSendOutline',
  'mdiSendVariant',
  'mdiSendVariantClock',
  'mdiSendVariantClockOutline',
  'mdiSendVariantOutline',
  'mdiSerialPort',
  'mdiServer',
  'mdiServerMinus',
  'mdiServerMinusOutline',
  'mdiServerNetwork',
  'mdiServerNetworkOff',
  'mdiServerNetworkOutline',
  'mdiServerOff',
  'mdiServerOutline',
  'mdiServerPlus',
  'mdiServerPlusOutline',
  'mdiServerRemove',
  'mdiServerSecurity',
  'mdiSetAll',
  'mdiSetCenter',
  'mdiSetCenterRight',
  'mdiSetLeft',
  'mdiSetLeftCenter',
  'mdiSetLeftRight',
  'mdiSetMerge',
  'mdiSetNone',
  'mdiSetRight',
  'mdiSetSplit',
  'mdiSetSquare',
  'mdiSetTopBox',
  'mdiSettingsHelper',
  'mdiShaker',
  'mdiShakerOutline',
  'mdiShape',
  'mdiShapeCirclePlus',
  'mdiShapeOutline',
  'mdiShapeOvalPlus',
  'mdiShapePlus',
  'mdiShapePlusOutline',
  'mdiShapePolygonPlus',
  'mdiShapeRectanglePlus',
  'mdiShapeSquarePlus',
  'mdiShapeSquareRoundedPlus',
  'mdiShare',
  'mdiShareAll',
  'mdiShareAllOutline',
  'mdiShareCircle',
  'mdiShareOff',
  'mdiShareOffOutline',
  'mdiShareOutline',
  'mdiShareVariant',
  'mdiShareVariantOutline',
  'mdiShark',
  'mdiSharkFin',
  'mdiSharkFinOutline',
  'mdiSharkOff',
  'mdiSheep',
  'mdiShield',
  'mdiShieldAccount',
  'mdiShieldAccountOutline',
  'mdiShieldAccountVariant',
  'mdiShieldAccountVariantOutline',
  'mdiShieldAirplane',
  'mdiShieldAirplaneOutline',
  'mdiShieldAlert',
  'mdiShieldAlertOutline',
  'mdiShieldBug',
  'mdiShieldBugOutline',
  'mdiShieldCar',
  'mdiShieldCheck',
  'mdiShieldCheckOutline',
  'mdiShieldCross',
  'mdiShieldCrossOutline',
  'mdiShieldCrown',
  'mdiShieldCrownOutline',
  'mdiShieldEdit',
  'mdiShieldEditOutline',
  'mdiShieldHalf',
  'mdiShieldHalfFull',
  'mdiShieldHome',
  'mdiShieldHomeOutline',
  'mdiShieldKey',
  'mdiShieldKeyOutline',
  'mdiShieldLinkVariant',
  'mdiShieldLinkVariantOutline',
  'mdiShieldLock',
  'mdiShieldLockOpen',
  'mdiShieldLockOpenOutline',
  'mdiShieldLockOutline',
  'mdiShieldMoon',
  'mdiShieldMoonOutline',
  'mdiShieldOff',
  'mdiShieldOffOutline',
  'mdiShieldOutline',
  'mdiShieldPlus',
  'mdiShieldPlusOutline',
  'mdiShieldRefresh',
  'mdiShieldRefreshOutline',
  'mdiShieldRemove',
  'mdiShieldRemoveOutline',
  'mdiShieldSearch',
  'mdiShieldStar',
  'mdiShieldStarOutline',
  'mdiShieldSun',
  'mdiShieldSunOutline',
  'mdiShieldSword',
  'mdiShieldSwordOutline',
  'mdiShieldSync',
  'mdiShieldSyncOutline',
  'mdiShimmer',
  'mdiShipWheel',
  'mdiShippingPallet',
  'mdiShoeBallet',
  'mdiShoeCleat',
  'mdiShoeFormal',
  'mdiShoeHeel',
  'mdiShoePrint',
  'mdiShoeSneaker',
  'mdiShopping',
  'mdiShoppingMusic',
  'mdiShoppingOutline',
  'mdiShoppingSearch',
  'mdiShoppingSearchOutline',
  'mdiShore',
  'mdiShovel',
  'mdiShovelOff',
  'mdiShower',
  'mdiShowerHead',
  'mdiShredder',
  'mdiShuffle',
  'mdiShuffleDisabled',
  'mdiShuffleVariant',
  'mdiShuriken',
  'mdiSickle',
  'mdiSigma',
  'mdiSigmaLower',
  'mdiSignCaution',
  'mdiSignDirection',
  'mdiSignDirectionMinus',
  'mdiSignDirectionPlus',
  'mdiSignDirectionRemove',
  'mdiSignLanguage',
  'mdiSignLanguageOutline',
  'mdiSignPole',
  'mdiSignRealEstate',
  'mdiSignText',
  'mdiSignYield',
  'mdiSignal',
  'mdiSignal2g',
  'mdiSignal3g',
  'mdiSignal4g',
  'mdiSignal5g',
  'mdiSignalCellular1',
  'mdiSignalCellular2',
  'mdiSignalCellular3',
  'mdiSignalCellularOutline',
  'mdiSignalDistanceVariant',
  'mdiSignalHspa',
  'mdiSignalHspaPlus',
  'mdiSignalOff',
  'mdiSignalVariant',
  'mdiSignature',
  'mdiSignatureFreehand',
  'mdiSignatureImage',
  'mdiSignatureText',
  'mdiSilo',
  'mdiSiloOutline',
  'mdiSilverware',
  'mdiSilverwareClean',
  'mdiSilverwareFork',
  'mdiSilverwareForkKnife',
  'mdiSilverwareSpoon',
  'mdiSilverwareVariant',
  'mdiSim',
  'mdiSimAlert',
  'mdiSimAlertOutline',
  'mdiSimOff',
  'mdiSimOffOutline',
  'mdiSimOutline',
  'mdiSimpleIcons',
  'mdiSinaWeibo',
  'mdiSineWave',
  'mdiSitemap',
  'mdiSitemapOutline',
  'mdiSizeL',
  'mdiSizeM',
  'mdiSizeS',
  'mdiSizeXl',
  'mdiSizeXs',
  'mdiSizeXxl',
  'mdiSizeXxs',
  'mdiSizeXxxl',
  'mdiSkate',
  'mdiSkateOff',
  'mdiSkateboard',
  'mdiSkateboarding',
  'mdiSkewLess',
  'mdiSkewMore',
  'mdiSki',
  'mdiSkiCrossCountry',
  'mdiSkiWater',
  'mdiSkipBackward',
  'mdiSkipBackwardOutline',
  'mdiSkipForward',
  'mdiSkipForwardOutline',
  'mdiSkipNext',
  'mdiSkipNextCircle',
  'mdiSkipNextCircleOutline',
  'mdiSkipNextOutline',
  'mdiSkipPrevious',
  'mdiSkipPreviousCircle',
  'mdiSkipPreviousCircleOutline',
  'mdiSkipPreviousOutline',
  'mdiSkull',
  'mdiSkullCrossbones',
  'mdiSkullCrossbonesOutline',
  'mdiSkullOutline',
  'mdiSkullScan',
  'mdiSkullScanOutline',
  'mdiSkype',
  'mdiSkypeBusiness',
  'mdiSlack',
  'mdiSlashForward',
  'mdiSlashForwardBox',
  'mdiSledding',
  'mdiSleep',
  'mdiSleepOff',
  'mdiSlide',
  'mdiSlopeDownhill',
  'mdiSlopeUphill',
  'mdiSlotMachine',
  'mdiSlotMachineOutline',
  'mdiSmartCard',
  'mdiSmartCardOff',
  'mdiSmartCardOffOutline',
  'mdiSmartCardOutline',
  'mdiSmartCardReader',
  'mdiSmartCardReaderOutline',
  'mdiSmog',
  'mdiSmoke',
  'mdiSmokeDetector',
  'mdiSmokeDetectorAlert',
  'mdiSmokeDetectorAlertOutline',
  'mdiSmokeDetectorOff',
  'mdiSmokeDetectorOffOutline',
  'mdiSmokeDetectorOutline',
  'mdiSmokeDetectorVariant',
  'mdiSmokeDetectorVariantAlert',
  'mdiSmokeDetectorVariantOff',
  'mdiSmoking',
  'mdiSmokingOff',
  'mdiSmokingPipe',
  'mdiSmokingPipeOff',
  'mdiSnail',
  'mdiSnake',
  'mdiSnapchat',
  'mdiSnowboard',
  'mdiSnowflake',
  'mdiSnowflakeAlert',
  'mdiSnowflakeCheck',
  'mdiSnowflakeMelt',
  'mdiSnowflakeOff',
  'mdiSnowflakeThermometer',
  'mdiSnowflakeVariant',
  'mdiSnowman',
  'mdiSnowmobile',
  'mdiSnowshoeing',
  'mdiSoccer',
  'mdiSoccerField',
  'mdiSocialDistance2Meters',
  'mdiSocialDistance6Feet',
  'mdiSofa',
  'mdiSofaOutline',
  'mdiSofaSingle',
  'mdiSofaSingleOutline',
  'mdiSolarPanel',
  'mdiSolarPanelLarge',
  'mdiSolarPower',
  'mdiSolarPowerVariant',
  'mdiSolarPowerVariantOutline',
  'mdiSolderingIron',
  'mdiSolid',
  'mdiSonyPlaystation',
  'mdiSort',
  'mdiSortAlphabeticalAscending',
  'mdiSortAlphabeticalAscendingVariant',
  'mdiSortAlphabeticalDescending',
  'mdiSortAlphabeticalDescendingVariant',
  'mdiSortAlphabeticalVariant',
  'mdiSortAscending',
  'mdiSortBoolAscending',
  'mdiSortBoolAscendingVariant',
  'mdiSortBoolDescending',
  'mdiSortBoolDescendingVariant',
  'mdiSortCalendarAscending',
  'mdiSortCalendarDescending',
  'mdiSortClockAscending',
  'mdiSortClockAscendingOutline',
  'mdiSortClockDescending',
  'mdiSortClockDescendingOutline',
  'mdiSortDescending',
  'mdiSortNumericAscending',
  'mdiSortNumericAscendingVariant',
  'mdiSortNumericDescending',
  'mdiSortNumericDescendingVariant',
  'mdiSortNumericVariant',
  'mdiSortReverseVariant',
  'mdiSortVariant',
  'mdiSortVariantLock',
  'mdiSortVariantLockOpen',
  'mdiSortVariantOff',
  'mdiSortVariantRemove',
  'mdiSoundbar',
  'mdiSoundcloud',
  'mdiSourceBranch',
  'mdiSourceBranchCheck',
  'mdiSourceBranchMinus',
  'mdiSourceBranchPlus',
  'mdiSourceBranchRefresh',
  'mdiSourceBranchRemove',
  'mdiSourceBranchSync',
  'mdiSourceCommit',
  'mdiSourceCommitEnd',
  'mdiSourceCommitEndLocal',
  'mdiSourceCommitLocal',
  'mdiSourceCommitNextLocal',
  'mdiSourceCommitStart',
  'mdiSourceCommitStartNextLocal',
  'mdiSourceFork',
  'mdiSourceMerge',
  'mdiSourcePull',
  'mdiSourceRepository',
  'mdiSourceRepositoryMultiple',
  'mdiSoySauce',
  'mdiSoySauceOff',
  'mdiSpa',
  'mdiSpaOutline',
  'mdiSpaceInvaders',
  'mdiSpaceStation',
  'mdiSpade',
  'mdiSpeaker',
  'mdiSpeakerBluetooth',
  'mdiSpeakerMessage',
  'mdiSpeakerMultiple',
  'mdiSpeakerOff',
  'mdiSpeakerPause',
  'mdiSpeakerPlay',
  'mdiSpeakerStop',
  'mdiSpeakerWireless',
  'mdiSpear',
  'mdiSpeedometer',
  'mdiSpeedometerMedium',
  'mdiSpeedometerSlow',
  'mdiSpellcheck',
  'mdiSphere',
  'mdiSphereOff',
  'mdiSpider',
  'mdiSpiderOutline',
  'mdiSpiderThread',
  'mdiSpiderWeb',
  'mdiSpiritLevel',
  'mdiSpoonSugar',
  'mdiSpotify',
  'mdiSpotlight',
  'mdiSpotlightBeam',
  'mdiSpray',
  'mdiSprayBottle',
  'mdiSprinkler',
  'mdiSprinklerFire',
  'mdiSprinklerVariant',
  'mdiSprout',
  'mdiSproutOutline',
  'mdiSquare',
  'mdiSquareCircle',
  'mdiSquareCircleOutline',
  'mdiSquareEditOutline',
  'mdiSquareMedium',
  'mdiSquareMediumOutline',
  'mdiSquareOff',
  'mdiSquareOffOutline',
  'mdiSquareOpacity',
  'mdiSquareOutline',
  'mdiSquareRoot',
  'mdiSquareRootBox',
  'mdiSquareRounded',
  'mdiSquareRoundedBadge',
  'mdiSquareRoundedBadgeOutline',
  'mdiSquareRoundedOutline',
  'mdiSquareSmall',
  'mdiSquareWave',
  'mdiSqueegee',
  'mdiSsh',
  'mdiStackExchange',
  'mdiStackOverflow',
  'mdiStackpath',
  'mdiStadium',
  'mdiStadiumOutline',
  'mdiStadiumVariant',
  'mdiStairs',
  'mdiStairsBox',
  'mdiStairsDown',
  'mdiStairsUp',
  'mdiStamper',
  'mdiStandardDefinition',
  'mdiStar',
  'mdiStarBox',
  'mdiStarBoxMultiple',
  'mdiStarBoxMultipleOutline',
  'mdiStarBoxOutline',
  'mdiStarCheck',
  'mdiStarCheckOutline',
  'mdiStarCircle',
  'mdiStarCircleOutline',
  'mdiStarCog',
  'mdiStarCogOutline',
  'mdiStarCrescent',
  'mdiStarDavid',
  'mdiStarFace',
  'mdiStarFourPoints',
  'mdiStarFourPointsBox',
  'mdiStarFourPointsBoxOutline',
  'mdiStarFourPointsCircle',
  'mdiStarFourPointsCircleOutline',
  'mdiStarFourPointsOutline',
  'mdiStarFourPointsSmall',
  'mdiStarHalf',
  'mdiStarHalfFull',
  'mdiStarMinus',
  'mdiStarMinusOutline',
  'mdiStarOff',
  'mdiStarOffOutline',
  'mdiStarOutline',
  'mdiStarPlus',
  'mdiStarPlusOutline',
  'mdiStarRemove',
  'mdiStarRemoveOutline',
  'mdiStarSettings',
  'mdiStarSettingsOutline',
  'mdiStarShooting',
  'mdiStarShootingOutline',
  'mdiStarThreePoints',
  'mdiStarThreePointsOutline',
  'mdiStateMachine',
  'mdiSteam',
  'mdiSteering',
  'mdiSteeringOff',
  'mdiStepBackward',
  'mdiStepBackward2',
  'mdiStepForward',
  'mdiStepForward2',
  'mdiStethoscope',
  'mdiSticker',
  'mdiStickerAlert',
  'mdiStickerAlertOutline',
  'mdiStickerCheck',
  'mdiStickerCheckOutline',
  'mdiStickerCircleOutline',
  'mdiStickerEmoji',
  'mdiStickerMinus',
  'mdiStickerMinusOutline',
  'mdiStickerOutline',
  'mdiStickerPlus',
  'mdiStickerPlusOutline',
  'mdiStickerRemove',
  'mdiStickerRemoveOutline',
  'mdiStickerText',
  'mdiStickerTextOutline',
  'mdiStocking',
  'mdiStomach',
  'mdiStool',
  'mdiStoolOutline',
  'mdiStop',
  'mdiStopCircle',
  'mdiStopCircleOutline',
  'mdiStorageTank',
  'mdiStorageTankOutline',
  'mdiStore',
  'mdiStore24Hour',
  'mdiStoreAlert',
  'mdiStoreAlertOutline',
  'mdiStoreCheck',
  'mdiStoreCheckOutline',
  'mdiStoreClock',
  'mdiStoreClockOutline',
  'mdiStoreCog',
  'mdiStoreCogOutline',
  'mdiStoreEdit',
  'mdiStoreEditOutline',
  'mdiStoreMarker',
  'mdiStoreMarkerOutline',
  'mdiStoreMinus',
  'mdiStoreMinusOutline',
  'mdiStoreOff',
  'mdiStoreOffOutline',
  'mdiStoreOutline',
  'mdiStorePlus',
  'mdiStorePlusOutline',
  'mdiStoreRemove',
  'mdiStoreRemoveOutline',
  'mdiStoreSearch',
  'mdiStoreSearchOutline',
  'mdiStoreSettings',
  'mdiStoreSettingsOutline',
  'mdiStorefront',
  'mdiStorefrontCheck',
  'mdiStorefrontCheckOutline',
  'mdiStorefrontEdit',
  'mdiStorefrontEditOutline',
  'mdiStorefrontMinus',
  'mdiStorefrontMinusOutline',
  'mdiStorefrontOutline',
  'mdiStorefrontPlus',
  'mdiStorefrontPlusOutline',
  'mdiStorefrontRemove',
  'mdiStorefrontRemoveOutline',
  'mdiStove',
  'mdiStrategy',
  'mdiStretchToPage',
  'mdiStretchToPageOutline',
  'mdiStringLights',
  'mdiStringLightsOff',
  'mdiSubdirectoryArrowLeft',
  'mdiSubdirectoryArrowRight',
  'mdiSubmarine',
  'mdiSubtitles',
  'mdiSubtitlesOutline',
  'mdiSubway',
  'mdiSubwayAlertVariant',
  'mdiSubwayVariant',
  'mdiSummit',
  'mdiSunAngle',
  'mdiSunAngleOutline',
  'mdiSunClock',
  'mdiSunClockOutline',
  'mdiSunCompass',
  'mdiSunSnowflake',
  'mdiSunSnowflakeVariant',
  'mdiSunThermometer',
  'mdiSunThermometerOutline',
  'mdiSunWireless',
  'mdiSunWirelessOutline',
  'mdiSunglasses',
  'mdiSurfing',
  'mdiSurroundSound',
  'mdiSurroundSound20',
  'mdiSurroundSound21',
  'mdiSurroundSound31',
  'mdiSurroundSound51',
  'mdiSurroundSound512',
  'mdiSurroundSound71',
  'mdiSvg',
  'mdiSwapHorizontal',
  'mdiSwapHorizontalBold',
  'mdiSwapHorizontalCircle',
  'mdiSwapHorizontalCircleOutline',
  'mdiSwapHorizontalHidden',
  'mdiSwapHorizontalVariant',
  'mdiSwapVertical',
  'mdiSwapVerticalBold',
  'mdiSwapVerticalCircle',
  'mdiSwapVerticalCircleOutline',
  'mdiSwapVerticalVariant',
  'mdiSwim',
  'mdiSwitch',
  'mdiSword',
  'mdiSwordCross',
  'mdiSyllabaryHangul',
  'mdiSyllabaryHiragana',
  'mdiSyllabaryKatakana',
  'mdiSyllabaryKatakanaHalfwidth',
  'mdiSymbol',
  'mdiSymfony',
  'mdiSynagogue',
  'mdiSynagogueOutline',
  'mdiSync',
  'mdiSyncAlert',
  'mdiSyncCircle',
  'mdiSyncOff',
  'mdiTab',
  'mdiTabMinus',
  'mdiTabPlus',
  'mdiTabRemove',
  'mdiTabSearch',
  'mdiTabUnselected',
  'mdiTable',
  'mdiTableAccount',
  'mdiTableAlert',
  'mdiTableArrowDown',
  'mdiTableArrowLeft',
  'mdiTableArrowRight',
  'mdiTableArrowUp',
  'mdiTableBorder',
  'mdiTableCancel',
  'mdiTableChair',
  'mdiTableCheck',
  'mdiTableClock',
  'mdiTableCog',
  'mdiTableColumn',
  'mdiTableColumnPlusAfter',
  'mdiTableColumnPlusBefore',
  'mdiTableColumnRemove',
  'mdiTableColumnWidth',
  'mdiTableEdit',
  'mdiTableEye',
  'mdiTableEyeOff',
  'mdiTableFilter',
  'mdiTableFurniture',
  'mdiTableHeadersEye',
  'mdiTableHeadersEyeOff',
  'mdiTableHeart',
  'mdiTableKey',
  'mdiTableLarge',
  'mdiTableLargePlus',
  'mdiTableLargeRemove',
  'mdiTableLock',
  'mdiTableMergeCells',
  'mdiTableMinus',
  'mdiTableMultiple',
  'mdiTableNetwork',
  'mdiTableOfContents',
  'mdiTableOff',
  'mdiTablePicnic',
  'mdiTablePivot',
  'mdiTablePlus',
  'mdiTableQuestion',
  'mdiTableRefresh',
  'mdiTableRemove',
  'mdiTableRow',
  'mdiTableRowHeight',
  'mdiTableRowPlusAfter',
  'mdiTableRowPlusBefore',
  'mdiTableRowRemove',
  'mdiTableSearch',
  'mdiTableSettings',
  'mdiTableSplitCell',
  'mdiTableStar',
  'mdiTableSync',
  'mdiTableTennis',
  'mdiTablet',
  'mdiTabletCellphone',
  'mdiTabletDashboard',
  'mdiTaco',
  'mdiTag',
  'mdiTagArrowDown',
  'mdiTagArrowDownOutline',
  'mdiTagArrowLeft',
  'mdiTagArrowLeftOutline',
  'mdiTagArrowRight',
  'mdiTagArrowRightOutline',
  'mdiTagArrowUp',
  'mdiTagArrowUpOutline',
  'mdiTagCheck',
  'mdiTagCheckOutline',
  'mdiTagEdit',
  'mdiTagEditOutline',
  'mdiTagFaces',
  'mdiTagHeart',
  'mdiTagHeartOutline',
  'mdiTagHidden',
  'mdiTagMinus',
  'mdiTagMinusOutline',
  'mdiTagMultiple',
  'mdiTagMultipleOutline',
  'mdiTagOff',
  'mdiTagOffOutline',
  'mdiTagOutline',
  'mdiTagPlus',
  'mdiTagPlusOutline',
  'mdiTagRemove',
  'mdiTagRemoveOutline',
  'mdiTagSearch',
  'mdiTagSearchOutline',
  'mdiTagText',
  'mdiTagTextOutline',
  'mdiTailwind',
  'mdiTallyMark1',
  'mdiTallyMark2',
  'mdiTallyMark3',
  'mdiTallyMark4',
  'mdiTallyMark5',
  'mdiTangram',
  'mdiTank',
  'mdiTankerTruck',
  'mdiTapeDrive',
  'mdiTapeMeasure',
  'mdiTarget',
  'mdiTargetAccount',
  'mdiTargetVariant',
  'mdiTaxi',
  'mdiTea',
  'mdiTeaOutline',
  'mdiTeamviewer',
  'mdiTeddyBear',
  'mdiTelescope',
  'mdiTelevision',
  'mdiTelevisionAmbientLight',
  'mdiTelevisionBox',
  'mdiTelevisionClassic',
  'mdiTelevisionClassicOff',
  'mdiTelevisionGuide',
  'mdiTelevisionOff',
  'mdiTelevisionPause',
  'mdiTelevisionPlay',
  'mdiTelevisionShimmer',
  'mdiTelevisionSpeaker',
  'mdiTelevisionSpeakerOff',
  'mdiTelevisionStop',
  'mdiTemperatureCelsius',
  'mdiTemperatureFahrenheit',
  'mdiTemperatureKelvin',
  'mdiTempleBuddhist',
  'mdiTempleBuddhistOutline',
  'mdiTempleHindu',
  'mdiTempleHinduOutline',
  'mdiTennis',
  'mdiTennisBall',
  'mdiTennisBallOutline',
  'mdiTent',
  'mdiTerraform',
  'mdiTerrain',
  'mdiTestTube',
  'mdiTestTubeEmpty',
  'mdiTestTubeOff',
  'mdiText',
  'mdiTextAccount',
  'mdiTextBox',
  'mdiTextBoxCheck',
  'mdiTextBoxCheckOutline',
  'mdiTextBoxEdit',
  'mdiTextBoxEditOutline',
  'mdiTextBoxMinus',
  'mdiTextBoxMinusOutline',
  'mdiTextBoxMultiple',
  'mdiTextBoxMultipleOutline',
  'mdiTextBoxOutline',
  'mdiTextBoxPlus',
  'mdiTextBoxPlusOutline',
  'mdiTextBoxRemove',
  'mdiTextBoxRemoveOutline',
  'mdiTextBoxSearch',
  'mdiTextBoxSearchOutline',
  'mdiTextLong',
  'mdiTextRecognition',
  'mdiTextSearch',
  'mdiTextSearchVariant',
  'mdiTextShadow',
  'mdiTextShort',
  'mdiTexture',
  'mdiTextureBox',
  'mdiTheater',
  'mdiThemeLightDark',
  'mdiThermometer',
  'mdiThermometerAlert',
  'mdiThermometerAuto',
  'mdiThermometerBluetooth',
  'mdiThermometerCheck',
  'mdiThermometerChevronDown',
  'mdiThermometerChevronUp',
  'mdiThermometerHigh',
  'mdiThermometerLines',
  'mdiThermometerLow',
  'mdiThermometerMinus',
  'mdiThermometerOff',
  'mdiThermometerPlus',
  'mdiThermometerProbe',
  'mdiThermometerProbeOff',
  'mdiThermometerWater',
  'mdiThermostat',
  'mdiThermostatAuto',
  'mdiThermostatBox',
  'mdiThermostatBoxAuto',
  'mdiThermostatCog',
  'mdiThoughtBubble',
  'mdiThoughtBubbleOutline',
  'mdiThumbDown',
  'mdiThumbDownOutline',
  'mdiThumbUp',
  'mdiThumbUpOutline',
  'mdiThumbsUpDown',
  'mdiThumbsUpDownOutline',
  'mdiTicket',
  'mdiTicketAccount',
  'mdiTicketConfirmation',
  'mdiTicketConfirmationOutline',
  'mdiTicketOutline',
  'mdiTicketPercent',
  'mdiTicketPercentOutline',
  'mdiTie',
  'mdiTilde',
  'mdiTildeOff',
  'mdiTimelapse',
  'mdiTimeline',
  'mdiTimelineAlert',
  'mdiTimelineAlertOutline',
  'mdiTimelineCheck',
  'mdiTimelineCheckOutline',
  'mdiTimelineClock',
  'mdiTimelineClockOutline',
  'mdiTimelineMinus',
  'mdiTimelineMinusOutline',
  'mdiTimelineOutline',
  'mdiTimelinePlus',
  'mdiTimelinePlusOutline',
  'mdiTimelineQuestion',
  'mdiTimelineQuestionOutline',
  'mdiTimelineRemove',
  'mdiTimelineRemoveOutline',
  'mdiTimelineText',
  'mdiTimelineTextOutline',
  'mdiTimer',
  'mdiTimer10',
  'mdiTimer3',
  'mdiTimerAlert',
  'mdiTimerAlertOutline',
  'mdiTimerCancel',
  'mdiTimerCancelOutline',
  'mdiTimerCheck',
  'mdiTimerCheckOutline',
  'mdiTimerCog',
  'mdiTimerCogOutline',
  'mdiTimerEdit',
  'mdiTimerEditOutline',
  'mdiTimerLock',
  'mdiTimerLockOpen',
  'mdiTimerLockOpenOutline',
  'mdiTimerLockOutline',
  'mdiTimerMarker',
  'mdiTimerMarkerOutline',
  'mdiTimerMinus',
  'mdiTimerMinusOutline',
  'mdiTimerMusic',
  'mdiTimerMusicOutline',
  'mdiTimerOff',
  'mdiTimerOffOutline',
  'mdiTimerOutline',
  'mdiTimerPause',
  'mdiTimerPauseOutline',
  'mdiTimerPlay',
  'mdiTimerPlayOutline',
  'mdiTimerPlus',
  'mdiTimerPlusOutline',
  'mdiTimerRefresh',
  'mdiTimerRefreshOutline',
  'mdiTimerRemove',
  'mdiTimerRemoveOutline',
  'mdiTimerSand',
  'mdiTimerSandComplete',
  'mdiTimerSandEmpty',
  'mdiTimerSandFull',
  'mdiTimerSandPaused',
  'mdiTimerSettings',
  'mdiTimerSettingsOutline',
  'mdiTimerStar',
  'mdiTimerStarOutline',
  'mdiTimerStop',
  'mdiTimerStopOutline',
  'mdiTimerSync',
  'mdiTimerSyncOutline',
  'mdiTimetable',
  'mdiTire',
  'mdiToaster',
  'mdiToasterOff',
  'mdiToasterOven',
  'mdiToggleSwitch',
  'mdiToggleSwitchOff',
  'mdiToggleSwitchOffOutline',
  'mdiToggleSwitchOutline',
  'mdiToggleSwitchVariant',
  'mdiToggleSwitchVariantOff',
  'mdiToilet',
  'mdiToolbox',
  'mdiToolboxOutline',
  'mdiTools',
  'mdiTooltip',
  'mdiTooltipAccount',
  'mdiTooltipCellphone',
  'mdiTooltipCheck',
  'mdiTooltipCheckOutline',
  'mdiTooltipEdit',
  'mdiTooltipEditOutline',
  'mdiTooltipImage',
  'mdiTooltipImageOutline',
  'mdiTooltipMinus',
  'mdiTooltipMinusOutline',
  'mdiTooltipOutline',
  'mdiTooltipPlus',
  'mdiTooltipPlusOutline',
  'mdiTooltipQuestion',
  'mdiTooltipQuestionOutline',
  'mdiTooltipRemove',
  'mdiTooltipRemoveOutline',
  'mdiTooltipText',
  'mdiTooltipTextOutline',
  'mdiTooth',
  'mdiToothOutline',
  'mdiToothbrush',
  'mdiToothbrushElectric',
  'mdiToothbrushPaste',
  'mdiTorch',
  'mdiTortoise',
  'mdiToslink',
  'mdiTouchTextOutline',
  'mdiTournament',
  'mdiTowTruck',
  'mdiTowerBeach',
  'mdiTowerFire',
  'mdiTownHall',
  'mdiToyBrick',
  'mdiToyBrickMarker',
  'mdiToyBrickMarkerOutline',
  'mdiToyBrickMinus',
  'mdiToyBrickMinusOutline',
  'mdiToyBrickOutline',
  'mdiToyBrickPlus',
  'mdiToyBrickPlusOutline',
  'mdiToyBrickRemove',
  'mdiToyBrickRemoveOutline',
  'mdiToyBrickSearch',
  'mdiToyBrickSearchOutline',
  'mdiTrackLight',
  'mdiTrackLightOff',
  'mdiTrackpad',
  'mdiTrackpadLock',
  'mdiTractor',
  'mdiTractorVariant',
  'mdiTrademark',
  'mdiTrafficCone',
  'mdiTrafficLight',
  'mdiTrafficLightOutline',
  'mdiTrain',
  'mdiTrainBus',
  'mdiTrainCar',
  'mdiTrainCarAutorack',
  'mdiTrainCarBox',
  'mdiTrainCarBoxFull',
  'mdiTrainCarBoxOpen',
  'mdiTrainCarCaboose',
  'mdiTrainCarCenterbeam',
  'mdiTrainCarCenterbeamFull',
  'mdiTrainCarContainer',
  'mdiTrainCarFlatbed',
  'mdiTrainCarFlatbedCar',
  'mdiTrainCarFlatbedTank',
  'mdiTrainCarGondola',
  'mdiTrainCarGondolaFull',
  'mdiTrainCarHopper',
  'mdiTrainCarHopperCovered',
  'mdiTrainCarHopperFull',
  'mdiTrainCarIntermodal',
  'mdiTrainCarPassenger',
  'mdiTrainCarPassengerDoor',
  'mdiTrainCarPassengerDoorOpen',
  'mdiTrainCarPassengerVariant',
  'mdiTrainCarTank',
  'mdiTrainVariant',
  'mdiTram',
  'mdiTramSide',
  'mdiTranscribe',
  'mdiTranscribeClose',
  'mdiTransfer',
  'mdiTransferDown',
  'mdiTransferLeft',
  'mdiTransferRight',
  'mdiTransferUp',
  'mdiTransitConnection',
  'mdiTransitConnectionHorizontal',
  'mdiTransitConnectionVariant',
  'mdiTransitDetour',
  'mdiTransitSkip',
  'mdiTransitTransfer',
  'mdiTransition',
  'mdiTransitionMasked',
  'mdiTranslate',
  'mdiTranslateOff',
  'mdiTranslateVariant',
  'mdiTransmissionTower',
  'mdiTransmissionTowerExport',
  'mdiTransmissionTowerImport',
  'mdiTransmissionTowerOff',
  'mdiTrashCan',
  'mdiTrashCanOutline',
  'mdiTray',
  'mdiTrayAlert',
  'mdiTrayArrowDown',
  'mdiTrayArrowUp',
  'mdiTrayFull',
  'mdiTrayMinus',
  'mdiTrayPlus',
  'mdiTrayRemove',
  'mdiTreasureChest',
  'mdiTreasureChestOutline',
  'mdiTree',
  'mdiTreeOutline',
  'mdiTrello',
  'mdiTrendingDown',
  'mdiTrendingNeutral',
  'mdiTrendingUp',
  'mdiTriangle',
  'mdiTriangleDown',
  'mdiTriangleDownOutline',
  'mdiTriangleOutline',
  'mdiTriangleSmallDown',
  'mdiTriangleSmallUp',
  'mdiTriangleWave',
  'mdiTriforce',
  'mdiTrophy',
  'mdiTrophyAward',
  'mdiTrophyBroken',
  'mdiTrophyOutline',
  'mdiTrophyVariant',
  'mdiTrophyVariantOutline',
  'mdiTruck',
  'mdiTruckAlert',
  'mdiTruckAlertOutline',
  'mdiTruckCargoContainer',
  'mdiTruckCheck',
  'mdiTruckCheckOutline',
  'mdiTruckDelivery',
  'mdiTruckDeliveryOutline',
  'mdiTruckFast',
  'mdiTruckFastOutline',
  'mdiTruckFlatbed',
  'mdiTruckMinus',
  'mdiTruckMinusOutline',
  'mdiTruckOffRoad',
  'mdiTruckOffRoadOff',
  'mdiTruckOutline',
  'mdiTruckPlus',
  'mdiTruckPlusOutline',
  'mdiTruckRemove',
  'mdiTruckRemoveOutline',
  'mdiTruckSnowflake',
  'mdiTruckTrailer',
  'mdiTrumpet',
  'mdiTshirtCrew',
  'mdiTshirtCrewOutline',
  'mdiTshirtV',
  'mdiTshirtVOutline',
  'mdiTsunami',
  'mdiTumbleDryer',
  'mdiTumbleDryerAlert',
  'mdiTumbleDryerOff',
  'mdiTune',
  'mdiTuneVariant',
  'mdiTuneVertical',
  'mdiTuneVerticalVariant',
  'mdiTunnel',
  'mdiTunnelOutline',
  'mdiTurbine',
  'mdiTurkey',
  'mdiTurnstile',
  'mdiTurnstileOutline',
  'mdiTurtle',
  'mdiTwitch',
  'mdiTwitter',
  'mdiTwoFactorAuthentication',
  'mdiTypewriter',
  'mdiUbisoft',
  'mdiUbuntu',
  'mdiUfo',
  'mdiUfoOutline',
  'mdiUltraHighDefinition',
  'mdiUmbraco',
  'mdiUmbrella',
  'mdiUmbrellaBeach',
  'mdiUmbrellaBeachOutline',
  'mdiUmbrellaClosed',
  'mdiUmbrellaClosedOutline',
  'mdiUmbrellaClosedVariant',
  'mdiUmbrellaOutline',
  'mdiUnderwearOutline',
  'mdiUndo',
  'mdiUndoVariant',
  'mdiUnfoldLessHorizontal',
  'mdiUnfoldLessVertical',
  'mdiUnfoldMoreHorizontal',
  'mdiUnfoldMoreVertical',
  'mdiUngroup',
  'mdiUnicode',
  'mdiUnicorn',
  'mdiUnicornVariant',
  'mdiUnicycle',
  'mdiUnity',
  'mdiUnreal',
  'mdiUpdate',
  'mdiUpload',
  'mdiUploadBox',
  'mdiUploadBoxOutline',
  'mdiUploadCircle',
  'mdiUploadCircleOutline',
  'mdiUploadLock',
  'mdiUploadLockOutline',
  'mdiUploadMultiple',
  'mdiUploadMultipleOutline',
  'mdiUploadNetwork',
  'mdiUploadNetworkOutline',
  'mdiUploadOff',
  'mdiUploadOffOutline',
  'mdiUploadOutline',
  'mdiUsb',
  'mdiUsbCPort',
  'mdiUsbFlashDrive',
  'mdiUsbFlashDriveOutline',
  'mdiUsbPort',
  'mdiVacuum',
  'mdiVacuumOutline',
  'mdiValve',
  'mdiValveClosed',
  'mdiValveOpen',
  'mdiVanPassenger',
  'mdiVanUtility',
  'mdiVanish',
  'mdiVanishQuarter',
  'mdiVanityLight',
  'mdiVariable',
  'mdiVariableBox',
  'mdiVectorArrangeAbove',
  'mdiVectorArrangeBelow',
  'mdiVectorBezier',
  'mdiVectorCircle',
  'mdiVectorCircleVariant',
  'mdiVectorCombine',
  'mdiVectorCurve',
  'mdiVectorDifference',
  'mdiVectorDifferenceAb',
  'mdiVectorDifferenceBa',
  'mdiVectorEllipse',
  'mdiVectorIntersection',
  'mdiVectorLine',
  'mdiVectorLink',
  'mdiVectorPoint',
  'mdiVectorPointEdit',
  'mdiVectorPointMinus',
  'mdiVectorPointPlus',
  'mdiVectorPointSelect',
  'mdiVectorPolygon',
  'mdiVectorPolygonVariant',
  'mdiVectorPolyline',
  'mdiVectorPolylineEdit',
  'mdiVectorPolylineMinus',
  'mdiVectorPolylinePlus',
  'mdiVectorPolylineRemove',
  'mdiVectorRadius',
  'mdiVectorRectangle',
  'mdiVectorSelection',
  'mdiVectorSquare',
  'mdiVectorSquareClose',
  'mdiVectorSquareEdit',
  'mdiVectorSquareMinus',
  'mdiVectorSquareOpen',
  'mdiVectorSquarePlus',
  'mdiVectorSquareRemove',
  'mdiVectorTriangle',
  'mdiVectorUnion',
  'mdiVhs',
  'mdiVibrate',
  'mdiVibrateOff',
  'mdiVideo',
  'mdiVideo2d',
  'mdiVideo3d',
  'mdiVideo3dOff',
  'mdiVideo3dVariant',
  'mdiVideo4kBox',
  'mdiVideoAccount',
  'mdiVideoBox',
  'mdiVideoBoxOff',
  'mdiVideoCheck',
  'mdiVideoCheckOutline',
  'mdiVideoHighDefinition',
  'mdiVideoImage',
  'mdiVideoInputAntenna',
  'mdiVideoInputComponent',
  'mdiVideoInputHdmi',
  'mdiVideoInputScart',
  'mdiVideoInputSvideo',
  'mdiVideoMarker',
  'mdiVideoMarkerOutline',
  'mdiVideoMinus',
  'mdiVideoMinusOutline',
  'mdiVideoOff',
  'mdiVideoOffOutline',
  'mdiVideoOutline',
  'mdiVideoPlus',
  'mdiVideoPlusOutline',
  'mdiVideoStabilization',
  'mdiVideoStandardDefinition',
  'mdiVideoSwitch',
  'mdiVideoSwitchOutline',
  'mdiVideoVintage',
  'mdiVideoWireless',
  'mdiVideoWirelessOutline',
  'mdiViewAgenda',
  'mdiViewAgendaOutline',
  'mdiViewArray',
  'mdiViewArrayOutline',
  'mdiViewCarousel',
  'mdiViewCarouselOutline',
  'mdiViewColumn',
  'mdiViewColumnOutline',
  'mdiViewComfy',
  'mdiViewComfyOutline',
  'mdiViewCompact',
  'mdiViewCompactOutline',
  'mdiViewDashboard',
  'mdiViewDashboardEdit',
  'mdiViewDashboardEditOutline',
  'mdiViewDashboardOutline',
  'mdiViewDashboardVariant',
  'mdiViewDashboardVariantOutline',
  'mdiViewDay',
  'mdiViewDayOutline',
  'mdiViewGallery',
  'mdiViewGalleryOutline',
  'mdiViewGrid',
  'mdiViewGridCompact',
  'mdiViewGridOutline',
  'mdiViewGridPlus',
  'mdiViewGridPlusOutline',
  'mdiViewHeadline',
  'mdiViewList',
  'mdiViewListOutline',
  'mdiViewModule',
  'mdiViewModuleOutline',
  'mdiViewParallel',
  'mdiViewParallelOutline',
  'mdiViewQuilt',
  'mdiViewQuiltOutline',
  'mdiViewSequential',
  'mdiViewSequentialOutline',
  'mdiViewSplitHorizontal',
  'mdiViewSplitVertical',
  'mdiViewStream',
  'mdiViewStreamOutline',
  'mdiViewWeek',
  'mdiViewWeekOutline',
  'mdiVimeo',
  'mdiViolin',
  'mdiVirtualReality',
  'mdiVirus',
  'mdiVirusOff',
  'mdiVirusOffOutline',
  'mdiVirusOutline',
  'mdiVlc',
  'mdiVoicemail',
  'mdiVolcano',
  'mdiVolcanoOutline',
  'mdiVolleyball',
  'mdiVolumeEqual',
  'mdiVolumeHigh',
  'mdiVolumeLow',
  'mdiVolumeMedium',
  'mdiVolumeMinus',
  'mdiVolumeMute',
  'mdiVolumeOff',
  'mdiVolumePlus',
  'mdiVolumeSource',
  'mdiVolumeVariantOff',
  'mdiVolumeVibrate',
  'mdiVote',
  'mdiVoteOutline',
  'mdiVpn',
  'mdiVuejs',
  'mdiVuetify',
  'mdiWalk',
  'mdiWall',
  'mdiWallFire',
  'mdiWallSconce',
  'mdiWallSconceFlat',
  'mdiWallSconceFlatOutline',
  'mdiWallSconceFlatVariant',
  'mdiWallSconceFlatVariantOutline',
  'mdiWallSconceOutline',
  'mdiWallSconceRound',
  'mdiWallSconceRoundOutline',
  'mdiWallSconceRoundVariant',
  'mdiWallSconceRoundVariantOutline',
  'mdiWallet',
  'mdiWalletBifold',
  'mdiWalletBifoldOutline',
  'mdiWalletGiftcard',
  'mdiWalletMembership',
  'mdiWalletOutline',
  'mdiWalletPlus',
  'mdiWalletPlusOutline',
  'mdiWalletTravel',
  'mdiWallpaper',
  'mdiWan',
  'mdiWardrobe',
  'mdiWardrobeOutline',
  'mdiWarehouse',
  'mdiWashingMachine',
  'mdiWashingMachineAlert',
  'mdiWashingMachineOff',
  'mdiWatch',
  'mdiWatchExport',
  'mdiWatchExportVariant',
  'mdiWatchImport',
  'mdiWatchImportVariant',
  'mdiWatchVariant',
  'mdiWatchVibrate',
  'mdiWatchVibrateOff',
  'mdiWater',
  'mdiWaterAlert',
  'mdiWaterAlertOutline',
  'mdiWaterBoiler',
  'mdiWaterBoilerAlert',
  'mdiWaterBoilerAuto',
  'mdiWaterBoilerOff',
  'mdiWaterCheck',
  'mdiWaterCheckOutline',
  'mdiWaterCircle',
  'mdiWaterMinus',
  'mdiWaterMinusOutline',
  'mdiWaterOff',
  'mdiWaterOffOutline',
  'mdiWaterOpacity',
  'mdiWaterOutline',
  'mdiWaterPercent',
  'mdiWaterPercentAlert',
  'mdiWaterPlus',
  'mdiWaterPlusOutline',
  'mdiWaterPolo',
  'mdiWaterPump',
  'mdiWaterPumpOff',
  'mdiWaterRemove',
  'mdiWaterRemoveOutline',
  'mdiWaterSync',
  'mdiWaterThermometer',
  'mdiWaterThermometerOutline',
  'mdiWaterWell',
  'mdiWaterWellOutline',
  'mdiWaterfall',
  'mdiWateringCan',
  'mdiWateringCanOutline',
  'mdiWatermark',
  'mdiWave',
  'mdiWaveArrowDown',
  'mdiWaveArrowUp',
  'mdiWaveUndercurrent',
  'mdiWaveform',
  'mdiWaves',
  'mdiWavesArrowLeft',
  'mdiWavesArrowRight',
  'mdiWavesArrowUp',
  'mdiWaze',
  'mdiWeatherCloudy',
  'mdiWeatherCloudyAlert',
  'mdiWeatherCloudyArrowRight',
  'mdiWeatherCloudyClock',
  'mdiWeatherDust',
  'mdiWeatherFog',
  'mdiWeatherHail',
  'mdiWeatherHazy',
  'mdiWeatherHurricane',
  'mdiWeatherHurricaneOutline',
  'mdiWeatherLightning',
  'mdiWeatherLightningRainy',
  'mdiWeatherMoonset',
  'mdiWeatherMoonsetDown',
  'mdiWeatherMoonsetUp',
  'mdiWeatherNight',
  'mdiWeatherNightPartlyCloudy',
  'mdiWeatherPartlyCloudy',
  'mdiWeatherPartlyLightning',
  'mdiWeatherPartlyRainy',
  'mdiWeatherPartlySnowy',
  'mdiWeatherPartlySnowyRainy',
  'mdiWeatherPouring',
  'mdiWeatherRainy',
  'mdiWeatherSnowy',
  'mdiWeatherSnowyHeavy',
  'mdiWeatherSnowyRainy',
  'mdiWeatherSunny',
  'mdiWeatherSunnyAlert',
  'mdiWeatherSunnyOff',
  'mdiWeatherSunset',
  'mdiWeatherSunsetDown',
  'mdiWeatherSunsetUp',
  'mdiWeatherTornado',
  'mdiWeatherWindy',
  'mdiWeatherWindyVariant',
  'mdiWeb',
  'mdiWebBox',
  'mdiWebCancel',
  'mdiWebCheck',
  'mdiWebClock',
  'mdiWebMinus',
  'mdiWebOff',
  'mdiWebPlus',
  'mdiWebRefresh',
  'mdiWebRemove',
  'mdiWebSync',
  'mdiWebcam',
  'mdiWebcamOff',
  'mdiWebhook',
  'mdiWebpack',
  'mdiWebrtc',
  'mdiWechat',
  'mdiWeight',
  'mdiWeightGram',
  'mdiWeightKilogram',
  'mdiWeightLifter',
  'mdiWeightPound',
  'mdiWhatsapp',
  'mdiWheelBarrow',
  'mdiWheelchair',
  'mdiWheelchairAccessibility',
  'mdiWhistle',
  'mdiWhistleOutline',
  'mdiWhiteBalanceAuto',
  'mdiWhiteBalanceIncandescent',
  'mdiWhiteBalanceIridescent',
  'mdiWhiteBalanceSunny',
  'mdiWidgets',
  'mdiWidgetsOutline',
  'mdiWifi',
  'mdiWifiAlert',
  'mdiWifiArrowDown',
  'mdiWifiArrowLeft',
  'mdiWifiArrowLeftRight',
  'mdiWifiArrowRight',
  'mdiWifiArrowUp',
  'mdiWifiArrowUpDown',
  'mdiWifiCancel',
  'mdiWifiCheck',
  'mdiWifiCog',
  'mdiWifiLock',
  'mdiWifiLockOpen',
  'mdiWifiMarker',
  'mdiWifiMinus',
  'mdiWifiOff',
  'mdiWifiPlus',
  'mdiWifiRefresh',
  'mdiWifiRemove',
  'mdiWifiSettings',
  'mdiWifiStar',
  'mdiWifiStrength1',
  'mdiWifiStrength1Alert',
  'mdiWifiStrength1Lock',
  'mdiWifiStrength1LockOpen',
  'mdiWifiStrength2',
  'mdiWifiStrength2Alert',
  'mdiWifiStrength2Lock',
  'mdiWifiStrength2LockOpen',
  'mdiWifiStrength3',
  'mdiWifiStrength3Alert',
  'mdiWifiStrength3Lock',
  'mdiWifiStrength3LockOpen',
  'mdiWifiStrength4',
  'mdiWifiStrength4Alert',
  'mdiWifiStrength4Lock',
  'mdiWifiStrength4LockOpen',
  'mdiWifiStrengthAlertOutline',
  'mdiWifiStrengthLockOpenOutline',
  'mdiWifiStrengthLockOutline',
  'mdiWifiStrengthOff',
  'mdiWifiStrengthOffOutline',
  'mdiWifiStrengthOutline',
  'mdiWifiSync',
  'mdiWikipedia',
  'mdiWindPower',
  'mdiWindPowerOutline',
  'mdiWindTurbine',
  'mdiWindTurbineAlert',
  'mdiWindTurbineCheck',
  'mdiWindowClose',
  'mdiWindowClosed',
  'mdiWindowClosedVariant',
  'mdiWindowMaximize',
  'mdiWindowMinimize',
  'mdiWindowOpen',
  'mdiWindowOpenVariant',
  'mdiWindowRestore',
  'mdiWindowShutter',
  'mdiWindowShutterAlert',
  'mdiWindowShutterAuto',
  'mdiWindowShutterCog',
  'mdiWindowShutterOpen',
  'mdiWindowShutterSettings',
  'mdiWindsock',
  'mdiWiper',
  'mdiWiperWash',
  'mdiWiperWashAlert',
  'mdiWizardHat',
  'mdiWordpress',
  'mdiWrap',
  'mdiWrapDisabled',
  'mdiWrench',
  'mdiWrenchCheck',
  'mdiWrenchCheckOutline',
  'mdiWrenchClock',
  'mdiWrenchClockOutline',
  'mdiWrenchCog',
  'mdiWrenchCogOutline',
  'mdiWrenchOutline',
  'mdiXamarin',
  'mdiXml',
  'mdiXmpp',
  'mdiYahoo',
  'mdiYeast',
  'mdiYinYang',
  'mdiYoga',
  'mdiYoutube',
  'mdiYoutubeGaming',
  'mdiYoutubeStudio',
  'mdiYoutubeSubscription',
  'mdiYoutubeTv',
  'mdiYurt',
  'mdiZWave',
  'mdiZend',
  'mdiZigbee',
  'mdiZipBox',
  'mdiZipBoxOutline',
  'mdiZipDisk',
  'mdiZodiacAquarius',
  'mdiZodiacAries',
  'mdiZodiacCancer',
  'mdiZodiacCapricorn',
  'mdiZodiacGemini',
  'mdiZodiacLeo',
  'mdiZodiacLibra',
  'mdiZodiacPisces',
  'mdiZodiacSagittarius',
  'mdiZodiacScorpio',
  'mdiZodiacTaurus',
  'mdiZodiacVirgo',
]
